/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Avallon API
 * OpenAPI spec version: 1.0.0
 */

import type { ListVoiceAgentsEnvelope,
ErrorResponse,
ListVoiceAgentsParams,
CreateVoiceAgentEnvelope,
CreateVoiceAgentBody,
GetVoiceAgentEnvelope,
UpdateVoiceAgentEnvelope,
UpdateVoiceAgentBody,
DeleteVoiceAgentEnvelope,
ListVoiceAgentVersionsEnvelope,
ListVoiceAgentVersionsParams,
GetVoiceAgentVersionEnvelope,
PromoteVoiceAgentVersionEnvelope,
PromoteVoiceAgentVersionBody,
GetVoiceAgentVersionChangeSummaryEnvelope,
GetVoiceAgentPlaceholdersEnvelope,
GetVoiceAgentPromptEnvelope,
GetVoiceAgentPromptParams,
UpdateVoiceAgentPromptEnvelope,
UpdateVoiceAgentPromptBody,
UpdateVoiceAgentModelsEnvelope,
UpdateVoiceAgentModelsBody,
UpdateCallControlsEnvelope,
UpdateCallControlsBody,
ScheduleJobEnvelope,
ScheduleJobBody,
ListJobsEnvelope,
ListJobsParams,
CancelJobEnvelope,
ListApiKeysEnvelope,
ListApiKeysParams,
CreateApiKeyEnvelope,
CreateApiKeyBody,
RevokeApiKeyEnvelope,
UpdateApiKeyEnvelope,
UpdateApiKeyBody,
CreateArtifactEnvelope,
CreateArtifactBody,
ListArtifactsEnvelope,
ListArtifactsParams,
GetArtifactEnvelope,
DeleteArtifactEnvelope,
GetArtifactMetadataKeysEnvelope,
GetArtifactMetadataKeysParams,
GetArtifactStatusSummaryEnvelope,
GetArtifactStatusSummaryParams,
GetArtifactUploadUrlEnvelope,
GetArtifactUploadUrlBody,
UpdateArtifactMetadataEnvelope,
UpdateArtifactMetadataBody,
SignUpEnvelope,
SignUpBody,
SignInEnvelope,
SignInBody,
RequestPasswordResetEnvelope,
RequestPasswordResetBody,
ResetPasswordEnvelope,
ResetPasswordBody,
RefreshTokenEnvelope,
RefreshTokenBody,
GetOAuthUrlEnvelope,
GetOAuthUrlParams,
GetSessionTokenEnvelope,
GetSessionTokenBody,
PartnerJwks,
PartnerLaunchEnvelope,
PartnerLaunchParams,
ListCallsEnvelope,
ListCallsParams,
GetCallEnvelope,
GetCallParams,
GetCallEvaluationEnvelope,
GetCallAnalyticsEnvelope,
GetCallAnalyticsParams,
GetAnalyticsTimeSeriesEnvelope,
GetAnalyticsTimeSeriesParams,
CreateCallFeedbackEnvelope,
CreateFeedbackRequest,
ListCallFeedbackEnvelope,
ListCallFeedbackParams,
DeleteCallFeedbackEnvelope,
CheckInboxAvailabilityEnvelope,
CheckInboxAvailabilityParams,
CreateInboxEnvelope,
CreateInboxBody,
ListInboxesEnvelope,
ListInboxesParams,
UpdateInboxEnvelope,
UpdateInboxBody,
DeleteInboxEnvelope,
GetEmailEnvelope,
DeleteEmailEnvelope,
ListEmailsEnvelope,
ListEmailsParams,
ListEmailThreadsEnvelope,
ListEmailThreadsParams,
ReplyToEmailEnvelope,
ReplyToEmailBody,
SendEmailEnvelope,
SendEmailBody,
ListExtractorJobsEnvelope,
ListExtractorJobsParams,
CreateExtractorJobEnvelope,
CreateExtractorJobBody,
GetExtractorJobEnvelope,
ListWorkerRunsEnvelope,
ListWorkerRunsParams,
CreateWorkerRunEnvelope,
CreateWorkerRunBody,
GetWorkerRunEnvelope,
ListWorkerRunMessagesEnvelope,
ListWorkerRunMessagesParams,
CancelWorkerRunEnvelope,
CreateWorkerEvalFromRunEnvelope,
CreateWorkerEvalFromRunBody,
RunEvalEnvelope,
GetEvalRunEnvelope,
CreateExtractorEnvelope,
CreateExtractorBody,
ListExtractorsEnvelope,
ListExtractorsParams,
GetExtractorEnvelope,
UpdateExtractorEnvelope,
UpdateExtractorBody,
DeleteExtractorEnvelope,
CreateWorkerEnvelope,
CreateWorkerBody,
ListWorkersEnvelope,
ListWorkersParams,
GetWorkerEnvelope,
DeleteWorkerEnvelope,
UpdateWorkerEnvelope,
UpdateWorkerBody,
GetWorkerPromptEnvelope,
GetWorkerPromptParams,
UpdateWorkerPromptEnvelope,
UpdateWorkerPromptBody,
ListWorkerModelsEnvelope,
UpdateWorkerMcpsEnvelope,
UpdateWorkerMcpsBody,
ListWorkerVersionsEnvelope,
ListWorkerVersionsParams,
GetWorkerVersionEnvelope,
PromoteWorkerVersionEnvelope,
PromoteWorkerVersionBody,
GetWorkerVersionChangeSummaryEnvelope,
CreateWorkerWebhookEnvelope,
CreateWorkerWebhookBody,
ListWorkerWebhooksEnvelope,
ListWorkerWebhooksParams,
ListCasesEnvelope,
ListCasesParams,
CreateCaseEnvelope,
CreateCaseBody,
SearchCasesEnvelope,
SearchCasesParams,
GetCaseEnvelope,
GetCaseParams,
AddCaseLinksEnvelope,
AddCaseLinksBody,
AddCaseLinksParams,
ListCaseLinksEnvelope,
ListCaseLinksParams,
RemoveCaseLinkEnvelope,
RemoveCaseLinkParams,
CreateChatAgentEnvelope,
CreateChatAgentBody,
ListChatAgentsEnvelope,
ListChatAgentsParams,
GetChatAgentEnvelope,
UpdateChatAgentEnvelope,
UpdateChatAgentRequest,
DeleteChatAgentEnvelope,
GetChatAgentPromptEnvelope,
UpdateChatAgentPromptEnvelope,
UpdateChatAgentPromptBody,
CreateChatEnvelope,
CreateChatBody,
GetChatEnvelope,
GetPublicChatAgentEnvelope,
PostChatMessageEnvelope,
PostChatMessageBody,
ListChatsEnvelope,
ListChatsParams,
ListChatMessagesEnvelope,
ListChatMessagesParams,
GetExtractEnvelope,
GetExtractCitationsEnvelope,
ListExtractsEnvelope,
ListExtractsParams,
GetProfileEnvelope,
ListTeamMembersEnvelope,
InviteTeamMemberEnvelope,
InviteTeamMemberBody,
ListTeamInvitationsEnvelope,
ResendTeamInvitationEnvelope,
UpdateMemberRoleEnvelope,
UpdateMemberRoleBody,
CreateSecretEnvelope,
CreateSecretBody,
ListSecretsEnvelope,
ListSecretsParams,
GetSecretEnvelope,
UpdateSecretEnvelope,
UpdateSecretBody,
DeleteSecretEnvelope,
CreateScheduleEnvelope,
CreateScheduleBody,
ListSchedulesEnvelope,
ListSchedulesParams,
GetScheduleEnvelope,
UpdateScheduleEnvelope,
UpdateScheduleBody,
DeleteScheduleEnvelope,
ListDispatchesEnvelope,
ListDispatchesParams,
ListNotificationsEnvelope,
ListNotificationsParams,
CreateInformationRequestEnvelope,
CreateInformationRequestBody,
ListInformationRequestsEnvelope,
ListInformationRequestsParams,
GetInformationRequestEnvelope,
ResolveInformationRequestEnvelope,
ResolveInformationRequestBody,
CreateToolEnvelope,
CreateToolBody,
ListToolsEnvelope,
ListToolsParams,
DeleteToolEnvelope,
GetToolEnvelope,
UpdateToolEnvelope,
UpdateToolBody,
ExecuteCodeEnvelope,
ExecuteCodeBody,
ListToolVersionsEnvelope,
ListToolVersionsParams,
GetToolVersionEnvelope,
PromoteToolVersionEnvelope,
PromoteToolVersionBody,
GetToolVersionChangeSummaryEnvelope,
WorkerListToolsEnvelope,
WorkerListToolsParams,
WorkerGetToolEnvelope,
WorkerExecuteToolEnvelope,
WorkerExecuteToolBody,
NotifyAdminEnvelope,
NotifyAdminBody,
UploadFileEnvelope,
UploadFileBody,
CreateAgentWebhookEnvelope,
CreateAgentWebhookBody,
ListAgentWebhooksEnvelope,
ListAgentWebhooksParams,
CreateInboxWebhookEnvelope,
CreateInboxWebhookBody,
ListInboxWebhooksEnvelope,
ListInboxWebhooksParams,
CreateExtractorWebhookEnvelope,
CreateExtractorWebhookBody,
ListWebhooksEnvelope,
ListWebhooksParams,
CreateNotificationWebhookEnvelope,
CreateNotificationWebhookBody,
ListNotificationWebhooksEnvelope,
ListNotificationWebhooksParams,
DeleteWebhookEnvelope,
GetWebhookEnvelope,
UpdateWebhookEnvelope,
UpdateWebhookBody,
ListWebhookDeliveriesEnvelope,
ListWebhookDeliveriesParams,
TestWebhookEnvelope,
TestWebhookBody } from './http-schemas';

export type listVoiceAgentsResponse200 = {
  data: ListVoiceAgentsEnvelope
  status: 200
}

export type listVoiceAgentsResponse400 = {
  data: ErrorResponse
  status: 400
}

export type listVoiceAgentsResponse401 = {
  data: ErrorResponse
  status: 401
}

export type listVoiceAgentsResponse409 = {
  data: ErrorResponse
  status: 409
}

export type listVoiceAgentsResponse500 = {
  data: ErrorResponse
  status: 500
}

export type listVoiceAgentsResponseSuccess = (listVoiceAgentsResponse200) & {
  headers: Headers;
};
export type listVoiceAgentsResponseError = (listVoiceAgentsResponse400 | listVoiceAgentsResponse401 | listVoiceAgentsResponse409 | listVoiceAgentsResponse500) & {
  headers: Headers;
};

export type listVoiceAgentsResponse = (listVoiceAgentsResponseSuccess | listVoiceAgentsResponseError)

export const getListVoiceAgentsUrl = (params?: ListVoiceAgentsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/voice-agents?${stringifiedParams}` : `/v1/voice-agents`
}

/**
 * List all voice agents for your tenant.
 *
 * **Filtering:**
 *
 * Filter voice agents by name using the `agent_name` query parameter (exact match).
 *
 * **Response:**
 *
 * Returns an array of all voice agents with their configurations and a total count.
 *
 * For compatibility this endpoint is also available using the following (deprecated) paths:
 * `GET /v1/agents`
 * @summary List voice agents
 */
export const listVoiceAgents = async (params?: ListVoiceAgentsParams, options?: RequestInit): Promise<listVoiceAgentsResponse> => {

  const res = await fetch(getListVoiceAgentsUrl(params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: listVoiceAgentsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as listVoiceAgentsResponse
}



export type createVoiceAgentResponse201 = {
  data: CreateVoiceAgentEnvelope
  status: 201
}

export type createVoiceAgentResponse400 = {
  data: ErrorResponse
  status: 400
}

export type createVoiceAgentResponse401 = {
  data: ErrorResponse
  status: 401
}

export type createVoiceAgentResponse409 = {
  data: ErrorResponse
  status: 409
}

export type createVoiceAgentResponse500 = {
  data: ErrorResponse
  status: 500
}

export type createVoiceAgentResponseSuccess = (createVoiceAgentResponse201) & {
  headers: Headers;
};
export type createVoiceAgentResponseError = (createVoiceAgentResponse400 | createVoiceAgentResponse401 | createVoiceAgentResponse409 | createVoiceAgentResponse500) & {
  headers: Headers;
};

export type createVoiceAgentResponse = (createVoiceAgentResponseSuccess | createVoiceAgentResponseError)

export const getCreateVoiceAgentUrl = () => {




  return `/v1/voice-agents`
}

/**
 * Create a new voice agent with the specified configuration.
 *
 * **Required fields:**
 *
 * All fields in the request body are required except `phone_number_id` and `transfer_phone_number`.
 *
 * **Response:**
 *
 * Returns the created voice agent with its ID and configuration.
 *
 * For compatibility this endpoint is also available using the following (deprecated) paths:
 * `POST /v1/agents`
 * @summary Create voice agent
 */
export const createVoiceAgent = async (createVoiceAgentBody?: CreateVoiceAgentBody, options?: RequestInit): Promise<createVoiceAgentResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getCreateVoiceAgentUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createVoiceAgentBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: createVoiceAgentResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as createVoiceAgentResponse
}



export type getVoiceAgentResponse200 = {
  data: GetVoiceAgentEnvelope
  status: 200
}

export type getVoiceAgentResponse400 = {
  data: ErrorResponse
  status: 400
}

export type getVoiceAgentResponse401 = {
  data: ErrorResponse
  status: 401
}

export type getVoiceAgentResponse404 = {
  data: ErrorResponse
  status: 404
}

export type getVoiceAgentResponse409 = {
  data: ErrorResponse
  status: 409
}

export type getVoiceAgentResponse500 = {
  data: ErrorResponse
  status: 500
}

export type getVoiceAgentResponseSuccess = (getVoiceAgentResponse200) & {
  headers: Headers;
};
export type getVoiceAgentResponseError = (getVoiceAgentResponse400 | getVoiceAgentResponse401 | getVoiceAgentResponse404 | getVoiceAgentResponse409 | getVoiceAgentResponse500) & {
  headers: Headers;
};

export type getVoiceAgentResponse = (getVoiceAgentResponseSuccess | getVoiceAgentResponseError)

export const getGetVoiceAgentUrl = (voiceAgentId: string,) => {




  return `/v1/voice-agents/${voiceAgentId}`
}

/**
 * Retrieve a single voice agent by its ID.
 *
 * For compatibility this endpoint is also available using the following (deprecated) paths:
 * `GET /v1/agents/{id}`
 * @summary Get voice agent
 */
export const getVoiceAgent = async (voiceAgentId: string, options?: RequestInit): Promise<getVoiceAgentResponse> => {

  const res = await fetch(getGetVoiceAgentUrl(voiceAgentId),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getVoiceAgentResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getVoiceAgentResponse
}



export type updateVoiceAgentResponse200 = {
  data: UpdateVoiceAgentEnvelope
  status: 200
}

export type updateVoiceAgentResponse400 = {
  data: ErrorResponse
  status: 400
}

export type updateVoiceAgentResponse401 = {
  data: ErrorResponse
  status: 401
}

export type updateVoiceAgentResponse404 = {
  data: ErrorResponse
  status: 404
}

export type updateVoiceAgentResponse409 = {
  data: ErrorResponse
  status: 409
}

export type updateVoiceAgentResponse500 = {
  data: ErrorResponse
  status: 500
}

export type updateVoiceAgentResponseSuccess = (updateVoiceAgentResponse200) & {
  headers: Headers;
};
export type updateVoiceAgentResponseError = (updateVoiceAgentResponse400 | updateVoiceAgentResponse401 | updateVoiceAgentResponse404 | updateVoiceAgentResponse409 | updateVoiceAgentResponse500) & {
  headers: Headers;
};

export type updateVoiceAgentResponse = (updateVoiceAgentResponseSuccess | updateVoiceAgentResponseError)

export const getUpdateVoiceAgentUrl = (voiceAgentId: string,) => {




  return `/v1/voice-agents/${voiceAgentId}`
}

/**
 * Update a voice agent's name, call processor, or call behaviour settings.
 *
 * To change the processor assignment, `call_processor_id` and `call_processor_type` must be provided together. Set `call_processor_id` to `null` to detach (`call_processor_type` is still required).
 *
 * Set `voice_mail_detection` to `true` to have the agent listen for a voicemail beep tone. Detection only runs on `OUTBOUND` agents; enabling it on an `INBOUND` agent is stored but has no effect.
 *
 * Set `noise_cancellation` to choose the noise cancellation mode applied to the caller audio.
 *
 * Set `tool_ids` to replace the agent's attached tool set. This is the supported way to manage tool attachments; the dedicated add and remove endpoints are deprecated.
 *
 * Config changes create a new voice agent config version. The live and test releases keep pointing at their current versions until the new version is promoted.
 * @summary Update voice agent
 */
export const updateVoiceAgent = async (voiceAgentId: string,
    updateVoiceAgentBody?: UpdateVoiceAgentBody, options?: RequestInit): Promise<updateVoiceAgentResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getUpdateVoiceAgentUrl(voiceAgentId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateVoiceAgentBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: updateVoiceAgentResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as updateVoiceAgentResponse
}



export type deleteVoiceAgentResponse200 = {
  data: DeleteVoiceAgentEnvelope
  status: 200
}

export type deleteVoiceAgentResponse400 = {
  data: ErrorResponse
  status: 400
}

export type deleteVoiceAgentResponse401 = {
  data: ErrorResponse
  status: 401
}

export type deleteVoiceAgentResponse404 = {
  data: ErrorResponse
  status: 404
}

export type deleteVoiceAgentResponse409 = {
  data: ErrorResponse
  status: 409
}

export type deleteVoiceAgentResponse500 = {
  data: ErrorResponse
  status: 500
}

export type deleteVoiceAgentResponseSuccess = (deleteVoiceAgentResponse200) & {
  headers: Headers;
};
export type deleteVoiceAgentResponseError = (deleteVoiceAgentResponse400 | deleteVoiceAgentResponse401 | deleteVoiceAgentResponse404 | deleteVoiceAgentResponse409 | deleteVoiceAgentResponse500) & {
  headers: Headers;
};

export type deleteVoiceAgentResponse = (deleteVoiceAgentResponseSuccess | deleteVoiceAgentResponseError)

export const getDeleteVoiceAgentUrl = (voiceAgentId: string,) => {




  return `/v1/voice-agents/${voiceAgentId}`
}

/**
 * Delete a voice agent. The agent is hidden from all reads; its call and job history is preserved.
 * @summary Delete voice agent
 */
export const deleteVoiceAgent = async (voiceAgentId: string, options?: RequestInit): Promise<deleteVoiceAgentResponse> => {

  const res = await fetch(getDeleteVoiceAgentUrl(voiceAgentId),
  {
    ...options,
    method: 'DELETE'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: deleteVoiceAgentResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as deleteVoiceAgentResponse
}



export type listVoiceAgentVersionsResponse200 = {
  data: ListVoiceAgentVersionsEnvelope
  status: 200
}

export type listVoiceAgentVersionsResponse400 = {
  data: ErrorResponse
  status: 400
}

export type listVoiceAgentVersionsResponse401 = {
  data: ErrorResponse
  status: 401
}

export type listVoiceAgentVersionsResponse404 = {
  data: ErrorResponse
  status: 404
}

export type listVoiceAgentVersionsResponse409 = {
  data: ErrorResponse
  status: 409
}

export type listVoiceAgentVersionsResponse500 = {
  data: ErrorResponse
  status: 500
}

export type listVoiceAgentVersionsResponseSuccess = (listVoiceAgentVersionsResponse200) & {
  headers: Headers;
};
export type listVoiceAgentVersionsResponseError = (listVoiceAgentVersionsResponse400 | listVoiceAgentVersionsResponse401 | listVoiceAgentVersionsResponse404 | listVoiceAgentVersionsResponse409 | listVoiceAgentVersionsResponse500) & {
  headers: Headers;
};

export type listVoiceAgentVersionsResponse = (listVoiceAgentVersionsResponseSuccess | listVoiceAgentVersionsResponseError)

export const getListVoiceAgentVersionsUrl = (voiceAgentId: string,
    params?: ListVoiceAgentVersionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/voice-agents/${voiceAgentId}/versions?${stringifiedParams}` : `/v1/voice-agents/${voiceAgentId}/versions`
}

/**
 * List all config versions for a voice agent, ordered by version (newest first by default).
 * @summary List voice agent versions
 */
export const listVoiceAgentVersions = async (voiceAgentId: string,
    params?: ListVoiceAgentVersionsParams, options?: RequestInit): Promise<listVoiceAgentVersionsResponse> => {

  const res = await fetch(getListVoiceAgentVersionsUrl(voiceAgentId,params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: listVoiceAgentVersionsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as listVoiceAgentVersionsResponse
}



export type getVoiceAgentVersionResponse200 = {
  data: GetVoiceAgentVersionEnvelope
  status: 200
}

export type getVoiceAgentVersionResponse400 = {
  data: ErrorResponse
  status: 400
}

export type getVoiceAgentVersionResponse401 = {
  data: ErrorResponse
  status: 401
}

export type getVoiceAgentVersionResponse404 = {
  data: ErrorResponse
  status: 404
}

export type getVoiceAgentVersionResponse409 = {
  data: ErrorResponse
  status: 409
}

export type getVoiceAgentVersionResponse500 = {
  data: ErrorResponse
  status: 500
}

export type getVoiceAgentVersionResponseSuccess = (getVoiceAgentVersionResponse200) & {
  headers: Headers;
};
export type getVoiceAgentVersionResponseError = (getVoiceAgentVersionResponse400 | getVoiceAgentVersionResponse401 | getVoiceAgentVersionResponse404 | getVoiceAgentVersionResponse409 | getVoiceAgentVersionResponse500) & {
  headers: Headers;
};

export type getVoiceAgentVersionResponse = (getVoiceAgentVersionResponseSuccess | getVoiceAgentVersionResponseError)

export const getGetVoiceAgentVersionUrl = (voiceAgentId: string,
    version: number,) => {




  return `/v1/voice-agents/${voiceAgentId}/versions/${version}`
}

/**
 * Retrieve a single voice agent config version, including the agent's identity, the config snapshot at that version, and version-specific metadata.
 * @summary Get voice agent version
 */
export const getVoiceAgentVersion = async (voiceAgentId: string,
    version: number, options?: RequestInit): Promise<getVoiceAgentVersionResponse> => {

  const res = await fetch(getGetVoiceAgentVersionUrl(voiceAgentId,version),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getVoiceAgentVersionResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getVoiceAgentVersionResponse
}



export type promoteVoiceAgentVersionResponse200 = {
  data: PromoteVoiceAgentVersionEnvelope
  status: 200
}

export type promoteVoiceAgentVersionResponse400 = {
  data: ErrorResponse
  status: 400
}

export type promoteVoiceAgentVersionResponse401 = {
  data: ErrorResponse
  status: 401
}

export type promoteVoiceAgentVersionResponse404 = {
  data: ErrorResponse
  status: 404
}

export type promoteVoiceAgentVersionResponse409 = {
  data: ErrorResponse
  status: 409
}

export type promoteVoiceAgentVersionResponse500 = {
  data: ErrorResponse
  status: 500
}

export type promoteVoiceAgentVersionResponseSuccess = (promoteVoiceAgentVersionResponse200) & {
  headers: Headers;
};
export type promoteVoiceAgentVersionResponseError = (promoteVoiceAgentVersionResponse400 | promoteVoiceAgentVersionResponse401 | promoteVoiceAgentVersionResponse404 | promoteVoiceAgentVersionResponse409 | promoteVoiceAgentVersionResponse500) & {
  headers: Headers;
};

export type promoteVoiceAgentVersionResponse = (promoteVoiceAgentVersionResponseSuccess | promoteVoiceAgentVersionResponseError)

export const getPromoteVoiceAgentVersionUrl = (voiceAgentId: string,
    version: number,) => {




  return `/v1/voice-agents/${voiceAgentId}/versions/${version}/promote`
}

/**
 * Select a voice agent configuration version for the live or test environment.
 * @summary Promote voice agent version
 */
export const promoteVoiceAgentVersion = async (voiceAgentId: string,
    version: number,
    promoteVoiceAgentVersionBody?: PromoteVoiceAgentVersionBody, options?: RequestInit): Promise<promoteVoiceAgentVersionResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getPromoteVoiceAgentVersionUrl(voiceAgentId,version),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(promoteVoiceAgentVersionBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: promoteVoiceAgentVersionResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as promoteVoiceAgentVersionResponse
}



export type getVoiceAgentVersionChangeSummaryResponse200 = {
  data: GetVoiceAgentVersionChangeSummaryEnvelope
  status: 200
}

export type getVoiceAgentVersionChangeSummaryResponse400 = {
  data: ErrorResponse
  status: 400
}

export type getVoiceAgentVersionChangeSummaryResponse401 = {
  data: ErrorResponse
  status: 401
}

export type getVoiceAgentVersionChangeSummaryResponse404 = {
  data: ErrorResponse
  status: 404
}

export type getVoiceAgentVersionChangeSummaryResponse409 = {
  data: ErrorResponse
  status: 409
}

export type getVoiceAgentVersionChangeSummaryResponse500 = {
  data: ErrorResponse
  status: 500
}

export type getVoiceAgentVersionChangeSummaryResponseSuccess = (getVoiceAgentVersionChangeSummaryResponse200) & {
  headers: Headers;
};
export type getVoiceAgentVersionChangeSummaryResponseError = (getVoiceAgentVersionChangeSummaryResponse400 | getVoiceAgentVersionChangeSummaryResponse401 | getVoiceAgentVersionChangeSummaryResponse404 | getVoiceAgentVersionChangeSummaryResponse409 | getVoiceAgentVersionChangeSummaryResponse500) & {
  headers: Headers;
};

export type getVoiceAgentVersionChangeSummaryResponse = (getVoiceAgentVersionChangeSummaryResponseSuccess | getVoiceAgentVersionChangeSummaryResponseError)

export const getGetVoiceAgentVersionChangeSummaryUrl = (voiceAgentId: string,
    version: number,) => {




  return `/v1/voice-agents/${voiceAgentId}/versions/${version}/change-summary`
}

/**
 * Returns an AI-generated summary of what changed between this version and the previous one. Initial version returns an empty string since there is no predecessor.
 * @summary Get voice agent version change summary
 */
export const getVoiceAgentVersionChangeSummary = async (voiceAgentId: string,
    version: number, options?: RequestInit): Promise<getVoiceAgentVersionChangeSummaryResponse> => {

  const res = await fetch(getGetVoiceAgentVersionChangeSummaryUrl(voiceAgentId,version),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getVoiceAgentVersionChangeSummaryResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getVoiceAgentVersionChangeSummaryResponse
}



export type getVoiceAgentPlaceholdersResponse200 = {
  data: GetVoiceAgentPlaceholdersEnvelope
  status: 200
}

export type getVoiceAgentPlaceholdersResponse400 = {
  data: ErrorResponse
  status: 400
}

export type getVoiceAgentPlaceholdersResponse401 = {
  data: ErrorResponse
  status: 401
}

export type getVoiceAgentPlaceholdersResponse404 = {
  data: ErrorResponse
  status: 404
}

export type getVoiceAgentPlaceholdersResponse409 = {
  data: ErrorResponse
  status: 409
}

export type getVoiceAgentPlaceholdersResponse500 = {
  data: ErrorResponse
  status: 500
}

export type getVoiceAgentPlaceholdersResponseSuccess = (getVoiceAgentPlaceholdersResponse200) & {
  headers: Headers;
};
export type getVoiceAgentPlaceholdersResponseError = (getVoiceAgentPlaceholdersResponse400 | getVoiceAgentPlaceholdersResponse401 | getVoiceAgentPlaceholdersResponse404 | getVoiceAgentPlaceholdersResponse409 | getVoiceAgentPlaceholdersResponse500) & {
  headers: Headers;
};

export type getVoiceAgentPlaceholdersResponse = (getVoiceAgentPlaceholdersResponseSuccess | getVoiceAgentPlaceholdersResponseError)

export const getGetVoiceAgentPlaceholdersUrl = (voiceAgentId: string,) => {




  return `/v1/voice-agents/${voiceAgentId}/placeholders`
}

/**
 * Retrieve the available placeholder variables defined in a voice agent's prompt.
 *
 * For compatibility this endpoint is also available using the following (deprecated) paths:
 * `GET /v1/agents/{id}/prompt`
 * @summary Get voice agent placeholders
 */
export const getVoiceAgentPlaceholders = async (voiceAgentId: string, options?: RequestInit): Promise<getVoiceAgentPlaceholdersResponse> => {

  const res = await fetch(getGetVoiceAgentPlaceholdersUrl(voiceAgentId),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getVoiceAgentPlaceholdersResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getVoiceAgentPlaceholdersResponse
}



export type getVoiceAgentPromptResponse200 = {
  data: GetVoiceAgentPromptEnvelope
  status: 200
}

export type getVoiceAgentPromptResponse400 = {
  data: ErrorResponse
  status: 400
}

export type getVoiceAgentPromptResponse401 = {
  data: ErrorResponse
  status: 401
}

export type getVoiceAgentPromptResponse404 = {
  data: ErrorResponse
  status: 404
}

export type getVoiceAgentPromptResponse409 = {
  data: ErrorResponse
  status: 409
}

export type getVoiceAgentPromptResponse500 = {
  data: ErrorResponse
  status: 500
}

export type getVoiceAgentPromptResponseSuccess = (getVoiceAgentPromptResponse200) & {
  headers: Headers;
};
export type getVoiceAgentPromptResponseError = (getVoiceAgentPromptResponse400 | getVoiceAgentPromptResponse401 | getVoiceAgentPromptResponse404 | getVoiceAgentPromptResponse409 | getVoiceAgentPromptResponse500) & {
  headers: Headers;
};

export type getVoiceAgentPromptResponse = (getVoiceAgentPromptResponseSuccess | getVoiceAgentPromptResponseError)

export const getGetVoiceAgentPromptUrl = (voiceAgentId: string,
    params?: GetVoiceAgentPromptParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/voice-agents/${voiceAgentId}/prompt?${stringifiedParams}` : `/v1/voice-agents/${voiceAgentId}/prompt`
}

/**
 * Retrieve the prompt for a voice agent. Pass `version` to fetch the prompt snapshot at a specific config version; omit it to fetch the current prompt. Internal use only.
 * @summary Get voice agent prompt
 */
export const getVoiceAgentPrompt = async (voiceAgentId: string,
    params?: GetVoiceAgentPromptParams, options?: RequestInit): Promise<getVoiceAgentPromptResponse> => {

  const res = await fetch(getGetVoiceAgentPromptUrl(voiceAgentId,params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getVoiceAgentPromptResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getVoiceAgentPromptResponse
}



export type updateVoiceAgentPromptResponse200 = {
  data: UpdateVoiceAgentPromptEnvelope
  status: 200
}

export type updateVoiceAgentPromptResponse400 = {
  data: ErrorResponse
  status: 400
}

export type updateVoiceAgentPromptResponse401 = {
  data: ErrorResponse
  status: 401
}

export type updateVoiceAgentPromptResponse404 = {
  data: ErrorResponse
  status: 404
}

export type updateVoiceAgentPromptResponse409 = {
  data: ErrorResponse
  status: 409
}

export type updateVoiceAgentPromptResponse500 = {
  data: ErrorResponse
  status: 500
}

export type updateVoiceAgentPromptResponseSuccess = (updateVoiceAgentPromptResponse200) & {
  headers: Headers;
};
export type updateVoiceAgentPromptResponseError = (updateVoiceAgentPromptResponse400 | updateVoiceAgentPromptResponse401 | updateVoiceAgentPromptResponse404 | updateVoiceAgentPromptResponse409 | updateVoiceAgentPromptResponse500) & {
  headers: Headers;
};

export type updateVoiceAgentPromptResponse = (updateVoiceAgentPromptResponseSuccess | updateVoiceAgentPromptResponseError)

export const getUpdateVoiceAgentPromptUrl = (voiceAgentId: string,) => {




  return `/v1/voice-agents/${voiceAgentId}/prompt`
}

/**
 * Update the prompt for a voice agent. Internal use only.
 * @summary Update voice agent prompt
 */
export const updateVoiceAgentPrompt = async (voiceAgentId: string,
    updateVoiceAgentPromptBody?: UpdateVoiceAgentPromptBody, options?: RequestInit): Promise<updateVoiceAgentPromptResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getUpdateVoiceAgentPromptUrl(voiceAgentId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateVoiceAgentPromptBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: updateVoiceAgentPromptResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as updateVoiceAgentPromptResponse
}



export type updateVoiceAgentModelsResponse200 = {
  data: UpdateVoiceAgentModelsEnvelope
  status: 200
}

export type updateVoiceAgentModelsResponse400 = {
  data: ErrorResponse
  status: 400
}

export type updateVoiceAgentModelsResponse401 = {
  data: ErrorResponse
  status: 401
}

export type updateVoiceAgentModelsResponse404 = {
  data: ErrorResponse
  status: 404
}

export type updateVoiceAgentModelsResponse409 = {
  data: ErrorResponse
  status: 409
}

export type updateVoiceAgentModelsResponse500 = {
  data: ErrorResponse
  status: 500
}

export type updateVoiceAgentModelsResponseSuccess = (updateVoiceAgentModelsResponse200) & {
  headers: Headers;
};
export type updateVoiceAgentModelsResponseError = (updateVoiceAgentModelsResponse400 | updateVoiceAgentModelsResponse401 | updateVoiceAgentModelsResponse404 | updateVoiceAgentModelsResponse409 | updateVoiceAgentModelsResponse500) & {
  headers: Headers;
};

export type updateVoiceAgentModelsResponse = (updateVoiceAgentModelsResponseSuccess | updateVoiceAgentModelsResponseError)

export const getUpdateVoiceAgentModelsUrl = (voiceAgentId: string,) => {




  return `/v1/voice-agents/${voiceAgentId}/models`
}

/**
 * Update the LLM, TTS, and STT model configuration for a voice agent.
 *
 * For compatibility this endpoint is also available using the following (deprecated) paths:
 * `PATCH /v1/agents/{id}/models`
 * @summary Update voice agent models
 */
export const updateVoiceAgentModels = async (voiceAgentId: string,
    updateVoiceAgentModelsBody?: UpdateVoiceAgentModelsBody, options?: RequestInit): Promise<updateVoiceAgentModelsResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getUpdateVoiceAgentModelsUrl(voiceAgentId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateVoiceAgentModelsBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: updateVoiceAgentModelsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as updateVoiceAgentModelsResponse
}



export type updateCallControlsResponse200 = {
  data: UpdateCallControlsEnvelope
  status: 200
}

export type updateCallControlsResponse400 = {
  data: ErrorResponse
  status: 400
}

export type updateCallControlsResponse401 = {
  data: ErrorResponse
  status: 401
}

export type updateCallControlsResponse404 = {
  data: ErrorResponse
  status: 404
}

export type updateCallControlsResponse409 = {
  data: ErrorResponse
  status: 409
}

export type updateCallControlsResponse500 = {
  data: ErrorResponse
  status: 500
}

export type updateCallControlsResponseSuccess = (updateCallControlsResponse200) & {
  headers: Headers;
};
export type updateCallControlsResponseError = (updateCallControlsResponse400 | updateCallControlsResponse401 | updateCallControlsResponse404 | updateCallControlsResponse409 | updateCallControlsResponse500) & {
  headers: Headers;
};

export type updateCallControlsResponse = (updateCallControlsResponseSuccess | updateCallControlsResponseError)

export const getUpdateCallControlsUrl = (voiceAgentId: string,) => {




  return `/v1/voice-agents/${voiceAgentId}/call-controls`
}

/**
 * Update call control settings for a voice agent.
 *
 * Configure whether the voice agent supports dial pad input, can end calls, and set a transfer phone number.
 *
 * For compatibility this endpoint is also available using the following (deprecated) paths:
 * `PUT /v1/agents/{id}/call-controls`
 * @summary Update voice agent call controls
 */
export const updateCallControls = async (voiceAgentId: string,
    updateCallControlsBody?: UpdateCallControlsBody, options?: RequestInit): Promise<updateCallControlsResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getUpdateCallControlsUrl(voiceAgentId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateCallControlsBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: updateCallControlsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as updateCallControlsResponse
}



export type scheduleJobResponse200 = {
  data: ScheduleJobEnvelope
  status: 200
}

export type scheduleJobResponse400 = {
  data: ErrorResponse
  status: 400
}

export type scheduleJobResponse401 = {
  data: ErrorResponse
  status: 401
}

export type scheduleJobResponse404 = {
  data: ErrorResponse
  status: 404
}

export type scheduleJobResponse409 = {
  data: ErrorResponse
  status: 409
}

export type scheduleJobResponse500 = {
  data: ErrorResponse
  status: 500
}

export type scheduleJobResponseSuccess = (scheduleJobResponse200) & {
  headers: Headers;
};
export type scheduleJobResponseError = (scheduleJobResponse400 | scheduleJobResponse401 | scheduleJobResponse404 | scheduleJobResponse409 | scheduleJobResponse500) & {
  headers: Headers;
};

export type scheduleJobResponse = (scheduleJobResponseSuccess | scheduleJobResponseError)

export const getScheduleJobUrl = (voiceAgentId: string,) => {




  return `/v1/voice-agents/${voiceAgentId}/jobs`
}

/**
 * Schedule a new outbound call job for a voice agent.
 *
 * The job can be scheduled for a future time or triggered immediately with `trigger_immediately: true`.
 *
 * **Scheduling:**
 *
 * When scheduling for a future time, provide `scheduled_at` (ISO 8601) and optionally `schedule_window_minutes` (minimum 10 minutes).
 *
 * **Environment:**
 *
 * `environment` selects which promoted agent configuration and phone binding the call dispatches against (`live` or `test`). Defaults to `live`. Scheduling fails when the selected environment has no active promotion.
 *
 * For compatibility this endpoint is also available using the following (deprecated) paths:
 * `POST /v1/agents/{id}/jobs`
 * @summary Schedule an outbound job
 */
export const scheduleJob = async (voiceAgentId: string,
    scheduleJobBody?: ScheduleJobBody, options?: RequestInit): Promise<scheduleJobResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getScheduleJobUrl(voiceAgentId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(scheduleJobBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: scheduleJobResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as scheduleJobResponse
}



export type listJobsResponse200 = {
  data: ListJobsEnvelope
  status: 200
}

export type listJobsResponse400 = {
  data: ErrorResponse
  status: 400
}

export type listJobsResponse401 = {
  data: ErrorResponse
  status: 401
}

export type listJobsResponse409 = {
  data: ErrorResponse
  status: 409
}

export type listJobsResponse500 = {
  data: ErrorResponse
  status: 500
}

export type listJobsResponseSuccess = (listJobsResponse200) & {
  headers: Headers;
};
export type listJobsResponseError = (listJobsResponse400 | listJobsResponse401 | listJobsResponse409 | listJobsResponse500) & {
  headers: Headers;
};

export type listJobsResponse = (listJobsResponseSuccess | listJobsResponseError)

export const getListJobsUrl = (params: ListJobsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["status"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/voice-agents/jobs?${stringifiedParams}` : `/v1/voice-agents/jobs`
}

/**
 * List all outbound jobs with pagination and filtering.
 *
 * **Filtering:**
 *
 * - Filter by agent ID, status, or scheduled time range.
 * - Multiple statuses can be comma-separated (e.g. `status=pending,queued`).
 *
 * For compatibility this endpoint is also available using the following (deprecated) paths:
 * `GET /v1/agents/jobs`
 * @summary List outbound jobs
 */
export const listJobs = async (params: ListJobsParams, options?: RequestInit): Promise<listJobsResponse> => {

  const res = await fetch(getListJobsUrl(params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: listJobsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as listJobsResponse
}



export type cancelJobResponse200 = {
  data: CancelJobEnvelope
  status: 200
}

export type cancelJobResponse400 = {
  data: ErrorResponse
  status: 400
}

export type cancelJobResponse401 = {
  data: ErrorResponse
  status: 401
}

export type cancelJobResponse404 = {
  data: ErrorResponse
  status: 404
}

export type cancelJobResponse409 = {
  data: ErrorResponse
  status: 409
}

export type cancelJobResponse500 = {
  data: ErrorResponse
  status: 500
}

export type cancelJobResponseSuccess = (cancelJobResponse200) & {
  headers: Headers;
};
export type cancelJobResponseError = (cancelJobResponse400 | cancelJobResponse401 | cancelJobResponse404 | cancelJobResponse409 | cancelJobResponse500) & {
  headers: Headers;
};

export type cancelJobResponse = (cancelJobResponseSuccess | cancelJobResponseError)

export const getCancelJobUrl = (jobId: string,) => {




  return `/v1/voice-agents/jobs/${jobId}/cancel`
}

/**
 * Cancel a pending or queued outbound job. Jobs that are already in progress or completed cannot be canceled.
 *
 * For compatibility this endpoint is also available using the following (deprecated) paths:
 * `POST /v1/agents/jobs/{id}/cancel`
 * @summary Cancel an outbound job
 */
export const cancelJob = async (jobId: string, options?: RequestInit): Promise<cancelJobResponse> => {

  const res = await fetch(getCancelJobUrl(jobId),
  {
    ...options,
    method: 'POST'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: cancelJobResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as cancelJobResponse
}



export type listApiKeysResponse200 = {
  data: ListApiKeysEnvelope
  status: 200
}

export type listApiKeysResponse400 = {
  data: ErrorResponse
  status: 400
}

export type listApiKeysResponse401 = {
  data: ErrorResponse
  status: 401
}

export type listApiKeysResponse409 = {
  data: ErrorResponse
  status: 409
}

export type listApiKeysResponse500 = {
  data: ErrorResponse
  status: 500
}

export type listApiKeysResponseSuccess = (listApiKeysResponse200) & {
  headers: Headers;
};
export type listApiKeysResponseError = (listApiKeysResponse400 | listApiKeysResponse401 | listApiKeysResponse409 | listApiKeysResponse500) & {
  headers: Headers;
};

export type listApiKeysResponse = (listApiKeysResponseSuccess | listApiKeysResponseError)

export const getListApiKeysUrl = (params?: ListApiKeysParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/platform/api-keys?${stringifiedParams}` : `/platform/api-keys`
}

/**
 * List all API keys for your tenant.
 *
 * By default, revoked keys are excluded. Set `include_revoked=true` to include them.
 *
 * **Note:** The full API key value is never returned — only the key prefix is shown.
 * @summary List API keys
 */
export const listApiKeys = async (params?: ListApiKeysParams, options?: RequestInit): Promise<listApiKeysResponse> => {

  const res = await fetch(getListApiKeysUrl(params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: listApiKeysResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as listApiKeysResponse
}



export type createApiKeyResponse201 = {
  data: CreateApiKeyEnvelope
  status: 201
}

export type createApiKeyResponse400 = {
  data: ErrorResponse
  status: 400
}

export type createApiKeyResponse401 = {
  data: ErrorResponse
  status: 401
}

export type createApiKeyResponse409 = {
  data: ErrorResponse
  status: 409
}

export type createApiKeyResponse500 = {
  data: ErrorResponse
  status: 500
}

export type createApiKeyResponseSuccess = (createApiKeyResponse201) & {
  headers: Headers;
};
export type createApiKeyResponseError = (createApiKeyResponse400 | createApiKeyResponse401 | createApiKeyResponse409 | createApiKeyResponse500) & {
  headers: Headers;
};

export type createApiKeyResponse = (createApiKeyResponseSuccess | createApiKeyResponseError)

export const getCreateApiKeyUrl = () => {




  return `/platform/api-keys`
}

/**
 * Create a new API key for authenticating with the Avallon API.
 *
 * **Important:** The full API key is only returned once in the response. Store it securely — it cannot be retrieved again.
 *
 * Keys are scoped to an environment (`test` or `live`) and optionally accept an expiration date.
 * @summary Create an API key
 */
export const createApiKey = async (createApiKeyBody?: CreateApiKeyBody, options?: RequestInit): Promise<createApiKeyResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getCreateApiKeyUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createApiKeyBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: createApiKeyResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as createApiKeyResponse
}



export type revokeApiKeyResponse200 = {
  data: RevokeApiKeyEnvelope
  status: 200
}

export type revokeApiKeyResponse400 = {
  data: ErrorResponse
  status: 400
}

export type revokeApiKeyResponse401 = {
  data: ErrorResponse
  status: 401
}

export type revokeApiKeyResponse404 = {
  data: ErrorResponse
  status: 404
}

export type revokeApiKeyResponse409 = {
  data: ErrorResponse
  status: 409
}

export type revokeApiKeyResponse500 = {
  data: ErrorResponse
  status: 500
}

export type revokeApiKeyResponseSuccess = (revokeApiKeyResponse200) & {
  headers: Headers;
};
export type revokeApiKeyResponseError = (revokeApiKeyResponse400 | revokeApiKeyResponse401 | revokeApiKeyResponse404 | revokeApiKeyResponse409 | revokeApiKeyResponse500) & {
  headers: Headers;
};

export type revokeApiKeyResponse = (revokeApiKeyResponseSuccess | revokeApiKeyResponseError)

export const getRevokeApiKeyUrl = (id: string,) => {




  return `/platform/api-keys/${id}/revoke`
}

/**
 * Revoke an existing API key. Once revoked, the key can no longer be used for authentication.
 *
 * This operation is irreversible — revoked keys cannot be re-enabled. Create a new key if needed.
 *
 * Returns 409 if the key is already revoked, 404 if the key does not exist.
 * @summary Revoke an API key
 */
export const revokeApiKey = async (id: string, options?: RequestInit): Promise<revokeApiKeyResponse> => {

  const res = await fetch(getRevokeApiKeyUrl(id),
  {
    ...options,
    method: 'POST'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: revokeApiKeyResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as revokeApiKeyResponse
}



export type updateApiKeyResponse200 = {
  data: UpdateApiKeyEnvelope
  status: 200
}

export type updateApiKeyResponse400 = {
  data: ErrorResponse
  status: 400
}

export type updateApiKeyResponse401 = {
  data: ErrorResponse
  status: 401
}

export type updateApiKeyResponse404 = {
  data: ErrorResponse
  status: 404
}

export type updateApiKeyResponse409 = {
  data: ErrorResponse
  status: 409
}

export type updateApiKeyResponse500 = {
  data: ErrorResponse
  status: 500
}

export type updateApiKeyResponseSuccess = (updateApiKeyResponse200) & {
  headers: Headers;
};
export type updateApiKeyResponseError = (updateApiKeyResponse400 | updateApiKeyResponse401 | updateApiKeyResponse404 | updateApiKeyResponse409 | updateApiKeyResponse500) & {
  headers: Headers;
};

export type updateApiKeyResponse = (updateApiKeyResponseSuccess | updateApiKeyResponseError)

export const getUpdateApiKeyUrl = (id: string,) => {




  return `/platform/api-keys/${id}`
}

/**
 * Update mutable fields of an API key. Currently only `role` can be updated.
 *
 * The caller's role caps the maximum role they can grant — an `admin` cannot promote a key to `avallon_admin`.
 * @summary Update API key
 */
export const updateApiKey = async (id: string,
    updateApiKeyBody?: UpdateApiKeyBody, options?: RequestInit): Promise<updateApiKeyResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getUpdateApiKeyUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateApiKeyBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: updateApiKeyResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as updateApiKeyResponse
}



export type createArtifactResponse200 = {
  data: CreateArtifactEnvelope
  status: 200
}

export type createArtifactResponse400 = {
  data: ErrorResponse
  status: 400
}

export type createArtifactResponse401 = {
  data: ErrorResponse
  status: 401
}

export type createArtifactResponse409 = {
  data: ErrorResponse
  status: 409
}

export type createArtifactResponse500 = {
  data: ErrorResponse
  status: 500
}

export type createArtifactResponseSuccess = (createArtifactResponse200) & {
  headers: Headers;
};
export type createArtifactResponseError = (createArtifactResponse400 | createArtifactResponse401 | createArtifactResponse409 | createArtifactResponse500) & {
  headers: Headers;
};

export type createArtifactResponse = (createArtifactResponseSuccess | createArtifactResponseError)

export const getCreateArtifactUrl = () => {




  return `/v1/artifacts`
}

/**
 * Upload a document as a base64-encoded artifact for processing.
 *
 * **Limits:**
 *
 * Maximum file size is approximately 6.75MB (base64 encoded). The API Gateway has a 10MB request limit.
 *
 * **Processing options:**
 *
 * - `file_password`: Password for encrypted PDFs
 * - `file_splitting_enabled`: Split multi-page PDFs into separate artifacts
 * @summary Create artifact
 */
export const createArtifact = async (createArtifactBody?: CreateArtifactBody, options?: RequestInit): Promise<createArtifactResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getCreateArtifactUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createArtifactBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: createArtifactResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as createArtifactResponse
}



export type listArtifactsResponse200 = {
  data: ListArtifactsEnvelope
  status: 200
}

export type listArtifactsResponse400 = {
  data: ErrorResponse
  status: 400
}

export type listArtifactsResponse401 = {
  data: ErrorResponse
  status: 401
}

export type listArtifactsResponse409 = {
  data: ErrorResponse
  status: 409
}

export type listArtifactsResponse500 = {
  data: ErrorResponse
  status: 500
}

export type listArtifactsResponseSuccess = (listArtifactsResponse200) & {
  headers: Headers;
};
export type listArtifactsResponseError = (listArtifactsResponse400 | listArtifactsResponse401 | listArtifactsResponse409 | listArtifactsResponse500) & {
  headers: Headers;
};

export type listArtifactsResponse = (listArtifactsResponseSuccess | listArtifactsResponseError)

export const getListArtifactsUrl = (params?: ListArtifactsParams,) => {
  const normalizedParams = new URLSearchParams();
  const deepObjectEntries: string[] = [];

  Object.entries(params || {}).forEach(([key, value]) => {
    const deepObjectParameters = ["metadata"];

    if (typeof value === 'object' && value !== null && !Array.isArray(value) && deepObjectParameters.includes(key)) {
      Object.entries(value).forEach(([subKey, subValue]) => {
        if (subValue !== undefined) {
          deepObjectEntries.push(encodeURIComponent(key) + '[' + encodeURIComponent(subKey) + ']=' + (subValue === null ? 'null' : encodeURIComponent(String(subValue))));
        }
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = [normalizedParams.toString(), deepObjectEntries.join('&')].filter(Boolean).join('&');

  return stringifiedParams.length > 0 ? `/v1/artifacts?${stringifiedParams}` : `/v1/artifacts`
}

/**
 * List all artifacts with pagination, filtering, and sorting.
 *
 * **Case Filtering:**
 *
 * Use `case_id` to return only artifacts linked to a case. This reads the case links
 * created via `POST /v1/cases/{caseId}/links`, and is independent of any
 * `metadata.case_id` an artifact may carry.
 *
 * **Metadata Filtering:**
 *
 * Use bracket notation to filter by metadata keys:
 * - `metadata[claim_id]=abc-123`
 * - `metadata[source]=email`
 *
 * Multiple metadata filters can be combined (AND logic).
 * @summary List artifacts
 */
export const listArtifacts = async (params?: ListArtifactsParams, options?: RequestInit): Promise<listArtifactsResponse> => {

  const res = await fetch(getListArtifactsUrl(params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: listArtifactsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as listArtifactsResponse
}



export type getArtifactResponse200 = {
  data: GetArtifactEnvelope
  status: 200
}

export type getArtifactResponse400 = {
  data: ErrorResponse
  status: 400
}

export type getArtifactResponse401 = {
  data: ErrorResponse
  status: 401
}

export type getArtifactResponse404 = {
  data: ErrorResponse
  status: 404
}

export type getArtifactResponse409 = {
  data: ErrorResponse
  status: 409
}

export type getArtifactResponse500 = {
  data: ErrorResponse
  status: 500
}

export type getArtifactResponseSuccess = (getArtifactResponse200) & {
  headers: Headers;
};
export type getArtifactResponseError = (getArtifactResponse400 | getArtifactResponse401 | getArtifactResponse404 | getArtifactResponse409 | getArtifactResponse500) & {
  headers: Headers;
};

export type getArtifactResponse = (getArtifactResponseSuccess | getArtifactResponseError)

export const getGetArtifactUrl = (id: string,) => {




  return `/v1/artifacts/${id}`
}

/**
 * Retrieve a single artifact by ID, including its metadata, file URL, extracted content, and chunk-annotated content.
 *
 * The response always includes `content_with_chunkids_md`: the parsed content annotated with `[chunk_id=...]` markers when the artifact has parsed chunks. Chunk IDs are stable citation anchors — cite them to attribute extracted values to their source location.
 * @summary Get artifact
 */
export const getArtifact = async (id: string, options?: RequestInit): Promise<getArtifactResponse> => {

  const res = await fetch(getGetArtifactUrl(id),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getArtifactResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getArtifactResponse
}



export type deleteArtifactResponse200 = {
  data: DeleteArtifactEnvelope
  status: 200
}

export type deleteArtifactResponse400 = {
  data: ErrorResponse
  status: 400
}

export type deleteArtifactResponse401 = {
  data: ErrorResponse
  status: 401
}

export type deleteArtifactResponse404 = {
  data: ErrorResponse
  status: 404
}

export type deleteArtifactResponse409 = {
  data: ErrorResponse
  status: 409
}

export type deleteArtifactResponse500 = {
  data: ErrorResponse
  status: 500
}

export type deleteArtifactResponseSuccess = (deleteArtifactResponse200) & {
  headers: Headers;
};
export type deleteArtifactResponseError = (deleteArtifactResponse400 | deleteArtifactResponse401 | deleteArtifactResponse404 | deleteArtifactResponse409 | deleteArtifactResponse500) & {
  headers: Headers;
};

export type deleteArtifactResponse = (deleteArtifactResponseSuccess | deleteArtifactResponseError)

export const getDeleteArtifactUrl = (id: string,) => {




  return `/v1/artifacts/${id}`
}

/**
 * Soft-delete an artifact. Soft-deleted artifacts and their chunks no longer appear in any read.
 * @summary Delete artifact
 */
export const deleteArtifact = async (id: string, options?: RequestInit): Promise<deleteArtifactResponse> => {

  const res = await fetch(getDeleteArtifactUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: deleteArtifactResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as deleteArtifactResponse
}



export type getArtifactMetadataKeysResponse200 = {
  data: GetArtifactMetadataKeysEnvelope
  status: 200
}

export type getArtifactMetadataKeysResponse400 = {
  data: ErrorResponse
  status: 400
}

export type getArtifactMetadataKeysResponse401 = {
  data: ErrorResponse
  status: 401
}

export type getArtifactMetadataKeysResponse409 = {
  data: ErrorResponse
  status: 409
}

export type getArtifactMetadataKeysResponse500 = {
  data: ErrorResponse
  status: 500
}

export type getArtifactMetadataKeysResponseSuccess = (getArtifactMetadataKeysResponse200) & {
  headers: Headers;
};
export type getArtifactMetadataKeysResponseError = (getArtifactMetadataKeysResponse400 | getArtifactMetadataKeysResponse401 | getArtifactMetadataKeysResponse409 | getArtifactMetadataKeysResponse500) & {
  headers: Headers;
};

export type getArtifactMetadataKeysResponse = (getArtifactMetadataKeysResponseSuccess | getArtifactMetadataKeysResponseError)

export const getGetArtifactMetadataKeysUrl = (params?: GetArtifactMetadataKeysParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/artifacts/metadata/keys?${stringifiedParams}` : `/v1/artifacts/metadata/keys`
}

/**
 * Retrieve all unique metadata keys and their values across artifacts. Useful for building filter UIs.
 * @summary Get artifact metadata keys
 */
export const getArtifactMetadataKeys = async (params?: GetArtifactMetadataKeysParams, options?: RequestInit): Promise<getArtifactMetadataKeysResponse> => {

  const res = await fetch(getGetArtifactMetadataKeysUrl(params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getArtifactMetadataKeysResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getArtifactMetadataKeysResponse
}



export type getArtifactStatusSummaryResponse200 = {
  data: GetArtifactStatusSummaryEnvelope
  status: 200
}

export type getArtifactStatusSummaryResponse400 = {
  data: ErrorResponse
  status: 400
}

export type getArtifactStatusSummaryResponse401 = {
  data: ErrorResponse
  status: 401
}

export type getArtifactStatusSummaryResponse409 = {
  data: ErrorResponse
  status: 409
}

export type getArtifactStatusSummaryResponse500 = {
  data: ErrorResponse
  status: 500
}

export type getArtifactStatusSummaryResponseSuccess = (getArtifactStatusSummaryResponse200) & {
  headers: Headers;
};
export type getArtifactStatusSummaryResponseError = (getArtifactStatusSummaryResponse400 | getArtifactStatusSummaryResponse401 | getArtifactStatusSummaryResponse409 | getArtifactStatusSummaryResponse500) & {
  headers: Headers;
};

export type getArtifactStatusSummaryResponse = (getArtifactStatusSummaryResponseSuccess | getArtifactStatusSummaryResponseError)

export const getGetArtifactStatusSummaryUrl = (params: GetArtifactStatusSummaryParams,) => {
  const normalizedParams = new URLSearchParams();
  const deepObjectEntries: string[] = [];

  Object.entries(params || {}).forEach(([key, value]) => {
    const deepObjectParameters = ["scope"];

    if (typeof value === 'object' && value !== null && !Array.isArray(value) && deepObjectParameters.includes(key)) {
      Object.entries(value).forEach(([subKey, subValue]) => {
        if (subValue !== undefined) {
          deepObjectEntries.push(encodeURIComponent(key) + '[' + encodeURIComponent(subKey) + ']=' + (subValue === null ? 'null' : encodeURIComponent(String(subValue))));
        }
      });
      return;
    }


  });

  const stringifiedParams = [normalizedParams.toString(), deepObjectEntries.join('&')].filter(Boolean).join('&');

  return stringifiedParams.length > 0 ? `/v1/artifacts/status-summary?${stringifiedParams}` : `/v1/artifacts/status-summary`
}

/**
 * Count the artifacts in a scope, broken down by processing status.
 *
 * Define the scope with bracket notation (e.g. `scope[email_id]=abc-123`). At least one key is required; multiple keys are combined with AND logic.
 * @summary Get artifact status summary
 */
export const getArtifactStatusSummary = async (params: GetArtifactStatusSummaryParams, options?: RequestInit): Promise<getArtifactStatusSummaryResponse> => {

  const res = await fetch(getGetArtifactStatusSummaryUrl(params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getArtifactStatusSummaryResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getArtifactStatusSummaryResponse
}



export type getArtifactUploadUrlResponse200 = {
  data: GetArtifactUploadUrlEnvelope
  status: 200
}

export type getArtifactUploadUrlResponse400 = {
  data: ErrorResponse
  status: 400
}

export type getArtifactUploadUrlResponse401 = {
  data: ErrorResponse
  status: 401
}

export type getArtifactUploadUrlResponse409 = {
  data: ErrorResponse
  status: 409
}

export type getArtifactUploadUrlResponse500 = {
  data: ErrorResponse
  status: 500
}

export type getArtifactUploadUrlResponseSuccess = (getArtifactUploadUrlResponse200) & {
  headers: Headers;
};
export type getArtifactUploadUrlResponseError = (getArtifactUploadUrlResponse400 | getArtifactUploadUrlResponse401 | getArtifactUploadUrlResponse409 | getArtifactUploadUrlResponse500) & {
  headers: Headers;
};

export type getArtifactUploadUrlResponse = (getArtifactUploadUrlResponseSuccess | getArtifactUploadUrlResponseError)

export const getGetArtifactUploadUrlUrl = () => {




  return `/v1/artifacts/get-upload-url`
}

/**
 * Returns a pre-signed PUT URL. Upload the file directly to `upload_url`, then pass `file_url` as `source_url` to POST /v1/upload-file.
 * @summary Request a pre-signed URL for direct large file upload
 */
export const getArtifactUploadUrl = async (getArtifactUploadUrlBody?: GetArtifactUploadUrlBody, options?: RequestInit): Promise<getArtifactUploadUrlResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getGetArtifactUploadUrlUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(getArtifactUploadUrlBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getArtifactUploadUrlResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getArtifactUploadUrlResponse
}



export type updateArtifactMetadataResponse200 = {
  data: UpdateArtifactMetadataEnvelope
  status: 200
}

export type updateArtifactMetadataResponse400 = {
  data: ErrorResponse
  status: 400
}

export type updateArtifactMetadataResponse401 = {
  data: ErrorResponse
  status: 401
}

export type updateArtifactMetadataResponse404 = {
  data: ErrorResponse
  status: 404
}

export type updateArtifactMetadataResponse409 = {
  data: ErrorResponse
  status: 409
}

export type updateArtifactMetadataResponse500 = {
  data: ErrorResponse
  status: 500
}

export type updateArtifactMetadataResponseSuccess = (updateArtifactMetadataResponse200) & {
  headers: Headers;
};
export type updateArtifactMetadataResponseError = (updateArtifactMetadataResponse400 | updateArtifactMetadataResponse401 | updateArtifactMetadataResponse404 | updateArtifactMetadataResponse409 | updateArtifactMetadataResponse500) & {
  headers: Headers;
};

export type updateArtifactMetadataResponse = (updateArtifactMetadataResponseSuccess | updateArtifactMetadataResponseError)

export const getUpdateArtifactMetadataUrl = (id: string,) => {




  return `/v1/artifacts/${id}/metadata`
}

/**
 * Merge-update metadata on an existing artifact. Provided keys are added or overwritten; other existing keys are preserved.
 * @summary Update artifact metadata
 */
export const updateArtifactMetadata = async (id: string,
    updateArtifactMetadataBody?: UpdateArtifactMetadataBody, options?: RequestInit): Promise<updateArtifactMetadataResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getUpdateArtifactMetadataUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateArtifactMetadataBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: updateArtifactMetadataResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as updateArtifactMetadataResponse
}



export type signUpResponse200 = {
  data: SignUpEnvelope
  status: 200
}

export type signUpResponse400 = {
  data: ErrorResponse
  status: 400
}

export type signUpResponse401 = {
  data: ErrorResponse
  status: 401
}

export type signUpResponse409 = {
  data: ErrorResponse
  status: 409
}

export type signUpResponse500 = {
  data: ErrorResponse
  status: 500
}

export type signUpResponseSuccess = (signUpResponse200) & {
  headers: Headers;
};
export type signUpResponseError = (signUpResponse400 | signUpResponse401 | signUpResponse409 | signUpResponse500) & {
  headers: Headers;
};

export type signUpResponse = (signUpResponseSuccess | signUpResponseError)

export const getSignUpUrl = () => {




  return `/v1/auth/sign-up`
}

/**
 * Create a new user account with email and password. When the response includes a pending_authentication_token, the account requires email verification: complete it via sign-in (type: email_otp) with the emailed one-time password and this token.
 * @summary Sign up
 */
export const signUp = async (signUpBody?: SignUpBody, options?: RequestInit): Promise<signUpResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getSignUpUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(signUpBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: signUpResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as signUpResponse
}



export type signInResponse200 = {
  data: SignInEnvelope
  status: 200
}

export type signInResponse400 = {
  data: ErrorResponse
  status: 400
}

export type signInResponse401 = {
  data: ErrorResponse
  status: 401
}

export type signInResponse409 = {
  data: ErrorResponse
  status: 409
}

export type signInResponse500 = {
  data: ErrorResponse
  status: 500
}

export type signInResponseSuccess = (signInResponse200) & {
  headers: Headers;
};
export type signInResponseError = (signInResponse400 | signInResponse401 | signInResponse409 | signInResponse500) & {
  headers: Headers;
};

export type signInResponse = (signInResponseSuccess | signInResponseError)

export const getSignInUrl = () => {




  return `/v1/auth/sign-in`
}

/**
 * Authenticate using one of the supported methods:
 *
 * - **Password:** Email and password credentials. If the password is correct but the email is not verified yet, responds 403 with `data.pending_authentication_token` and a fresh verification code is emailed; complete verification via **Email OTP**. Each password attempt invalidates earlier codes and tokens, so always use the most recent pair — repeating the password sign-in is also how a new code is requested.
 * - **OAuth:** Authorization code from OAuth flow (social or enterprise SSO). Pass the `provider` the flow was started with so the code is exchanged against the system that issued it. `verifier` is only required when the flow was started with a `code_challenge` — see **Get OAuth sign-in URL**.
 * - **Email OTP:** One-time password sent to email. Include the `pending_authentication_token` from sign-up, or from the 403 returned by an unverified user's password sign-in, when completing email verification.
 * @summary Sign in
 */
export const signIn = async (signInBody?: SignInBody, options?: RequestInit): Promise<signInResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getSignInUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(signInBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: signInResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as signInResponse
}



export type requestPasswordResetResponse200 = {
  data: RequestPasswordResetEnvelope
  status: 200
}

export type requestPasswordResetResponse400 = {
  data: ErrorResponse
  status: 400
}

export type requestPasswordResetResponse401 = {
  data: ErrorResponse
  status: 401
}

export type requestPasswordResetResponse409 = {
  data: ErrorResponse
  status: 409
}

export type requestPasswordResetResponse500 = {
  data: ErrorResponse
  status: 500
}

export type requestPasswordResetResponseSuccess = (requestPasswordResetResponse200) & {
  headers: Headers;
};
export type requestPasswordResetResponseError = (requestPasswordResetResponse400 | requestPasswordResetResponse401 | requestPasswordResetResponse409 | requestPasswordResetResponse500) & {
  headers: Headers;
};

export type requestPasswordResetResponse = (requestPasswordResetResponseSuccess | requestPasswordResetResponseError)

export const getRequestPasswordResetUrl = () => {




  return `/v1/auth/request-password-reset`
}

/**
 * Start password recovery for an email/password account. When the email belongs to an account, a reset link is emailed to it. The response is 200 regardless, and does not reveal whether an account exists.
 * @summary Request password reset
 */
export const requestPasswordReset = async (requestPasswordResetBody?: RequestPasswordResetBody, options?: RequestInit): Promise<requestPasswordResetResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getRequestPasswordResetUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(requestPasswordResetBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: requestPasswordResetResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as requestPasswordResetResponse
}



export type resetPasswordResponse200 = {
  data: ResetPasswordEnvelope
  status: 200
}

export type resetPasswordResponse400 = {
  data: ErrorResponse
  status: 400
}

export type resetPasswordResponse401 = {
  data: ErrorResponse
  status: 401
}

export type resetPasswordResponse409 = {
  data: ErrorResponse
  status: 409
}

export type resetPasswordResponse500 = {
  data: ErrorResponse
  status: 500
}

export type resetPasswordResponseSuccess = (resetPasswordResponse200) & {
  headers: Headers;
};
export type resetPasswordResponseError = (resetPasswordResponse400 | resetPasswordResponse401 | resetPasswordResponse409 | resetPasswordResponse500) & {
  headers: Headers;
};

export type resetPasswordResponse = (resetPasswordResponseSuccess | resetPasswordResponseError)

export const getResetPasswordUrl = () => {




  return `/v1/auth/reset-password`
}

/**
 * Complete password recovery with the token from the emailed reset link and set a new password. Completing the reset also verifies the account's email address. Afterwards, sign in with the new password.
 * @summary Reset password
 */
export const resetPassword = async (resetPasswordBody?: ResetPasswordBody, options?: RequestInit): Promise<resetPasswordResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getResetPasswordUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(resetPasswordBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: resetPasswordResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as resetPasswordResponse
}



export type refreshTokenResponse200 = {
  data: RefreshTokenEnvelope
  status: 200
}

export type refreshTokenResponse400 = {
  data: ErrorResponse
  status: 400
}

export type refreshTokenResponse401 = {
  data: ErrorResponse
  status: 401
}

export type refreshTokenResponse409 = {
  data: ErrorResponse
  status: 409
}

export type refreshTokenResponse500 = {
  data: ErrorResponse
  status: 500
}

export type refreshTokenResponseSuccess = (refreshTokenResponse200) & {
  headers: Headers;
};
export type refreshTokenResponseError = (refreshTokenResponse400 | refreshTokenResponse401 | refreshTokenResponse409 | refreshTokenResponse500) & {
  headers: Headers;
};

export type refreshTokenResponse = (refreshTokenResponseSuccess | refreshTokenResponseError)

export const getRefreshTokenUrl = () => {




  return `/v1/auth/refresh-token`
}

/**
 * Exchange a valid access token and refresh token pair for new tokens.
 * @summary Refresh authentication token
 */
export const refreshToken = async (refreshTokenBody?: RefreshTokenBody, options?: RequestInit): Promise<refreshTokenResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getRefreshTokenUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(refreshTokenBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: refreshTokenResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as refreshTokenResponse
}



export type getOAuthUrlResponse200 = {
  data: GetOAuthUrlEnvelope
  status: 200
}

export type getOAuthUrlResponse400 = {
  data: ErrorResponse
  status: 400
}

export type getOAuthUrlResponse401 = {
  data: ErrorResponse
  status: 401
}

export type getOAuthUrlResponse409 = {
  data: ErrorResponse
  status: 409
}

export type getOAuthUrlResponse500 = {
  data: ErrorResponse
  status: 500
}

export type getOAuthUrlResponseSuccess = (getOAuthUrlResponse200) & {
  headers: Headers;
};
export type getOAuthUrlResponseError = (getOAuthUrlResponse400 | getOAuthUrlResponse401 | getOAuthUrlResponse409 | getOAuthUrlResponse500) & {
  headers: Headers;
};

export type getOAuthUrlResponse = (getOAuthUrlResponseSuccess | getOAuthUrlResponseError)

export const getGetOAuthUrlUrl = (params: GetOAuthUrlParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/auth/oauth-url?${stringifiedParams}` : `/v1/auth/oauth-url`
}

/**
 * Generate an OAuth authorization URL for a given provider.
 *
 * PKCE is optional. To use it, generate a random verifier, derive `code_challenge` from it, and pass both `code_challenge` and the matching `code_challenge_method` — then send the verifier to **Sign in** when exchanging the code. Omit both to run the flow without PKCE and exchange the code on its own.
 *
 * For enterprise SSO, pass `provider=sso` together with the user's `email`; the email domain selects the SSO organization. Responds 404 when no SSO organization is configured for the domain.
 * @summary Get OAuth sign-in URL
 */
export const getOAuthUrl = async (params: GetOAuthUrlParams, options?: RequestInit): Promise<getOAuthUrlResponse> => {

  const res = await fetch(getGetOAuthUrlUrl(params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getOAuthUrlResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getOAuthUrlResponse
}



export type getSessionTokenResponse200 = {
  data: GetSessionTokenEnvelope
  status: 200
}

export type getSessionTokenResponse400 = {
  data: ErrorResponse
  status: 400
}

export type getSessionTokenResponse401 = {
  data: ErrorResponse
  status: 401
}

export type getSessionTokenResponse409 = {
  data: ErrorResponse
  status: 409
}

export type getSessionTokenResponse500 = {
  data: ErrorResponse
  status: 500
}

export type getSessionTokenResponseSuccess = (getSessionTokenResponse200) & {
  headers: Headers;
};
export type getSessionTokenResponseError = (getSessionTokenResponse400 | getSessionTokenResponse401 | getSessionTokenResponse409 | getSessionTokenResponse500) & {
  headers: Headers;
};

export type getSessionTokenResponse = (getSessionTokenResponseSuccess | getSessionTokenResponseError)

export const getGetSessionTokenUrl = () => {




  return `/v1/auth/session`
}

/**
 * Exchange an identity token for a tenant-scoped Core Plane access token.
 *
 * - If `tenant_id` is provided, validates the user is a member of that tenant and returns 404 if they are not.
 * - If `tenant_id` is omitted, selects the tenant of the identity token's organization, falling back to the user's default (oldest) tenant.
 * - Call this endpoint again with a different `tenant_id` to switch tenants.
 * @summary Create or switch tenant session
 */
export const getSessionToken = async (getSessionTokenBody?: GetSessionTokenBody, options?: RequestInit): Promise<getSessionTokenResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getGetSessionTokenUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(getSessionTokenBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getSessionTokenResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getSessionTokenResponse
}



export type getPartnerJwksResponse200 = {
  data: PartnerJwks
  status: 200
}

export type getPartnerJwksResponse400 = {
  data: ErrorResponse
  status: 400
}

export type getPartnerJwksResponse401 = {
  data: ErrorResponse
  status: 401
}

export type getPartnerJwksResponse404 = {
  data: ErrorResponse
  status: 404
}

export type getPartnerJwksResponse409 = {
  data: ErrorResponse
  status: 409
}

export type getPartnerJwksResponse500 = {
  data: ErrorResponse
  status: 500
}

export type getPartnerJwksResponseSuccess = (getPartnerJwksResponse200) & {
  headers: Headers;
};
export type getPartnerJwksResponseError = (getPartnerJwksResponse400 | getPartnerJwksResponse401 | getPartnerJwksResponse404 | getPartnerJwksResponse409 | getPartnerJwksResponse500) & {
  headers: Headers;
};

export type getPartnerJwksResponse = (getPartnerJwksResponseSuccess | getPartnerJwksResponseError)

export const getGetPartnerJwksUrl = (partner: string,) => {




  return `/.well-known/partners/${partner}/jwks.json`
}

/**
 * Returns the JSON Web Key Set (RFC 7517) of a partner's public signing keys, used to verify partner-issued launch tokens.
 * @summary Get partner JWKS
 */
export const getPartnerJwks = async (partner: string, options?: RequestInit): Promise<getPartnerJwksResponse> => {

  const res = await fetch(getGetPartnerJwksUrl(partner),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getPartnerJwksResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getPartnerJwksResponse
}



export type partnerLaunchResponse302 = {
  data: PartnerLaunchEnvelope
  status: 302
}

export type partnerLaunchResponse400 = {
  data: ErrorResponse
  status: 400
}

export type partnerLaunchResponse401 = {
  data: ErrorResponse
  status: 401
}

export type partnerLaunchResponse409 = {
  data: ErrorResponse
  status: 409
}

export type partnerLaunchResponse500 = {
  data: ErrorResponse
  status: 500
}

;
export type partnerLaunchResponseError = (partnerLaunchResponse302 | partnerLaunchResponse400 | partnerLaunchResponse401 | partnerLaunchResponse409 | partnerLaunchResponse500) & {
  headers: Headers;
};

export type partnerLaunchResponse = (partnerLaunchResponseError)

export const getPartnerLaunchUrl = (params?: PartnerLaunchParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/auth/partner-launch?${stringifiedParams}` : `/v1/auth/partner-launch`
}

/**
 * Verifies a partner-signed launch token, mints an Avallon session, and redirects (302) the user into the app's handoff route, carrying the session token in the URL fragment (no cookie).
 * @summary Partner launch (SSO)
 */
export const partnerLaunch = async (params?: PartnerLaunchParams, options?: RequestInit): Promise<partnerLaunchResponse> => {

  const res = await fetch(getPartnerLaunchUrl(params),
  {
    ...options,
    method: 'POST'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: partnerLaunchResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as partnerLaunchResponse
}



export type listCallsResponse200 = {
  data: ListCallsEnvelope
  status: 200
}

export type listCallsResponse400 = {
  data: ErrorResponse
  status: 400
}

export type listCallsResponse401 = {
  data: ErrorResponse
  status: 401
}

export type listCallsResponse409 = {
  data: ErrorResponse
  status: 409
}

export type listCallsResponse500 = {
  data: ErrorResponse
  status: 500
}

export type listCallsResponseSuccess = (listCallsResponse200) & {
  headers: Headers;
};
export type listCallsResponseError = (listCallsResponse400 | listCallsResponse401 | listCallsResponse409 | listCallsResponse500) & {
  headers: Headers;
};

export type listCallsResponse = (listCallsResponseSuccess | listCallsResponseError)

export const getListCallsUrl = (params?: ListCallsParams,) => {
  const normalizedParams = new URLSearchParams();
  const deepObjectEntries: string[] = [];

  Object.entries(params || {}).forEach(([key, value]) => {
    const deepObjectParameters = ["metadata"];

    if (typeof value === 'object' && value !== null && !Array.isArray(value) && deepObjectParameters.includes(key)) {
      Object.entries(value).forEach(([subKey, subValue]) => {
        if (subValue !== undefined) {
          deepObjectEntries.push(encodeURIComponent(key) + '[' + encodeURIComponent(subKey) + ']=' + (subValue === null ? 'null' : encodeURIComponent(String(subValue))));
        }
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = [normalizedParams.toString(), deepObjectEntries.join('&')].filter(Boolean).join('&');

  return stringifiedParams.length > 0 ? `/v1/calls?${stringifiedParams}` : `/v1/calls`
}

/**
 * List all calls, with pagination, filtering, and sorting.
 *
 * **Filtering:**
 *
 * Filter by agent, direction, status, time range, phone number, and more. Phone number filter supports both exact E.164 matches and partial search.
 *
 * **Case Filtering:**
 *
 * Use `case_id` to return only calls linked to a case. This reads the case links created
 * via `POST /v1/cases/{caseId}/links`, and is independent of any `metadata.case_id` a
 * call may carry.
 *
 * **Metadata Filtering:**
 *
 * Use bracket notation to filter by metadata keys:
 * - `metadata[claim_id]=abc-123`
 * - `metadata[source]=worker`
 *
 * Multiple metadata filters can be combined (AND logic).
 * @summary List calls
 */
export const listCalls = async (params?: ListCallsParams, options?: RequestInit): Promise<listCallsResponse> => {

  const res = await fetch(getListCallsUrl(params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: listCallsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as listCallsResponse
}



export type getCallResponse200 = {
  data: GetCallEnvelope
  status: 200
}

export type getCallResponse400 = {
  data: ErrorResponse
  status: 400
}

export type getCallResponse401 = {
  data: ErrorResponse
  status: 401
}

export type getCallResponse404 = {
  data: ErrorResponse
  status: 404
}

export type getCallResponse409 = {
  data: ErrorResponse
  status: 409
}

export type getCallResponse500 = {
  data: ErrorResponse
  status: 500
}

export type getCallResponseSuccess = (getCallResponse200) & {
  headers: Headers;
};
export type getCallResponseError = (getCallResponse400 | getCallResponse401 | getCallResponse404 | getCallResponse409 | getCallResponse500) & {
  headers: Headers;
};

export type getCallResponse = (getCallResponseSuccess | getCallResponseError)

export const getGetCallUrl = (id: string,
    params?: GetCallParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/calls/${id}?${stringifiedParams}` : `/v1/calls/${id}`
}

/**
 * Retrieve detailed information about a specific call.
 *
 * Set `include_messages=true` to include the full message transcript.
 * @summary Get call
 */
export const getCall = async (id: string,
    params?: GetCallParams, options?: RequestInit): Promise<getCallResponse> => {

  const res = await fetch(getGetCallUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getCallResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getCallResponse
}



export type getCallEvaluationResponse200 = {
  data: GetCallEvaluationEnvelope
  status: 200
}

export type getCallEvaluationResponse400 = {
  data: ErrorResponse
  status: 400
}

export type getCallEvaluationResponse401 = {
  data: ErrorResponse
  status: 401
}

export type getCallEvaluationResponse404 = {
  data: ErrorResponse
  status: 404
}

export type getCallEvaluationResponse409 = {
  data: ErrorResponse
  status: 409
}

export type getCallEvaluationResponse500 = {
  data: ErrorResponse
  status: 500
}

export type getCallEvaluationResponseSuccess = (getCallEvaluationResponse200) & {
  headers: Headers;
};
export type getCallEvaluationResponseError = (getCallEvaluationResponse400 | getCallEvaluationResponse401 | getCallEvaluationResponse404 | getCallEvaluationResponse409 | getCallEvaluationResponse500) & {
  headers: Headers;
};

export type getCallEvaluationResponse = (getCallEvaluationResponseSuccess | getCallEvaluationResponseError)

export const getGetCallEvaluationUrl = (id: string,) => {




  return `/v1/calls/${id}/evaluation`
}

/**
 * Retrieve the evaluation results for a specific call, including overall score, pass status, and per-metric breakdowns.
 * @summary Get call evaluation
 */
export const getCallEvaluation = async (id: string, options?: RequestInit): Promise<getCallEvaluationResponse> => {

  const res = await fetch(getGetCallEvaluationUrl(id),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getCallEvaluationResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getCallEvaluationResponse
}



export type getCallAnalyticsResponse200 = {
  data: GetCallAnalyticsEnvelope
  status: 200
}

export type getCallAnalyticsResponse400 = {
  data: ErrorResponse
  status: 400
}

export type getCallAnalyticsResponse401 = {
  data: ErrorResponse
  status: 401
}

export type getCallAnalyticsResponse409 = {
  data: ErrorResponse
  status: 409
}

export type getCallAnalyticsResponse500 = {
  data: ErrorResponse
  status: 500
}

export type getCallAnalyticsResponseSuccess = (getCallAnalyticsResponse200) & {
  headers: Headers;
};
export type getCallAnalyticsResponseError = (getCallAnalyticsResponse400 | getCallAnalyticsResponse401 | getCallAnalyticsResponse409 | getCallAnalyticsResponse500) & {
  headers: Headers;
};

export type getCallAnalyticsResponse = (getCallAnalyticsResponseSuccess | getCallAnalyticsResponseError)

export const getGetCallAnalyticsUrl = (params: GetCallAnalyticsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/calls/analytics?${stringifiedParams}` : `/v1/calls/analytics`
}

/**
 * Retrieve aggregated call analytics for a time range.
 *
 * Includes summary statistics, call volume over time, evaluation scores, score and duration distributions, and per-metric performance.
 * @summary Get call analytics
 */
export const getCallAnalytics = async (params: GetCallAnalyticsParams, options?: RequestInit): Promise<getCallAnalyticsResponse> => {

  const res = await fetch(getGetCallAnalyticsUrl(params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getCallAnalyticsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getCallAnalyticsResponse
}



export type getAnalyticsTimeSeriesResponse200 = {
  data: GetAnalyticsTimeSeriesEnvelope
  status: 200
}

export type getAnalyticsTimeSeriesResponse400 = {
  data: ErrorResponse
  status: 400
}

export type getAnalyticsTimeSeriesResponse401 = {
  data: ErrorResponse
  status: 401
}

export type getAnalyticsTimeSeriesResponse409 = {
  data: ErrorResponse
  status: 409
}

export type getAnalyticsTimeSeriesResponse500 = {
  data: ErrorResponse
  status: 500
}

export type getAnalyticsTimeSeriesResponseSuccess = (getAnalyticsTimeSeriesResponse200) & {
  headers: Headers;
};
export type getAnalyticsTimeSeriesResponseError = (getAnalyticsTimeSeriesResponse400 | getAnalyticsTimeSeriesResponse401 | getAnalyticsTimeSeriesResponse409 | getAnalyticsTimeSeriesResponse500) & {
  headers: Headers;
};

export type getAnalyticsTimeSeriesResponse = (getAnalyticsTimeSeriesResponseSuccess | getAnalyticsTimeSeriesResponseError)

export const getGetAnalyticsTimeSeriesUrl = (params: GetAnalyticsTimeSeriesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/analytics/timeseries?${stringifiedParams}` : `/v1/analytics/timeseries`
}

/**
 * Retrieve a tenant-scoped time series for a single processing-volume metric.
 *
 * Pick a `metric` (worker runs, documents, or pages), a date range, a bucket `granularity` (day/week/month), and optionally a `group_by` dimension (e.g. worker runs grouped by worker). The series is sparse (only buckets with data) over the half-open window `[from, to)`.
 *
 * `data` is an array of per-metric results; today it always contains exactly one entry (the requested metric).
 * @summary Get analytics time series
 */
export const getAnalyticsTimeSeries = async (params: GetAnalyticsTimeSeriesParams, options?: RequestInit): Promise<getAnalyticsTimeSeriesResponse> => {

  const res = await fetch(getGetAnalyticsTimeSeriesUrl(params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getAnalyticsTimeSeriesResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getAnalyticsTimeSeriesResponse
}



export type createCallFeedbackResponse201 = {
  data: CreateCallFeedbackEnvelope
  status: 201
}

export type createCallFeedbackResponse400 = {
  data: ErrorResponse
  status: 400
}

export type createCallFeedbackResponse401 = {
  data: ErrorResponse
  status: 401
}

export type createCallFeedbackResponse404 = {
  data: ErrorResponse
  status: 404
}

export type createCallFeedbackResponse409 = {
  data: ErrorResponse
  status: 409
}

export type createCallFeedbackResponse500 = {
  data: ErrorResponse
  status: 500
}

export type createCallFeedbackResponseSuccess = (createCallFeedbackResponse201) & {
  headers: Headers;
};
export type createCallFeedbackResponseError = (createCallFeedbackResponse400 | createCallFeedbackResponse401 | createCallFeedbackResponse404 | createCallFeedbackResponse409 | createCallFeedbackResponse500) & {
  headers: Headers;
};

export type createCallFeedbackResponse = (createCallFeedbackResponseSuccess | createCallFeedbackResponseError)

export const getCreateCallFeedbackUrl = (id: string,) => {




  return `/v1/calls/${id}/feedback`
}

/**
 * Create feedback for a specific message in a call. Requires user (JWT) authentication; the author is derived from the authenticated user's profile and API-key callers are rejected.
 * @summary Create feedback on a call message
 */
export const createCallFeedback = async (id: string,
    createFeedbackRequest?: CreateFeedbackRequest, options?: RequestInit): Promise<createCallFeedbackResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getCreateCallFeedbackUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createFeedbackRequest)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: createCallFeedbackResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as createCallFeedbackResponse
}



export type listCallFeedbackResponse200 = {
  data: ListCallFeedbackEnvelope
  status: 200
}

export type listCallFeedbackResponse400 = {
  data: ErrorResponse
  status: 400
}

export type listCallFeedbackResponse401 = {
  data: ErrorResponse
  status: 401
}

export type listCallFeedbackResponse404 = {
  data: ErrorResponse
  status: 404
}

export type listCallFeedbackResponse409 = {
  data: ErrorResponse
  status: 409
}

export type listCallFeedbackResponse500 = {
  data: ErrorResponse
  status: 500
}

export type listCallFeedbackResponseSuccess = (listCallFeedbackResponse200) & {
  headers: Headers;
};
export type listCallFeedbackResponseError = (listCallFeedbackResponse400 | listCallFeedbackResponse401 | listCallFeedbackResponse404 | listCallFeedbackResponse409 | listCallFeedbackResponse500) & {
  headers: Headers;
};

export type listCallFeedbackResponse = (listCallFeedbackResponseSuccess | listCallFeedbackResponseError)

export const getListCallFeedbackUrl = (id: string,
    params?: ListCallFeedbackParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/calls/${id}/feedback?${stringifiedParams}` : `/v1/calls/${id}/feedback`
}

/**
 * List all feedback for a call. Paginated.
 * @summary List feedback for a call
 */
export const listCallFeedback = async (id: string,
    params?: ListCallFeedbackParams, options?: RequestInit): Promise<listCallFeedbackResponse> => {

  const res = await fetch(getListCallFeedbackUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: listCallFeedbackResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as listCallFeedbackResponse
}



export type deleteCallFeedbackResponse200 = {
  data: DeleteCallFeedbackEnvelope
  status: 200
}

export type deleteCallFeedbackResponse400 = {
  data: ErrorResponse
  status: 400
}

export type deleteCallFeedbackResponse401 = {
  data: ErrorResponse
  status: 401
}

export type deleteCallFeedbackResponse404 = {
  data: ErrorResponse
  status: 404
}

export type deleteCallFeedbackResponse409 = {
  data: ErrorResponse
  status: 409
}

export type deleteCallFeedbackResponse500 = {
  data: ErrorResponse
  status: 500
}

export type deleteCallFeedbackResponseSuccess = (deleteCallFeedbackResponse200) & {
  headers: Headers;
};
export type deleteCallFeedbackResponseError = (deleteCallFeedbackResponse400 | deleteCallFeedbackResponse401 | deleteCallFeedbackResponse404 | deleteCallFeedbackResponse409 | deleteCallFeedbackResponse500) & {
  headers: Headers;
};

export type deleteCallFeedbackResponse = (deleteCallFeedbackResponseSuccess | deleteCallFeedbackResponseError)

export const getDeleteCallFeedbackUrl = (id: string,
    feedbackId: string,) => {




  return `/v1/calls/${id}/feedback/${feedbackId}`
}

/**
 * Delete a single feedback entry.
 * @summary Delete feedback
 */
export const deleteCallFeedback = async (id: string,
    feedbackId: string, options?: RequestInit): Promise<deleteCallFeedbackResponse> => {

  const res = await fetch(getDeleteCallFeedbackUrl(id,feedbackId),
  {
    ...options,
    method: 'DELETE'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: deleteCallFeedbackResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as deleteCallFeedbackResponse
}



export type checkInboxAvailabilityResponse200 = {
  data: CheckInboxAvailabilityEnvelope
  status: 200
}

export type checkInboxAvailabilityResponse400 = {
  data: ErrorResponse
  status: 400
}

export type checkInboxAvailabilityResponse401 = {
  data: ErrorResponse
  status: 401
}

export type checkInboxAvailabilityResponse409 = {
  data: ErrorResponse
  status: 409
}

export type checkInboxAvailabilityResponse500 = {
  data: ErrorResponse
  status: 500
}

export type checkInboxAvailabilityResponseSuccess = (checkInboxAvailabilityResponse200) & {
  headers: Headers;
};
export type checkInboxAvailabilityResponseError = (checkInboxAvailabilityResponse400 | checkInboxAvailabilityResponse401 | checkInboxAvailabilityResponse409 | checkInboxAvailabilityResponse500) & {
  headers: Headers;
};

export type checkInboxAvailabilityResponse = (checkInboxAvailabilityResponseSuccess | checkInboxAvailabilityResponseError)

export const getCheckInboxAvailabilityUrl = (params: CheckInboxAvailabilityParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/inboxes/availability?${stringifiedParams}` : `/v1/inboxes/availability`
}

/**
 * Check whether a given email username is available for creating a new inbox.
 *
 * For compatibility this endpoint is also available using the following (deprecated) paths:
 * `GET /v1/email-agents/availability`
 * @summary Check email username availability
 */
export const checkInboxAvailability = async (params: CheckInboxAvailabilityParams, options?: RequestInit): Promise<checkInboxAvailabilityResponse> => {

  const res = await fetch(getCheckInboxAvailabilityUrl(params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: checkInboxAvailabilityResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as checkInboxAvailabilityResponse
}



export type createInboxResponse200 = {
  data: CreateInboxEnvelope
  status: 200
}

export type createInboxResponse400 = {
  data: ErrorResponse
  status: 400
}

export type createInboxResponse401 = {
  data: ErrorResponse
  status: 401
}

export type createInboxResponse409 = {
  data: ErrorResponse
  status: 409
}

export type createInboxResponse500 = {
  data: ErrorResponse
  status: 500
}

export type createInboxResponseSuccess = (createInboxResponse200) & {
  headers: Headers;
};
export type createInboxResponseError = (createInboxResponse400 | createInboxResponse401 | createInboxResponse409 | createInboxResponse500) & {
  headers: Headers;
};

export type createInboxResponse = (createInboxResponseSuccess | createInboxResponseError)

export const getCreateInboxUrl = () => {




  return `/v1/inboxes`
}

/**
 * Create a new inbox linked to a processor (extractor or worker).
 *
 * The inbox will receive emails at the assigned address and automatically process attachments using the specified processor.
 *
 * Either `processor_id` or the deprecated `extractor_id` must be provided. When using `extractor_id`, the processor type defaults to `extractor`.
 *
 * For compatibility this endpoint is also available using the following (deprecated) paths:
 * `POST /v1/email-agents`
 * @summary Create inbox
 */
export const createInbox = async (createInboxBody?: CreateInboxBody, options?: RequestInit): Promise<createInboxResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getCreateInboxUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createInboxBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: createInboxResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as createInboxResponse
}



export type listInboxesResponse200 = {
  data: ListInboxesEnvelope
  status: 200
}

export type listInboxesResponse400 = {
  data: ErrorResponse
  status: 400
}

export type listInboxesResponse401 = {
  data: ErrorResponse
  status: 401
}

export type listInboxesResponse409 = {
  data: ErrorResponse
  status: 409
}

export type listInboxesResponse500 = {
  data: ErrorResponse
  status: 500
}

export type listInboxesResponseSuccess = (listInboxesResponse200) & {
  headers: Headers;
};
export type listInboxesResponseError = (listInboxesResponse400 | listInboxesResponse401 | listInboxesResponse409 | listInboxesResponse500) & {
  headers: Headers;
};

export type listInboxesResponse = (listInboxesResponseSuccess | listInboxesResponseError)

export const getListInboxesUrl = (params?: ListInboxesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/inboxes?${stringifiedParams}` : `/v1/inboxes`
}

/**
 * List all inboxes with pagination and sorting.
 *
 * For compatibility this endpoint is also available using the following (deprecated) paths:
 * `GET /v1/email-agents`
 * @summary List inboxes
 */
export const listInboxes = async (params?: ListInboxesParams, options?: RequestInit): Promise<listInboxesResponse> => {

  const res = await fetch(getListInboxesUrl(params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: listInboxesResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as listInboxesResponse
}



export type updateInboxResponse200 = {
  data: UpdateInboxEnvelope
  status: 200
}

export type updateInboxResponse400 = {
  data: ErrorResponse
  status: 400
}

export type updateInboxResponse401 = {
  data: ErrorResponse
  status: 401
}

export type updateInboxResponse404 = {
  data: ErrorResponse
  status: 404
}

export type updateInboxResponse409 = {
  data: ErrorResponse
  status: 409
}

export type updateInboxResponse500 = {
  data: ErrorResponse
  status: 500
}

export type updateInboxResponseSuccess = (updateInboxResponse200) & {
  headers: Headers;
};
export type updateInboxResponseError = (updateInboxResponse400 | updateInboxResponse401 | updateInboxResponse404 | updateInboxResponse409 | updateInboxResponse500) & {
  headers: Headers;
};

export type updateInboxResponse = (updateInboxResponseSuccess | updateInboxResponseError)

export const getUpdateInboxUrl = (inboxId: string,) => {




  return `/v1/inboxes/${inboxId}`
}

/**
 * Update an inbox's configuration.
 *
 * For compatibility this endpoint is also available using the following (deprecated) paths:
 * `PATCH /v1/email-agents/{id}`
 * @summary Update inbox
 */
export const updateInbox = async (inboxId: string,
    updateInboxBody?: UpdateInboxBody, options?: RequestInit): Promise<updateInboxResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getUpdateInboxUrl(inboxId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateInboxBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: updateInboxResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as updateInboxResponse
}



export type deleteInboxResponse200 = {
  data: DeleteInboxEnvelope
  status: 200
}

export type deleteInboxResponse400 = {
  data: ErrorResponse
  status: 400
}

export type deleteInboxResponse401 = {
  data: ErrorResponse
  status: 401
}

export type deleteInboxResponse404 = {
  data: ErrorResponse
  status: 404
}

export type deleteInboxResponse409 = {
  data: ErrorResponse
  status: 409
}

export type deleteInboxResponse500 = {
  data: ErrorResponse
  status: 500
}

export type deleteInboxResponseSuccess = (deleteInboxResponse200) & {
  headers: Headers;
};
export type deleteInboxResponseError = (deleteInboxResponse400 | deleteInboxResponse401 | deleteInboxResponse404 | deleteInboxResponse409 | deleteInboxResponse500) & {
  headers: Headers;
};

export type deleteInboxResponse = (deleteInboxResponseSuccess | deleteInboxResponseError)

export const getDeleteInboxUrl = (inboxId: string,) => {




  return `/v1/inboxes/${inboxId}`
}

/**
 * Delete an inbox. The inbox stops routing new mail; existing email history is preserved.
 * @summary Delete inbox
 */
export const deleteInbox = async (inboxId: string, options?: RequestInit): Promise<deleteInboxResponse> => {

  const res = await fetch(getDeleteInboxUrl(inboxId),
  {
    ...options,
    method: 'DELETE'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: deleteInboxResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as deleteInboxResponse
}



export type getEmailResponse200 = {
  data: GetEmailEnvelope
  status: 200
}

export type getEmailResponse400 = {
  data: ErrorResponse
  status: 400
}

export type getEmailResponse401 = {
  data: ErrorResponse
  status: 401
}

export type getEmailResponse404 = {
  data: ErrorResponse
  status: 404
}

export type getEmailResponse409 = {
  data: ErrorResponse
  status: 409
}

export type getEmailResponse500 = {
  data: ErrorResponse
  status: 500
}

export type getEmailResponseSuccess = (getEmailResponse200) & {
  headers: Headers;
};
export type getEmailResponseError = (getEmailResponse400 | getEmailResponse401 | getEmailResponse404 | getEmailResponse409 | getEmailResponse500) & {
  headers: Headers;
};

export type getEmailResponse = (getEmailResponseSuccess | getEmailResponseError)

export const getGetEmailUrl = (emailId: string,) => {




  return `/v1/emails/${emailId}`
}

/**
 * Retrieve detailed information about a specific email, including full body content.
 * @summary Get email
 */
export const getEmail = async (emailId: string, options?: RequestInit): Promise<getEmailResponse> => {

  const res = await fetch(getGetEmailUrl(emailId),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getEmailResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getEmailResponse
}



export type deleteEmailResponse200 = {
  data: DeleteEmailEnvelope
  status: 200
}

export type deleteEmailResponse400 = {
  data: ErrorResponse
  status: 400
}

export type deleteEmailResponse401 = {
  data: ErrorResponse
  status: 401
}

export type deleteEmailResponse404 = {
  data: ErrorResponse
  status: 404
}

export type deleteEmailResponse409 = {
  data: ErrorResponse
  status: 409
}

export type deleteEmailResponse500 = {
  data: ErrorResponse
  status: 500
}

export type deleteEmailResponseSuccess = (deleteEmailResponse200) & {
  headers: Headers;
};
export type deleteEmailResponseError = (deleteEmailResponse400 | deleteEmailResponse401 | deleteEmailResponse404 | deleteEmailResponse409 | deleteEmailResponse500) & {
  headers: Headers;
};

export type deleteEmailResponse = (deleteEmailResponseSuccess | deleteEmailResponseError)

export const getDeleteEmailUrl = (emailId: string,) => {




  return `/v1/emails/${emailId}`
}

/**
 * Soft-delete an email. The message is hidden from all reads (get, list, and thread aggregation) but its content is retained until a separate hard purge.
 * @summary Delete email
 */
export const deleteEmail = async (emailId: string, options?: RequestInit): Promise<deleteEmailResponse> => {

  const res = await fetch(getDeleteEmailUrl(emailId),
  {
    ...options,
    method: 'DELETE'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: deleteEmailResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as deleteEmailResponse
}



export type listEmailsResponse200 = {
  data: ListEmailsEnvelope
  status: 200
}

export type listEmailsResponse400 = {
  data: ErrorResponse
  status: 400
}

export type listEmailsResponse401 = {
  data: ErrorResponse
  status: 401
}

export type listEmailsResponse409 = {
  data: ErrorResponse
  status: 409
}

export type listEmailsResponse500 = {
  data: ErrorResponse
  status: 500
}

export type listEmailsResponseSuccess = (listEmailsResponse200) & {
  headers: Headers;
};
export type listEmailsResponseError = (listEmailsResponse400 | listEmailsResponse401 | listEmailsResponse409 | listEmailsResponse500) & {
  headers: Headers;
};

export type listEmailsResponse = (listEmailsResponseSuccess | listEmailsResponseError)

export const getListEmailsUrl = (params?: ListEmailsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/emails?${stringifiedParams}` : `/v1/emails`
}

/**
 * List all emails with pagination and filtering.
 *
 * **Filtering:**
 *
 * Filter by email agent, sender, recipient, content search, or case.
 * @summary List emails
 */
export const listEmails = async (params?: ListEmailsParams, options?: RequestInit): Promise<listEmailsResponse> => {

  const res = await fetch(getListEmailsUrl(params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: listEmailsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as listEmailsResponse
}



export type listEmailThreadsResponse200 = {
  data: ListEmailThreadsEnvelope
  status: 200
}

export type listEmailThreadsResponse400 = {
  data: ErrorResponse
  status: 400
}

export type listEmailThreadsResponse401 = {
  data: ErrorResponse
  status: 401
}

export type listEmailThreadsResponse409 = {
  data: ErrorResponse
  status: 409
}

export type listEmailThreadsResponse500 = {
  data: ErrorResponse
  status: 500
}

export type listEmailThreadsResponseSuccess = (listEmailThreadsResponse200) & {
  headers: Headers;
};
export type listEmailThreadsResponseError = (listEmailThreadsResponse400 | listEmailThreadsResponse401 | listEmailThreadsResponse409 | listEmailThreadsResponse500) & {
  headers: Headers;
};

export type listEmailThreadsResponse = (listEmailThreadsResponseSuccess | listEmailThreadsResponseError)

export const getListEmailThreadsUrl = (params?: ListEmailThreadsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/emails/threads?${stringifiedParams}` : `/v1/emails/threads`
}

/**
 * List email threads with pagination. Each thread includes the subject of the first email, the sender of the first email, and the date of the last email.
 *
 * **Filtering:**
 *
 * Filter by inbox or environment. Without an `environment` filter, live and test threads are returned together.
 * @summary List email threads
 */
export const listEmailThreads = async (params?: ListEmailThreadsParams, options?: RequestInit): Promise<listEmailThreadsResponse> => {

  const res = await fetch(getListEmailThreadsUrl(params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: listEmailThreadsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as listEmailThreadsResponse
}



export type replyToEmailResponse200 = {
  data: ReplyToEmailEnvelope
  status: 200
}

export type replyToEmailResponse400 = {
  data: ErrorResponse
  status: 400
}

export type replyToEmailResponse401 = {
  data: ErrorResponse
  status: 401
}

export type replyToEmailResponse404 = {
  data: ErrorResponse
  status: 404
}

export type replyToEmailResponse409 = {
  data: ErrorResponse
  status: 409
}

export type replyToEmailResponse500 = {
  data: ErrorResponse
  status: 500
}

export type replyToEmailResponseSuccess = (replyToEmailResponse200) & {
  headers: Headers;
};
export type replyToEmailResponseError = (replyToEmailResponse400 | replyToEmailResponse401 | replyToEmailResponse404 | replyToEmailResponse409 | replyToEmailResponse500) & {
  headers: Headers;
};

export type replyToEmailResponse = (replyToEmailResponseSuccess | replyToEmailResponseError)

export const getReplyToEmailUrl = (emailId: string,) => {




  return `/v1/emails/${emailId}/reply`
}

/**
 * Reply to an existing email thread via Nylas. The reply is sent to the original sender by default.
 *
 * Optionally include additional recipients via `to` (merged with the original sender), `cc`, and `bcc` arrays.
 *
 * The `body` is HTML by default. Set `is_html` to `false` to provide plain text instead; it is converted to HTML before sending.
 * @summary Reply to email
 */
export const replyToEmail = async (emailId: string,
    replyToEmailBody?: ReplyToEmailBody, options?: RequestInit): Promise<replyToEmailResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getReplyToEmailUrl(emailId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(replyToEmailBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: replyToEmailResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as replyToEmailResponse
}



export type sendEmailResponse200 = {
  data: SendEmailEnvelope
  status: 200
}

export type sendEmailResponse400 = {
  data: ErrorResponse
  status: 400
}

export type sendEmailResponse401 = {
  data: ErrorResponse
  status: 401
}

export type sendEmailResponse409 = {
  data: ErrorResponse
  status: 409
}

export type sendEmailResponse500 = {
  data: ErrorResponse
  status: 500
}

export type sendEmailResponseSuccess = (sendEmailResponse200) & {
  headers: Headers;
};
export type sendEmailResponseError = (sendEmailResponse400 | sendEmailResponse401 | sendEmailResponse409 | sendEmailResponse500) & {
  headers: Headers;
};

export type sendEmailResponse = (sendEmailResponseSuccess | sendEmailResponseError)

export const getSendEmailUrl = () => {




  return `/v1/emails/send`
}

/**
 * Send a new email through an inbox. The provider-assigned thread id is returned and persisted on the stored email row, so subsequent inbound replies on that thread are linked to this send.
 *
 * The `body` is HTML by default. Set `is_html` to `false` to provide plain text instead; it is converted to HTML before sending.
 * @summary Send email
 */
export const sendEmail = async (sendEmailBody?: SendEmailBody, options?: RequestInit): Promise<sendEmailResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getSendEmailUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(sendEmailBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: sendEmailResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as sendEmailResponse
}



export type listExtractorJobsResponse200 = {
  data: ListExtractorJobsEnvelope
  status: 200
}

export type listExtractorJobsResponse400 = {
  data: ErrorResponse
  status: 400
}

export type listExtractorJobsResponse401 = {
  data: ErrorResponse
  status: 401
}

export type listExtractorJobsResponse409 = {
  data: ErrorResponse
  status: 409
}

export type listExtractorJobsResponse500 = {
  data: ErrorResponse
  status: 500
}

export type listExtractorJobsResponseSuccess = (listExtractorJobsResponse200) & {
  headers: Headers;
};
export type listExtractorJobsResponseError = (listExtractorJobsResponse400 | listExtractorJobsResponse401 | listExtractorJobsResponse409 | listExtractorJobsResponse500) & {
  headers: Headers;
};

export type listExtractorJobsResponse = (listExtractorJobsResponseSuccess | listExtractorJobsResponseError)

export const getListExtractorJobsUrl = (params?: ListExtractorJobsParams,) => {
  const normalizedParams = new URLSearchParams();
  const deepObjectEntries: string[] = [];

  Object.entries(params || {}).forEach(([key, value]) => {
    const deepObjectParameters = ["scope"];

    if (typeof value === 'object' && value !== null && !Array.isArray(value) && deepObjectParameters.includes(key)) {
      Object.entries(value).forEach(([subKey, subValue]) => {
        if (subValue !== undefined) {
          deepObjectEntries.push(encodeURIComponent(key) + '[' + encodeURIComponent(subKey) + ']=' + (subValue === null ? 'null' : encodeURIComponent(String(subValue))));
        }
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = [normalizedParams.toString(), deepObjectEntries.join('&')].filter(Boolean).join('&');

  return stringifiedParams.length > 0 ? `/v1/extractor-jobs?${stringifiedParams}` : `/v1/extractor-jobs`
}

/**
 * List all extraction jobs with pagination, filtering, and sorting.
 *
 * **Scope Filtering:**
 *
 * Use bracket notation to filter by scope keys:
 * - `scope[call_id]=abc-123`
 * - `scope[email_id]=xyz-456`
 * - `scope[case_id]=case-789`
 *
 * Multiple scope filters can be combined (AND logic).
 * @summary List extractor jobs
 */
export const listExtractorJobs = async (params?: ListExtractorJobsParams, options?: RequestInit): Promise<listExtractorJobsResponse> => {

  const res = await fetch(getListExtractorJobsUrl(params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: listExtractorJobsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as listExtractorJobsResponse
}



export type createExtractorJobResponse200 = {
  data: CreateExtractorJobEnvelope
  status: 200
}

export type createExtractorJobResponse400 = {
  data: ErrorResponse
  status: 400
}

export type createExtractorJobResponse401 = {
  data: ErrorResponse
  status: 401
}

export type createExtractorJobResponse409 = {
  data: ErrorResponse
  status: 409
}

export type createExtractorJobResponse500 = {
  data: ErrorResponse
  status: 500
}

export type createExtractorJobResponseSuccess = (createExtractorJobResponse200) & {
  headers: Headers;
};
export type createExtractorJobResponseError = (createExtractorJobResponse400 | createExtractorJobResponse401 | createExtractorJobResponse409 | createExtractorJobResponse500) & {
  headers: Headers;
};

export type createExtractorJobResponse = (createExtractorJobResponseSuccess | createExtractorJobResponseError)

export const getCreateExtractorJobUrl = () => {




  return `/v1/extractor-jobs`
}

/**
 * Create a new extraction job for the specified extractor.
 *
 * Provide a non-empty `scope` object to define what the extractor should process (e.g. `{ "claim_id": "abc-123" }`).
 * @summary Create extractor job
 */
export const createExtractorJob = async (createExtractorJobBody?: CreateExtractorJobBody, options?: RequestInit): Promise<createExtractorJobResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getCreateExtractorJobUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createExtractorJobBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: createExtractorJobResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as createExtractorJobResponse
}



export type getExtractorJobResponse200 = {
  data: GetExtractorJobEnvelope
  status: 200
}

export type getExtractorJobResponse400 = {
  data: ErrorResponse
  status: 400
}

export type getExtractorJobResponse401 = {
  data: ErrorResponse
  status: 401
}

export type getExtractorJobResponse404 = {
  data: ErrorResponse
  status: 404
}

export type getExtractorJobResponse409 = {
  data: ErrorResponse
  status: 409
}

export type getExtractorJobResponse500 = {
  data: ErrorResponse
  status: 500
}

export type getExtractorJobResponseSuccess = (getExtractorJobResponse200) & {
  headers: Headers;
};
export type getExtractorJobResponseError = (getExtractorJobResponse400 | getExtractorJobResponse401 | getExtractorJobResponse404 | getExtractorJobResponse409 | getExtractorJobResponse500) & {
  headers: Headers;
};

export type getExtractorJobResponse = (getExtractorJobResponseSuccess | getExtractorJobResponseError)

export const getGetExtractorJobUrl = (id: string,) => {




  return `/v1/extractor-jobs/${id}`
}

/**
 * Retrieve detailed information about a specific extractor job, including its status, timing, and result.
 * @summary Get extractor job
 */
export const getExtractorJob = async (id: string, options?: RequestInit): Promise<getExtractorJobResponse> => {

  const res = await fetch(getGetExtractorJobUrl(id),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getExtractorJobResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getExtractorJobResponse
}



export type listWorkerRunsResponse200 = {
  data: ListWorkerRunsEnvelope
  status: 200
}

export type listWorkerRunsResponse400 = {
  data: ErrorResponse
  status: 400
}

export type listWorkerRunsResponse401 = {
  data: ErrorResponse
  status: 401
}

export type listWorkerRunsResponse409 = {
  data: ErrorResponse
  status: 409
}

export type listWorkerRunsResponse500 = {
  data: ErrorResponse
  status: 500
}

export type listWorkerRunsResponseSuccess = (listWorkerRunsResponse200) & {
  headers: Headers;
};
export type listWorkerRunsResponseError = (listWorkerRunsResponse400 | listWorkerRunsResponse401 | listWorkerRunsResponse409 | listWorkerRunsResponse500) & {
  headers: Headers;
};

export type listWorkerRunsResponse = (listWorkerRunsResponseSuccess | listWorkerRunsResponseError)

export const getListWorkerRunsUrl = (params?: ListWorkerRunsParams,) => {
  const normalizedParams = new URLSearchParams();
  const deepObjectEntries: string[] = [];

  Object.entries(params || {}).forEach(([key, value]) => {
    const deepObjectParameters = ["scope"];

    if (typeof value === 'object' && value !== null && !Array.isArray(value) && deepObjectParameters.includes(key)) {
      Object.entries(value).forEach(([subKey, subValue]) => {
        if (subValue !== undefined) {
          deepObjectEntries.push(encodeURIComponent(key) + '[' + encodeURIComponent(subKey) + ']=' + (subValue === null ? 'null' : encodeURIComponent(String(subValue))));
        }
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = [normalizedParams.toString(), deepObjectEntries.join('&')].filter(Boolean).join('&');

  return stringifiedParams.length > 0 ? `/v1/worker-runs?${stringifiedParams}` : `/v1/worker-runs`
}

/**
 * List all worker runs with pagination, filtering, and sorting.
 *
 * **Scope Filtering:**
 *
 * Use bracket notation to filter by scope keys:
 * - `scope[call_id]=abc-123`
 * - `scope[email_id]=xyz-456`
 *
 * Multiple scope filters can be combined (AND logic).
 * @summary List worker runs
 */
export const listWorkerRuns = async (params?: ListWorkerRunsParams, options?: RequestInit): Promise<listWorkerRunsResponse> => {

  const res = await fetch(getListWorkerRunsUrl(params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: listWorkerRunsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as listWorkerRunsResponse
}



export type createWorkerRunResponse200 = {
  data: CreateWorkerRunEnvelope
  status: 200
}

export type createWorkerRunResponse400 = {
  data: ErrorResponse
  status: 400
}

export type createWorkerRunResponse401 = {
  data: ErrorResponse
  status: 401
}

export type createWorkerRunResponse409 = {
  data: ErrorResponse
  status: 409
}

export type createWorkerRunResponse500 = {
  data: ErrorResponse
  status: 500
}

export type createWorkerRunResponseSuccess = (createWorkerRunResponse200) & {
  headers: Headers;
};
export type createWorkerRunResponseError = (createWorkerRunResponse400 | createWorkerRunResponse401 | createWorkerRunResponse409 | createWorkerRunResponse500) & {
  headers: Headers;
};

export type createWorkerRunResponse = (createWorkerRunResponseSuccess | createWorkerRunResponseError)

export const getCreateWorkerRunUrl = () => {




  return `/v1/worker-runs`
}

/**
 * Create a new worker run for the specified worker.
 *
 * Provide a `scope` object with at least one key to define which artifacts the worker should process (e.g. `{ "claim_id": "abc-123" }`). The run stays `pending` until those artifacts are ready.
 *
 * Pass `null` to run the worker without any artifacts — the run is queued immediately. An empty object is rejected.
 * @summary Create worker run
 */
export const createWorkerRun = async (createWorkerRunBody?: CreateWorkerRunBody, options?: RequestInit): Promise<createWorkerRunResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getCreateWorkerRunUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createWorkerRunBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: createWorkerRunResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as createWorkerRunResponse
}



export type getWorkerRunResponse200 = {
  data: GetWorkerRunEnvelope
  status: 200
}

export type getWorkerRunResponse400 = {
  data: ErrorResponse
  status: 400
}

export type getWorkerRunResponse401 = {
  data: ErrorResponse
  status: 401
}

export type getWorkerRunResponse404 = {
  data: ErrorResponse
  status: 404
}

export type getWorkerRunResponse409 = {
  data: ErrorResponse
  status: 409
}

export type getWorkerRunResponse500 = {
  data: ErrorResponse
  status: 500
}

export type getWorkerRunResponseSuccess = (getWorkerRunResponse200) & {
  headers: Headers;
};
export type getWorkerRunResponseError = (getWorkerRunResponse400 | getWorkerRunResponse401 | getWorkerRunResponse404 | getWorkerRunResponse409 | getWorkerRunResponse500) & {
  headers: Headers;
};

export type getWorkerRunResponse = (getWorkerRunResponseSuccess | getWorkerRunResponseError)

export const getGetWorkerRunUrl = (workerRunId: string,) => {




  return `/v1/worker-runs/${workerRunId}`
}

/**
 * Retrieve detailed information about a specific worker run, including its status, timing, and errors.
 * @summary Get worker run
 */
export const getWorkerRun = async (workerRunId: string, options?: RequestInit): Promise<getWorkerRunResponse> => {

  const res = await fetch(getGetWorkerRunUrl(workerRunId),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getWorkerRunResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getWorkerRunResponse
}



export type listWorkerRunMessagesResponse200 = {
  data: ListWorkerRunMessagesEnvelope
  status: 200
}

export type listWorkerRunMessagesResponse400 = {
  data: ErrorResponse
  status: 400
}

export type listWorkerRunMessagesResponse401 = {
  data: ErrorResponse
  status: 401
}

export type listWorkerRunMessagesResponse404 = {
  data: ErrorResponse
  status: 404
}

export type listWorkerRunMessagesResponse409 = {
  data: ErrorResponse
  status: 409
}

export type listWorkerRunMessagesResponse500 = {
  data: ErrorResponse
  status: 500
}

export type listWorkerRunMessagesResponseSuccess = (listWorkerRunMessagesResponse200) & {
  headers: Headers;
};
export type listWorkerRunMessagesResponseError = (listWorkerRunMessagesResponse400 | listWorkerRunMessagesResponse401 | listWorkerRunMessagesResponse404 | listWorkerRunMessagesResponse409 | listWorkerRunMessagesResponse500) & {
  headers: Headers;
};

export type listWorkerRunMessagesResponse = (listWorkerRunMessagesResponseSuccess | listWorkerRunMessagesResponseError)

export const getListWorkerRunMessagesUrl = (workerRunId: string,
    params?: ListWorkerRunMessagesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/worker-runs/${workerRunId}/messages?${stringifiedParams}` : `/v1/worker-runs/${workerRunId}/messages`
}

/**
 * Retrieve messages emitted during a worker run, ordered by emission time. Supports cursor-style pagination via `after` and `count`.
 * @summary List worker run messages
 */
export const listWorkerRunMessages = async (workerRunId: string,
    params?: ListWorkerRunMessagesParams, options?: RequestInit): Promise<listWorkerRunMessagesResponse> => {

  const res = await fetch(getListWorkerRunMessagesUrl(workerRunId,params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: listWorkerRunMessagesResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as listWorkerRunMessagesResponse
}



export type cancelWorkerRunResponse200 = {
  data: CancelWorkerRunEnvelope
  status: 200
}

export type cancelWorkerRunResponse400 = {
  data: ErrorResponse
  status: 400
}

export type cancelWorkerRunResponse401 = {
  data: ErrorResponse
  status: 401
}

export type cancelWorkerRunResponse404 = {
  data: ErrorResponse
  status: 404
}

export type cancelWorkerRunResponse409 = {
  data: ErrorResponse
  status: 409
}

export type cancelWorkerRunResponse500 = {
  data: ErrorResponse
  status: 500
}

export type cancelWorkerRunResponseSuccess = (cancelWorkerRunResponse200) & {
  headers: Headers;
};
export type cancelWorkerRunResponseError = (cancelWorkerRunResponse400 | cancelWorkerRunResponse401 | cancelWorkerRunResponse404 | cancelWorkerRunResponse409 | cancelWorkerRunResponse500) & {
  headers: Headers;
};

export type cancelWorkerRunResponse = (cancelWorkerRunResponseSuccess | cancelWorkerRunResponseError)

export const getCancelWorkerRunUrl = (workerRunId: string,) => {




  return `/v1/worker-runs/${workerRunId}/cancel`
}

/**
 * Cancel a worker run. For in_progress runs, the underlying E2B sandbox is terminated when possible. Pending and queued runs are simply marked canceled. Runs that are starting are still being handed their context and cannot be interrupted, so they cannot be canceled until they reach in_progress. Runs in terminal states (completed, failed) cannot be canceled. Already-canceled runs are returned without side effects.
 * @summary Cancel a worker run
 */
export const cancelWorkerRun = async (workerRunId: string, options?: RequestInit): Promise<cancelWorkerRunResponse> => {

  const res = await fetch(getCancelWorkerRunUrl(workerRunId),
  {
    ...options,
    method: 'POST'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: cancelWorkerRunResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as cancelWorkerRunResponse
}



export type createWorkerEvalFromRunResponse200 = {
  data: CreateWorkerEvalFromRunEnvelope
  status: 200
}

export type createWorkerEvalFromRunResponse400 = {
  data: ErrorResponse
  status: 400
}

export type createWorkerEvalFromRunResponse401 = {
  data: ErrorResponse
  status: 401
}

export type createWorkerEvalFromRunResponse404 = {
  data: ErrorResponse
  status: 404
}

export type createWorkerEvalFromRunResponse409 = {
  data: ErrorResponse
  status: 409
}

export type createWorkerEvalFromRunResponse500 = {
  data: ErrorResponse
  status: 500
}

export type createWorkerEvalFromRunResponseSuccess = (createWorkerEvalFromRunResponse200) & {
  headers: Headers;
};
export type createWorkerEvalFromRunResponseError = (createWorkerEvalFromRunResponse400 | createWorkerEvalFromRunResponse401 | createWorkerEvalFromRunResponse404 | createWorkerEvalFromRunResponse409 | createWorkerEvalFromRunResponse500) & {
  headers: Headers;
};

export type createWorkerEvalFromRunResponse = (createWorkerEvalFromRunResponseSuccess | createWorkerEvalFromRunResponseError)

export const getCreateWorkerEvalFromRunUrl = (workerRunId: string,) => {




  return `/v1/worker-runs/${workerRunId}/evals`
}

/**
 * Snapshot a worker run's trigger and resolved artifacts. Mock responses are returned in call order.
 * @summary Create a worker eval from a run
 */
export const createWorkerEvalFromRun = async (workerRunId: string,
    createWorkerEvalFromRunBody?: CreateWorkerEvalFromRunBody, options?: RequestInit): Promise<createWorkerEvalFromRunResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getCreateWorkerEvalFromRunUrl(workerRunId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createWorkerEvalFromRunBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: createWorkerEvalFromRunResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as createWorkerEvalFromRunResponse
}



export type runEvalResponse200 = {
  data: RunEvalEnvelope
  status: 200
}

export type runEvalResponse400 = {
  data: ErrorResponse
  status: 400
}

export type runEvalResponse401 = {
  data: ErrorResponse
  status: 401
}

export type runEvalResponse404 = {
  data: ErrorResponse
  status: 404
}

export type runEvalResponse409 = {
  data: ErrorResponse
  status: 409
}

export type runEvalResponse500 = {
  data: ErrorResponse
  status: 500
}

export type runEvalResponseSuccess = (runEvalResponse200) & {
  headers: Headers;
};
export type runEvalResponseError = (runEvalResponse400 | runEvalResponse401 | runEvalResponse404 | runEvalResponse409 | runEvalResponse500) & {
  headers: Headers;
};

export type runEvalResponse = (runEvalResponseSuccess | runEvalResponseError)

export const getRunEvalUrl = (evalId: string,) => {




  return `/v1/evals/${evalId}/runs`
}

/**
 * Queue the worker's current test version against the eval's immutable artifact snapshot and mocked tools.
 * @summary Run an eval
 */
export const runEval = async (evalId: string, options?: RequestInit): Promise<runEvalResponse> => {

  const res = await fetch(getRunEvalUrl(evalId),
  {
    ...options,
    method: 'POST'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: runEvalResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as runEvalResponse
}



export type getEvalRunResponse200 = {
  data: GetEvalRunEnvelope
  status: 200
}

export type getEvalRunResponse400 = {
  data: ErrorResponse
  status: 400
}

export type getEvalRunResponse401 = {
  data: ErrorResponse
  status: 401
}

export type getEvalRunResponse404 = {
  data: ErrorResponse
  status: 404
}

export type getEvalRunResponse409 = {
  data: ErrorResponse
  status: 409
}

export type getEvalRunResponse500 = {
  data: ErrorResponse
  status: 500
}

export type getEvalRunResponseSuccess = (getEvalRunResponse200) & {
  headers: Headers;
};
export type getEvalRunResponseError = (getEvalRunResponse400 | getEvalRunResponse401 | getEvalRunResponse404 | getEvalRunResponse409 | getEvalRunResponse500) & {
  headers: Headers;
};

export type getEvalRunResponse = (getEvalRunResponseSuccess | getEvalRunResponseError)

export const getGetEvalRunUrl = (evalRunId: string,) => {




  return `/v1/eval-runs/${evalRunId}`
}

/**
 * Get the status and prompt-grader result for an eval run.
 * @summary Get an eval run
 */
export const getEvalRun = async (evalRunId: string, options?: RequestInit): Promise<getEvalRunResponse> => {

  const res = await fetch(getGetEvalRunUrl(evalRunId),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getEvalRunResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getEvalRunResponse
}



export type createExtractorResponse200 = {
  data: CreateExtractorEnvelope
  status: 200
}

export type createExtractorResponse400 = {
  data: ErrorResponse
  status: 400
}

export type createExtractorResponse401 = {
  data: ErrorResponse
  status: 401
}

export type createExtractorResponse409 = {
  data: ErrorResponse
  status: 409
}

export type createExtractorResponse500 = {
  data: ErrorResponse
  status: 500
}

export type createExtractorResponseSuccess = (createExtractorResponse200) & {
  headers: Headers;
};
export type createExtractorResponseError = (createExtractorResponse400 | createExtractorResponse401 | createExtractorResponse409 | createExtractorResponse500) & {
  headers: Headers;
};

export type createExtractorResponse = (createExtractorResponseSuccess | createExtractorResponseError)

export const getCreateExtractorUrl = () => {




  return `/v1/extractors`
}

/**
 * Create a new extractor with a name and JSON schema defining the extraction output format.
 * @summary Create extractor
 */
export const createExtractor = async (createExtractorBody?: CreateExtractorBody, options?: RequestInit): Promise<createExtractorResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getCreateExtractorUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createExtractorBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: createExtractorResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as createExtractorResponse
}



export type listExtractorsResponse200 = {
  data: ListExtractorsEnvelope
  status: 200
}

export type listExtractorsResponse400 = {
  data: ErrorResponse
  status: 400
}

export type listExtractorsResponse401 = {
  data: ErrorResponse
  status: 401
}

export type listExtractorsResponse409 = {
  data: ErrorResponse
  status: 409
}

export type listExtractorsResponse500 = {
  data: ErrorResponse
  status: 500
}

export type listExtractorsResponseSuccess = (listExtractorsResponse200) & {
  headers: Headers;
};
export type listExtractorsResponseError = (listExtractorsResponse400 | listExtractorsResponse401 | listExtractorsResponse409 | listExtractorsResponse500) & {
  headers: Headers;
};

export type listExtractorsResponse = (listExtractorsResponseSuccess | listExtractorsResponseError)

export const getListExtractorsUrl = (params?: ListExtractorsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/extractors?${stringifiedParams}` : `/v1/extractors`
}

/**
 * List all extractors with pagination, filtering, and sorting.
 *
 * Filter by name using the `name` query parameter.
 * @summary List extractors
 */
export const listExtractors = async (params?: ListExtractorsParams, options?: RequestInit): Promise<listExtractorsResponse> => {

  const res = await fetch(getListExtractorsUrl(params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: listExtractorsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as listExtractorsResponse
}



export type getExtractorResponse200 = {
  data: GetExtractorEnvelope
  status: 200
}

export type getExtractorResponse400 = {
  data: ErrorResponse
  status: 400
}

export type getExtractorResponse401 = {
  data: ErrorResponse
  status: 401
}

export type getExtractorResponse404 = {
  data: ErrorResponse
  status: 404
}

export type getExtractorResponse409 = {
  data: ErrorResponse
  status: 409
}

export type getExtractorResponse500 = {
  data: ErrorResponse
  status: 500
}

export type getExtractorResponseSuccess = (getExtractorResponse200) & {
  headers: Headers;
};
export type getExtractorResponseError = (getExtractorResponse400 | getExtractorResponse401 | getExtractorResponse404 | getExtractorResponse409 | getExtractorResponse500) & {
  headers: Headers;
};

export type getExtractorResponse = (getExtractorResponseSuccess | getExtractorResponseError)

export const getGetExtractorUrl = (id: string,) => {




  return `/v1/extractors/${id}`
}

/**
 * Retrieve a single extractor by ID, including its schema and version.
 * @summary Get extractor
 */
export const getExtractor = async (id: string, options?: RequestInit): Promise<getExtractorResponse> => {

  const res = await fetch(getGetExtractorUrl(id),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getExtractorResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getExtractorResponse
}



export type updateExtractorResponse200 = {
  data: UpdateExtractorEnvelope
  status: 200
}

export type updateExtractorResponse400 = {
  data: ErrorResponse
  status: 400
}

export type updateExtractorResponse401 = {
  data: ErrorResponse
  status: 401
}

export type updateExtractorResponse404 = {
  data: ErrorResponse
  status: 404
}

export type updateExtractorResponse409 = {
  data: ErrorResponse
  status: 409
}

export type updateExtractorResponse500 = {
  data: ErrorResponse
  status: 500
}

export type updateExtractorResponseSuccess = (updateExtractorResponse200) & {
  headers: Headers;
};
export type updateExtractorResponseError = (updateExtractorResponse400 | updateExtractorResponse401 | updateExtractorResponse404 | updateExtractorResponse409 | updateExtractorResponse500) & {
  headers: Headers;
};

export type updateExtractorResponse = (updateExtractorResponseSuccess | updateExtractorResponseError)

export const getUpdateExtractorUrl = (id: string,) => {




  return `/v1/extractors/${id}`
}

/**
 * Update an extractor's schema. This creates a new version of the extractor.
 * @summary Update extractor
 */
export const updateExtractor = async (id: string,
    updateExtractorBody?: UpdateExtractorBody, options?: RequestInit): Promise<updateExtractorResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getUpdateExtractorUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateExtractorBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: updateExtractorResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as updateExtractorResponse
}



export type deleteExtractorResponse200 = {
  data: DeleteExtractorEnvelope
  status: 200
}

export type deleteExtractorResponse400 = {
  data: ErrorResponse
  status: 400
}

export type deleteExtractorResponse401 = {
  data: ErrorResponse
  status: 401
}

export type deleteExtractorResponse404 = {
  data: ErrorResponse
  status: 404
}

export type deleteExtractorResponse409 = {
  data: ErrorResponse
  status: 409
}

export type deleteExtractorResponse500 = {
  data: ErrorResponse
  status: 500
}

export type deleteExtractorResponseSuccess = (deleteExtractorResponse200) & {
  headers: Headers;
};
export type deleteExtractorResponseError = (deleteExtractorResponse400 | deleteExtractorResponse401 | deleteExtractorResponse404 | deleteExtractorResponse409 | deleteExtractorResponse500) & {
  headers: Headers;
};

export type deleteExtractorResponse = (deleteExtractorResponseSuccess | deleteExtractorResponseError)

export const getDeleteExtractorUrl = (id: string,) => {




  return `/v1/extractors/${id}`
}

/**
 * Soft-delete an extractor and all of its versions. Soft-deleted extractors no longer appear in any read.
 * @summary Delete extractor
 */
export const deleteExtractor = async (id: string, options?: RequestInit): Promise<deleteExtractorResponse> => {

  const res = await fetch(getDeleteExtractorUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: deleteExtractorResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as deleteExtractorResponse
}



export type createWorkerResponse200 = {
  data: CreateWorkerEnvelope
  status: 200
}

export type createWorkerResponse400 = {
  data: ErrorResponse
  status: 400
}

export type createWorkerResponse401 = {
  data: ErrorResponse
  status: 401
}

export type createWorkerResponse409 = {
  data: ErrorResponse
  status: 409
}

export type createWorkerResponse500 = {
  data: ErrorResponse
  status: 500
}

export type createWorkerResponseSuccess = (createWorkerResponse200) & {
  headers: Headers;
};
export type createWorkerResponseError = (createWorkerResponse400 | createWorkerResponse401 | createWorkerResponse409 | createWorkerResponse500) & {
  headers: Headers;
};

export type createWorkerResponse = (createWorkerResponseSuccess | createWorkerResponseError)

export const getCreateWorkerUrl = () => {




  return `/v1/workers`
}

/**
 * Create a new worker with a name and prompt.
 * @summary Create worker
 */
export const createWorker = async (createWorkerBody?: CreateWorkerBody, options?: RequestInit): Promise<createWorkerResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getCreateWorkerUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createWorkerBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: createWorkerResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as createWorkerResponse
}



export type listWorkersResponse200 = {
  data: ListWorkersEnvelope
  status: 200
}

export type listWorkersResponse400 = {
  data: ErrorResponse
  status: 400
}

export type listWorkersResponse401 = {
  data: ErrorResponse
  status: 401
}

export type listWorkersResponse409 = {
  data: ErrorResponse
  status: 409
}

export type listWorkersResponse500 = {
  data: ErrorResponse
  status: 500
}

export type listWorkersResponseSuccess = (listWorkersResponse200) & {
  headers: Headers;
};
export type listWorkersResponseError = (listWorkersResponse400 | listWorkersResponse401 | listWorkersResponse409 | listWorkersResponse500) & {
  headers: Headers;
};

export type listWorkersResponse = (listWorkersResponseSuccess | listWorkersResponseError)

export const getListWorkersUrl = (params?: ListWorkersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/workers?${stringifiedParams}` : `/v1/workers`
}

/**
 * List all workers with pagination, filtering, and sorting.
 *
 * Filter by name using the `name` query parameter.
 * @summary List workers
 */
export const listWorkers = async (params?: ListWorkersParams, options?: RequestInit): Promise<listWorkersResponse> => {

  const res = await fetch(getListWorkersUrl(params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: listWorkersResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as listWorkersResponse
}



export type getWorkerResponse200 = {
  data: GetWorkerEnvelope
  status: 200
}

export type getWorkerResponse400 = {
  data: ErrorResponse
  status: 400
}

export type getWorkerResponse401 = {
  data: ErrorResponse
  status: 401
}

export type getWorkerResponse404 = {
  data: ErrorResponse
  status: 404
}

export type getWorkerResponse409 = {
  data: ErrorResponse
  status: 409
}

export type getWorkerResponse500 = {
  data: ErrorResponse
  status: 500
}

export type getWorkerResponseSuccess = (getWorkerResponse200) & {
  headers: Headers;
};
export type getWorkerResponseError = (getWorkerResponse400 | getWorkerResponse401 | getWorkerResponse404 | getWorkerResponse409 | getWorkerResponse500) & {
  headers: Headers;
};

export type getWorkerResponse = (getWorkerResponseSuccess | getWorkerResponseError)

export const getGetWorkerUrl = (workerId: string,) => {




  return `/v1/workers/${workerId}`
}

/**
 * Retrieve a single worker by ID.
 * @summary Get worker
 */
export const getWorker = async (workerId: string, options?: RequestInit): Promise<getWorkerResponse> => {

  const res = await fetch(getGetWorkerUrl(workerId),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getWorkerResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getWorkerResponse
}



export type deleteWorkerResponse200 = {
  data: DeleteWorkerEnvelope
  status: 200
}

export type deleteWorkerResponse400 = {
  data: ErrorResponse
  status: 400
}

export type deleteWorkerResponse401 = {
  data: ErrorResponse
  status: 401
}

export type deleteWorkerResponse404 = {
  data: ErrorResponse
  status: 404
}

export type deleteWorkerResponse409 = {
  data: ErrorResponse
  status: 409
}

export type deleteWorkerResponse500 = {
  data: ErrorResponse
  status: 500
}

export type deleteWorkerResponseSuccess = (deleteWorkerResponse200) & {
  headers: Headers;
};
export type deleteWorkerResponseError = (deleteWorkerResponse400 | deleteWorkerResponse401 | deleteWorkerResponse404 | deleteWorkerResponse409 | deleteWorkerResponse500) & {
  headers: Headers;
};

export type deleteWorkerResponse = (deleteWorkerResponseSuccess | deleteWorkerResponseError)

export const getDeleteWorkerUrl = (workerId: string,) => {




  return `/v1/workers/${workerId}`
}

/**
 * Delete a worker. The worker is hidden from all reads; its run history is preserved.
 * @summary Delete worker
 */
export const deleteWorker = async (workerId: string, options?: RequestInit): Promise<deleteWorkerResponse> => {

  const res = await fetch(getDeleteWorkerUrl(workerId),
  {
    ...options,
    method: 'DELETE'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: deleteWorkerResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as deleteWorkerResponse
}



export type updateWorkerResponse200 = {
  data: UpdateWorkerEnvelope
  status: 200
}

export type updateWorkerResponse400 = {
  data: ErrorResponse
  status: 400
}

export type updateWorkerResponse401 = {
  data: ErrorResponse
  status: 401
}

export type updateWorkerResponse404 = {
  data: ErrorResponse
  status: 404
}

export type updateWorkerResponse409 = {
  data: ErrorResponse
  status: 409
}

export type updateWorkerResponse500 = {
  data: ErrorResponse
  status: 500
}

export type updateWorkerResponseSuccess = (updateWorkerResponse200) & {
  headers: Headers;
};
export type updateWorkerResponseError = (updateWorkerResponse400 | updateWorkerResponse401 | updateWorkerResponse404 | updateWorkerResponse409 | updateWorkerResponse500) & {
  headers: Headers;
};

export type updateWorkerResponse = (updateWorkerResponseSuccess | updateWorkerResponseError)

export const getUpdateWorkerUrl = (workerId: string,) => {




  return `/v1/workers/${workerId}`
}

/**
 * Update the configuration of a worker, including the attached tool set.
 * @summary Update worker
 */
export const updateWorker = async (workerId: string,
    updateWorkerBody?: UpdateWorkerBody, options?: RequestInit): Promise<updateWorkerResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getUpdateWorkerUrl(workerId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateWorkerBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: updateWorkerResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as updateWorkerResponse
}



export type getWorkerPromptResponse200 = {
  data: GetWorkerPromptEnvelope
  status: 200
}

export type getWorkerPromptResponse400 = {
  data: ErrorResponse
  status: 400
}

export type getWorkerPromptResponse401 = {
  data: ErrorResponse
  status: 401
}

export type getWorkerPromptResponse404 = {
  data: ErrorResponse
  status: 404
}

export type getWorkerPromptResponse409 = {
  data: ErrorResponse
  status: 409
}

export type getWorkerPromptResponse500 = {
  data: ErrorResponse
  status: 500
}

export type getWorkerPromptResponseSuccess = (getWorkerPromptResponse200) & {
  headers: Headers;
};
export type getWorkerPromptResponseError = (getWorkerPromptResponse400 | getWorkerPromptResponse401 | getWorkerPromptResponse404 | getWorkerPromptResponse409 | getWorkerPromptResponse500) & {
  headers: Headers;
};

export type getWorkerPromptResponse = (getWorkerPromptResponseSuccess | getWorkerPromptResponseError)

export const getGetWorkerPromptUrl = (workerId: string,
    params?: GetWorkerPromptParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/workers/${workerId}/prompt?${stringifiedParams}` : `/v1/workers/${workerId}/prompt`
}

/**
 * Retrieve the prompt for a worker. Pass `version` to fetch the prompt snapshot at a specific config version; omit it to fetch the current prompt. Internal use only.
 * @summary Get worker prompt
 */
export const getWorkerPrompt = async (workerId: string,
    params?: GetWorkerPromptParams, options?: RequestInit): Promise<getWorkerPromptResponse> => {

  const res = await fetch(getGetWorkerPromptUrl(workerId,params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getWorkerPromptResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getWorkerPromptResponse
}



export type updateWorkerPromptResponse200 = {
  data: UpdateWorkerPromptEnvelope
  status: 200
}

export type updateWorkerPromptResponse400 = {
  data: ErrorResponse
  status: 400
}

export type updateWorkerPromptResponse401 = {
  data: ErrorResponse
  status: 401
}

export type updateWorkerPromptResponse404 = {
  data: ErrorResponse
  status: 404
}

export type updateWorkerPromptResponse409 = {
  data: ErrorResponse
  status: 409
}

export type updateWorkerPromptResponse500 = {
  data: ErrorResponse
  status: 500
}

export type updateWorkerPromptResponseSuccess = (updateWorkerPromptResponse200) & {
  headers: Headers;
};
export type updateWorkerPromptResponseError = (updateWorkerPromptResponse400 | updateWorkerPromptResponse401 | updateWorkerPromptResponse404 | updateWorkerPromptResponse409 | updateWorkerPromptResponse500) & {
  headers: Headers;
};

export type updateWorkerPromptResponse = (updateWorkerPromptResponseSuccess | updateWorkerPromptResponseError)

export const getUpdateWorkerPromptUrl = (workerId: string,) => {




  return `/v1/workers/${workerId}/prompt`
}

/**
 * Update the prompt for a worker. Internal use only.
 * @summary Update worker prompt
 */
export const updateWorkerPrompt = async (workerId: string,
    updateWorkerPromptBody?: UpdateWorkerPromptBody, options?: RequestInit): Promise<updateWorkerPromptResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getUpdateWorkerPromptUrl(workerId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateWorkerPromptBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: updateWorkerPromptResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as updateWorkerPromptResponse
}



export type listWorkerModelsResponse200 = {
  data: ListWorkerModelsEnvelope
  status: 200
}

export type listWorkerModelsResponse400 = {
  data: ErrorResponse
  status: 400
}

export type listWorkerModelsResponse401 = {
  data: ErrorResponse
  status: 401
}

export type listWorkerModelsResponse409 = {
  data: ErrorResponse
  status: 409
}

export type listWorkerModelsResponse500 = {
  data: ErrorResponse
  status: 500
}

export type listWorkerModelsResponseSuccess = (listWorkerModelsResponse200) & {
  headers: Headers;
};
export type listWorkerModelsResponseError = (listWorkerModelsResponse400 | listWorkerModelsResponse401 | listWorkerModelsResponse409 | listWorkerModelsResponse500) & {
  headers: Headers;
};

export type listWorkerModelsResponse = (listWorkerModelsResponseSuccess | listWorkerModelsResponseError)

export const getListWorkerModelsUrl = () => {




  return `/v1/worker-models`
}

/**
 * List the LLM models that can be assigned to a worker via the `model` field on update.
 * @summary List available worker models
 */
export const listWorkerModels = async ( options?: RequestInit): Promise<listWorkerModelsResponse> => {

  const res = await fetch(getListWorkerModelsUrl(),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: listWorkerModelsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as listWorkerModelsResponse
}



export type updateWorkerMcpsResponse200 = {
  data: UpdateWorkerMcpsEnvelope
  status: 200
}

export type updateWorkerMcpsResponse400 = {
  data: ErrorResponse
  status: 400
}

export type updateWorkerMcpsResponse401 = {
  data: ErrorResponse
  status: 401
}

export type updateWorkerMcpsResponse404 = {
  data: ErrorResponse
  status: 404
}

export type updateWorkerMcpsResponse409 = {
  data: ErrorResponse
  status: 409
}

export type updateWorkerMcpsResponse500 = {
  data: ErrorResponse
  status: 500
}

export type updateWorkerMcpsResponseSuccess = (updateWorkerMcpsResponse200) & {
  headers: Headers;
};
export type updateWorkerMcpsResponseError = (updateWorkerMcpsResponse400 | updateWorkerMcpsResponse401 | updateWorkerMcpsResponse404 | updateWorkerMcpsResponse409 | updateWorkerMcpsResponse500) & {
  headers: Headers;
};

export type updateWorkerMcpsResponse = (updateWorkerMcpsResponseSuccess | updateWorkerMcpsResponseError)

export const getUpdateWorkerMcpsUrl = (workerId: string,) => {




  return `/v1/workers/${workerId}/mcps`
}

/**
 * Replace the set of MCP servers a worker connects to. Pass an empty array to disconnect.
 * @summary Update worker MCP servers
 */
export const updateWorkerMcps = async (workerId: string,
    updateWorkerMcpsBody?: UpdateWorkerMcpsBody, options?: RequestInit): Promise<updateWorkerMcpsResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getUpdateWorkerMcpsUrl(workerId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateWorkerMcpsBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: updateWorkerMcpsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as updateWorkerMcpsResponse
}



export type listWorkerVersionsResponse200 = {
  data: ListWorkerVersionsEnvelope
  status: 200
}

export type listWorkerVersionsResponse400 = {
  data: ErrorResponse
  status: 400
}

export type listWorkerVersionsResponse401 = {
  data: ErrorResponse
  status: 401
}

export type listWorkerVersionsResponse404 = {
  data: ErrorResponse
  status: 404
}

export type listWorkerVersionsResponse409 = {
  data: ErrorResponse
  status: 409
}

export type listWorkerVersionsResponse500 = {
  data: ErrorResponse
  status: 500
}

export type listWorkerVersionsResponseSuccess = (listWorkerVersionsResponse200) & {
  headers: Headers;
};
export type listWorkerVersionsResponseError = (listWorkerVersionsResponse400 | listWorkerVersionsResponse401 | listWorkerVersionsResponse404 | listWorkerVersionsResponse409 | listWorkerVersionsResponse500) & {
  headers: Headers;
};

export type listWorkerVersionsResponse = (listWorkerVersionsResponseSuccess | listWorkerVersionsResponseError)

export const getListWorkerVersionsUrl = (workerId: string,
    params?: ListWorkerVersionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/workers/${workerId}/versions?${stringifiedParams}` : `/v1/workers/${workerId}/versions`
}

/**
 * List all config versions for a worker, ordered by version (newest first by default).
 * @summary List worker versions
 */
export const listWorkerVersions = async (workerId: string,
    params?: ListWorkerVersionsParams, options?: RequestInit): Promise<listWorkerVersionsResponse> => {

  const res = await fetch(getListWorkerVersionsUrl(workerId,params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: listWorkerVersionsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as listWorkerVersionsResponse
}



export type getWorkerVersionResponse200 = {
  data: GetWorkerVersionEnvelope
  status: 200
}

export type getWorkerVersionResponse400 = {
  data: ErrorResponse
  status: 400
}

export type getWorkerVersionResponse401 = {
  data: ErrorResponse
  status: 401
}

export type getWorkerVersionResponse404 = {
  data: ErrorResponse
  status: 404
}

export type getWorkerVersionResponse409 = {
  data: ErrorResponse
  status: 409
}

export type getWorkerVersionResponse500 = {
  data: ErrorResponse
  status: 500
}

export type getWorkerVersionResponseSuccess = (getWorkerVersionResponse200) & {
  headers: Headers;
};
export type getWorkerVersionResponseError = (getWorkerVersionResponse400 | getWorkerVersionResponse401 | getWorkerVersionResponse404 | getWorkerVersionResponse409 | getWorkerVersionResponse500) & {
  headers: Headers;
};

export type getWorkerVersionResponse = (getWorkerVersionResponseSuccess | getWorkerVersionResponseError)

export const getGetWorkerVersionUrl = (workerId: string,
    version: number,) => {




  return `/v1/workers/${workerId}/versions/${version}`
}

/**
 * Retrieve a single worker config version, including the worker's identity, the config snapshot at that version, and version-specific metadata. The prompt is served separately by the worker prompt endpoint.
 * @summary Get worker version
 */
export const getWorkerVersion = async (workerId: string,
    version: number, options?: RequestInit): Promise<getWorkerVersionResponse> => {

  const res = await fetch(getGetWorkerVersionUrl(workerId,version),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getWorkerVersionResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getWorkerVersionResponse
}



export type promoteWorkerVersionResponse200 = {
  data: PromoteWorkerVersionEnvelope
  status: 200
}

export type promoteWorkerVersionResponse400 = {
  data: ErrorResponse
  status: 400
}

export type promoteWorkerVersionResponse401 = {
  data: ErrorResponse
  status: 401
}

export type promoteWorkerVersionResponse404 = {
  data: ErrorResponse
  status: 404
}

export type promoteWorkerVersionResponse409 = {
  data: ErrorResponse
  status: 409
}

export type promoteWorkerVersionResponse500 = {
  data: ErrorResponse
  status: 500
}

export type promoteWorkerVersionResponseSuccess = (promoteWorkerVersionResponse200) & {
  headers: Headers;
};
export type promoteWorkerVersionResponseError = (promoteWorkerVersionResponse400 | promoteWorkerVersionResponse401 | promoteWorkerVersionResponse404 | promoteWorkerVersionResponse409 | promoteWorkerVersionResponse500) & {
  headers: Headers;
};

export type promoteWorkerVersionResponse = (promoteWorkerVersionResponseSuccess | promoteWorkerVersionResponseError)

export const getPromoteWorkerVersionUrl = (workerId: string,
    version: number,) => {




  return `/v1/workers/${workerId}/versions/${version}/promote`
}

/**
 * Select a worker configuration version for the live or test environment. This freezes the config snapshot only — the E2B template, attached tools and attached secrets are not versioned and always resolve to their current values.
 * @summary Promote worker version
 */
export const promoteWorkerVersion = async (workerId: string,
    version: number,
    promoteWorkerVersionBody?: PromoteWorkerVersionBody, options?: RequestInit): Promise<promoteWorkerVersionResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getPromoteWorkerVersionUrl(workerId,version),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(promoteWorkerVersionBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: promoteWorkerVersionResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as promoteWorkerVersionResponse
}



export type getWorkerVersionChangeSummaryResponse200 = {
  data: GetWorkerVersionChangeSummaryEnvelope
  status: 200
}

export type getWorkerVersionChangeSummaryResponse400 = {
  data: ErrorResponse
  status: 400
}

export type getWorkerVersionChangeSummaryResponse401 = {
  data: ErrorResponse
  status: 401
}

export type getWorkerVersionChangeSummaryResponse404 = {
  data: ErrorResponse
  status: 404
}

export type getWorkerVersionChangeSummaryResponse409 = {
  data: ErrorResponse
  status: 409
}

export type getWorkerVersionChangeSummaryResponse500 = {
  data: ErrorResponse
  status: 500
}

export type getWorkerVersionChangeSummaryResponseSuccess = (getWorkerVersionChangeSummaryResponse200) & {
  headers: Headers;
};
export type getWorkerVersionChangeSummaryResponseError = (getWorkerVersionChangeSummaryResponse400 | getWorkerVersionChangeSummaryResponse401 | getWorkerVersionChangeSummaryResponse404 | getWorkerVersionChangeSummaryResponse409 | getWorkerVersionChangeSummaryResponse500) & {
  headers: Headers;
};

export type getWorkerVersionChangeSummaryResponse = (getWorkerVersionChangeSummaryResponseSuccess | getWorkerVersionChangeSummaryResponseError)

export const getGetWorkerVersionChangeSummaryUrl = (workerId: string,
    version: number,) => {




  return `/v1/workers/${workerId}/versions/${version}/change-summary`
}

/**
 * Returns an AI-generated summary of what changed between this version and the previous one. Initial version returns an empty string since there is no predecessor.
 * @summary Get worker version change summary
 */
export const getWorkerVersionChangeSummary = async (workerId: string,
    version: number, options?: RequestInit): Promise<getWorkerVersionChangeSummaryResponse> => {

  const res = await fetch(getGetWorkerVersionChangeSummaryUrl(workerId,version),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getWorkerVersionChangeSummaryResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getWorkerVersionChangeSummaryResponse
}



export type createWorkerWebhookResponse200 = {
  data: CreateWorkerWebhookEnvelope
  status: 200
}

export type createWorkerWebhookResponse400 = {
  data: ErrorResponse
  status: 400
}

export type createWorkerWebhookResponse401 = {
  data: ErrorResponse
  status: 401
}

export type createWorkerWebhookResponse404 = {
  data: ErrorResponse
  status: 404
}

export type createWorkerWebhookResponse409 = {
  data: ErrorResponse
  status: 409
}

export type createWorkerWebhookResponse500 = {
  data: ErrorResponse
  status: 500
}

export type createWorkerWebhookResponseSuccess = (createWorkerWebhookResponse200) & {
  headers: Headers;
};
export type createWorkerWebhookResponseError = (createWorkerWebhookResponse400 | createWorkerWebhookResponse401 | createWorkerWebhookResponse404 | createWorkerWebhookResponse409 | createWorkerWebhookResponse500) & {
  headers: Headers;
};

export type createWorkerWebhookResponse = (createWorkerWebhookResponseSuccess | createWorkerWebhookResponseError)

export const getCreateWorkerWebhookUrl = (workerId: string,) => {




  return `/v1/workers/${workerId}/webhooks`
}

/**
 * Create a webhook that fires when events occur for the specified worker.
 * @summary Create worker webhook
 */
export const createWorkerWebhook = async (workerId: string,
    createWorkerWebhookBody?: CreateWorkerWebhookBody, options?: RequestInit): Promise<createWorkerWebhookResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getCreateWorkerWebhookUrl(workerId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createWorkerWebhookBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: createWorkerWebhookResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as createWorkerWebhookResponse
}



export type listWorkerWebhooksResponse200 = {
  data: ListWorkerWebhooksEnvelope
  status: 200
}

export type listWorkerWebhooksResponse400 = {
  data: ErrorResponse
  status: 400
}

export type listWorkerWebhooksResponse401 = {
  data: ErrorResponse
  status: 401
}

export type listWorkerWebhooksResponse404 = {
  data: ErrorResponse
  status: 404
}

export type listWorkerWebhooksResponse409 = {
  data: ErrorResponse
  status: 409
}

export type listWorkerWebhooksResponse500 = {
  data: ErrorResponse
  status: 500
}

export type listWorkerWebhooksResponseSuccess = (listWorkerWebhooksResponse200) & {
  headers: Headers;
};
export type listWorkerWebhooksResponseError = (listWorkerWebhooksResponse400 | listWorkerWebhooksResponse401 | listWorkerWebhooksResponse404 | listWorkerWebhooksResponse409 | listWorkerWebhooksResponse500) & {
  headers: Headers;
};

export type listWorkerWebhooksResponse = (listWorkerWebhooksResponseSuccess | listWorkerWebhooksResponseError)

export const getListWorkerWebhooksUrl = (workerId: string,
    params?: ListWorkerWebhooksParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/workers/${workerId}/webhooks?${stringifiedParams}` : `/v1/workers/${workerId}/webhooks`
}

/**
 * List all webhooks configured for a specific worker.
 * @summary List worker webhooks
 */
export const listWorkerWebhooks = async (workerId: string,
    params?: ListWorkerWebhooksParams, options?: RequestInit): Promise<listWorkerWebhooksResponse> => {

  const res = await fetch(getListWorkerWebhooksUrl(workerId,params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: listWorkerWebhooksResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as listWorkerWebhooksResponse
}



export type listCasesResponse200 = {
  data: ListCasesEnvelope
  status: 200
}

export type listCasesResponse400 = {
  data: ErrorResponse
  status: 400
}

export type listCasesResponse401 = {
  data: ErrorResponse
  status: 401
}

export type listCasesResponse409 = {
  data: ErrorResponse
  status: 409
}

export type listCasesResponse500 = {
  data: ErrorResponse
  status: 500
}

export type listCasesResponseSuccess = (listCasesResponse200) & {
  headers: Headers;
};
export type listCasesResponseError = (listCasesResponse400 | listCasesResponse401 | listCasesResponse409 | listCasesResponse500) & {
  headers: Headers;
};

export type listCasesResponse = (listCasesResponseSuccess | listCasesResponseError)

export const getListCasesUrl = (params?: ListCasesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/cases?${stringifiedParams}` : `/v1/cases`
}

/**
 * List all cases for the current tenant, paginated, filterable, and sortable.
 * @summary List cases
 */
export const listCases = async (params?: ListCasesParams, options?: RequestInit): Promise<listCasesResponse> => {

  const res = await fetch(getListCasesUrl(params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: listCasesResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as listCasesResponse
}



export type createCaseResponse201 = {
  data: CreateCaseEnvelope
  status: 201
}

export type createCaseResponse400 = {
  data: ErrorResponse
  status: 400
}

export type createCaseResponse401 = {
  data: ErrorResponse
  status: 401
}

export type createCaseResponse409 = {
  data: ErrorResponse
  status: 409
}

export type createCaseResponse500 = {
  data: ErrorResponse
  status: 500
}

export type createCaseResponseSuccess = (createCaseResponse201) & {
  headers: Headers;
};
export type createCaseResponseError = (createCaseResponse400 | createCaseResponse401 | createCaseResponse409 | createCaseResponse500) & {
  headers: Headers;
};

export type createCaseResponse = (createCaseResponseSuccess | createCaseResponseError)

export const getCreateCaseUrl = () => {




  return `/v1/cases`
}

/**
 * Create a case with a client-supplied id.
 *
 * Case ids are tenant-scoped opaque keys (e.g. "clm-1", "STD-001") and are normalized server-side (trimmed and lowercased). Creating an id that already exists **in the same environment** returns 409 — the same id can exist once in `live` and once in `test`.
 * @summary Create case
 */
export const createCase = async (createCaseBody?: CreateCaseBody, options?: RequestInit): Promise<createCaseResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getCreateCaseUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createCaseBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: createCaseResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as createCaseResponse
}



export type searchCasesResponse200 = {
  data: SearchCasesEnvelope
  status: 200
}

export type searchCasesResponse400 = {
  data: ErrorResponse
  status: 400
}

export type searchCasesResponse401 = {
  data: ErrorResponse
  status: 401
}

export type searchCasesResponse409 = {
  data: ErrorResponse
  status: 409
}

export type searchCasesResponse500 = {
  data: ErrorResponse
  status: 500
}

export type searchCasesResponseSuccess = (searchCasesResponse200) & {
  headers: Headers;
};
export type searchCasesResponseError = (searchCasesResponse400 | searchCasesResponse401 | searchCasesResponse409 | searchCasesResponse500) & {
  headers: Headers;
};

export type searchCasesResponse = (searchCasesResponseSuccess | searchCasesResponseError)

export const getSearchCasesUrl = (params: SearchCasesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/cases/search?${stringifiedParams}` : `/v1/cases/search`
}

/**
 * Probe for candidate cases. Matches the query as a normalized substring of the case id, and fuzzily (trigram) against subject and reporter. Results are relevance-ranked — id matches first, then best fuzzy match, then most recently updated — so ordering is fixed and not configurable.
 * @summary Search cases
 */
export const searchCases = async (params: SearchCasesParams, options?: RequestInit): Promise<searchCasesResponse> => {

  const res = await fetch(getSearchCasesUrl(params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: searchCasesResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as searchCasesResponse
}



export type getCaseResponse200 = {
  data: GetCaseEnvelope
  status: 200
}

export type getCaseResponse400 = {
  data: ErrorResponse
  status: 400
}

export type getCaseResponse401 = {
  data: ErrorResponse
  status: 401
}

export type getCaseResponse404 = {
  data: ErrorResponse
  status: 404
}

export type getCaseResponse409 = {
  data: ErrorResponse
  status: 409
}

export type getCaseResponse500 = {
  data: ErrorResponse
  status: 500
}

export type getCaseResponseSuccess = (getCaseResponse200) & {
  headers: Headers;
};
export type getCaseResponseError = (getCaseResponse400 | getCaseResponse401 | getCaseResponse404 | getCaseResponse409 | getCaseResponse500) & {
  headers: Headers;
};

export type getCaseResponse = (getCaseResponseSuccess | getCaseResponseError)

export const getGetCaseUrl = (id: string,
    params?: GetCaseParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/cases/${id}?${stringifiedParams}` : `/v1/cases/${id}`
}

/**
 * Retrieve a case by id.
 *
 * Related entities are not embedded — fetch them via the filtered list endpoints,
 * e.g. `GET /v1/worker-runs?case_id=…` and `GET /v1/artifacts?metadata[case_id]=…`.
 * @summary Get case
 */
export const getCase = async (id: string,
    params?: GetCaseParams, options?: RequestInit): Promise<getCaseResponse> => {

  const res = await fetch(getGetCaseUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getCaseResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getCaseResponse
}



export type addCaseLinksResponse200 = {
  data: AddCaseLinksEnvelope
  status: 200
}

export type addCaseLinksResponse400 = {
  data: ErrorResponse
  status: 400
}

export type addCaseLinksResponse401 = {
  data: ErrorResponse
  status: 401
}

export type addCaseLinksResponse404 = {
  data: ErrorResponse
  status: 404
}

export type addCaseLinksResponse409 = {
  data: ErrorResponse
  status: 409
}

export type addCaseLinksResponse500 = {
  data: ErrorResponse
  status: 500
}

export type addCaseLinksResponseSuccess = (addCaseLinksResponse200) & {
  headers: Headers;
};
export type addCaseLinksResponseError = (addCaseLinksResponse400 | addCaseLinksResponse401 | addCaseLinksResponse404 | addCaseLinksResponse409 | addCaseLinksResponse500) & {
  headers: Headers;
};

export type addCaseLinksResponse = (addCaseLinksResponseSuccess | addCaseLinksResponseError)

export const getAddCaseLinksUrl = (id: string,
    params?: AddCaseLinksParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/cases/${id}/links?${stringifiedParams}` : `/v1/cases/${id}/links`
}

/**
 * Link one or more entities (artifacts, calls, chats, emails, extracts, information requests, schedules, worker runs) to a case.
 *
 * The case and every entity must already exist in the tenant — unknown ids return 404 and nothing is created. Adding is idempotent: re-linking an already linked entity returns the existing link with its original `created_at`.
 * @summary Add case links
 */
export const addCaseLinks = async (id: string,
    addCaseLinksBody?: AddCaseLinksBody,
    params?: AddCaseLinksParams, options?: RequestInit): Promise<addCaseLinksResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getAddCaseLinksUrl(id,params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(addCaseLinksBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: addCaseLinksResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as addCaseLinksResponse
}



export type listCaseLinksResponse200 = {
  data: ListCaseLinksEnvelope
  status: 200
}

export type listCaseLinksResponse400 = {
  data: ErrorResponse
  status: 400
}

export type listCaseLinksResponse401 = {
  data: ErrorResponse
  status: 401
}

export type listCaseLinksResponse404 = {
  data: ErrorResponse
  status: 404
}

export type listCaseLinksResponse409 = {
  data: ErrorResponse
  status: 409
}

export type listCaseLinksResponse500 = {
  data: ErrorResponse
  status: 500
}

export type listCaseLinksResponseSuccess = (listCaseLinksResponse200) & {
  headers: Headers;
};
export type listCaseLinksResponseError = (listCaseLinksResponse400 | listCaseLinksResponse401 | listCaseLinksResponse404 | listCaseLinksResponse409 | listCaseLinksResponse500) & {
  headers: Headers;
};

export type listCaseLinksResponse = (listCaseLinksResponseSuccess | listCaseLinksResponseError)

export const getListCaseLinksUrl = (id: string,
    params?: ListCaseLinksParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/cases/${id}/links?${stringifiedParams}` : `/v1/cases/${id}/links`
}

/**
 * List the entities linked to a case, paginated and filterable by entity type.
 * @summary List case links
 */
export const listCaseLinks = async (id: string,
    params?: ListCaseLinksParams, options?: RequestInit): Promise<listCaseLinksResponse> => {

  const res = await fetch(getListCaseLinksUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: listCaseLinksResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as listCaseLinksResponse
}



export type removeCaseLinkResponse200 = {
  data: RemoveCaseLinkEnvelope
  status: 200
}

export type removeCaseLinkResponse400 = {
  data: ErrorResponse
  status: 400
}

export type removeCaseLinkResponse401 = {
  data: ErrorResponse
  status: 401
}

export type removeCaseLinkResponse404 = {
  data: ErrorResponse
  status: 404
}

export type removeCaseLinkResponse409 = {
  data: ErrorResponse
  status: 409
}

export type removeCaseLinkResponse500 = {
  data: ErrorResponse
  status: 500
}

export type removeCaseLinkResponseSuccess = (removeCaseLinkResponse200) & {
  headers: Headers;
};
export type removeCaseLinkResponseError = (removeCaseLinkResponse400 | removeCaseLinkResponse401 | removeCaseLinkResponse404 | removeCaseLinkResponse409 | removeCaseLinkResponse500) & {
  headers: Headers;
};

export type removeCaseLinkResponse = (removeCaseLinkResponseSuccess | removeCaseLinkResponseError)

export const getRemoveCaseLinkUrl = (id: string,
    entityType: 'artifact' | 'call' | 'chat' | 'email' | 'extract' | 'information_request' | 'schedule' | 'worker_run',
    entityId: string,
    params?: RemoveCaseLinkParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/cases/${id}/links/${entityType}/${entityId}?${stringifiedParams}` : `/v1/cases/${id}/links/${entityType}/${entityId}`
}

/**
 * Remove the link between a case and an entity. Removal is idempotent: removing a link that does not exist succeeds without effect.
 * @summary Remove case link
 */
export const removeCaseLink = async (id: string,
    entityType: 'artifact' | 'call' | 'chat' | 'email' | 'extract' | 'information_request' | 'schedule' | 'worker_run',
    entityId: string,
    params?: RemoveCaseLinkParams, options?: RequestInit): Promise<removeCaseLinkResponse> => {

  const res = await fetch(getRemoveCaseLinkUrl(id,entityType,entityId,params),
  {
    ...options,
    method: 'DELETE'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: removeCaseLinkResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as removeCaseLinkResponse
}



export type createChatAgentResponse200 = {
  data: CreateChatAgentEnvelope
  status: 200
}

export type createChatAgentResponse400 = {
  data: ErrorResponse
  status: 400
}

export type createChatAgentResponse401 = {
  data: ErrorResponse
  status: 401
}

export type createChatAgentResponse409 = {
  data: ErrorResponse
  status: 409
}

export type createChatAgentResponse500 = {
  data: ErrorResponse
  status: 500
}

export type createChatAgentResponseSuccess = (createChatAgentResponse200) & {
  headers: Headers;
};
export type createChatAgentResponseError = (createChatAgentResponse400 | createChatAgentResponse401 | createChatAgentResponse409 | createChatAgentResponse500) & {
  headers: Headers;
};

export type createChatAgentResponse = (createChatAgentResponseSuccess | createChatAgentResponseError)

export const getCreateChatAgentUrl = () => {




  return `/v1/chat-agents`
}

/**
 * Create a new chat agent with a name and prompt.
 * @summary Create chat agent
 */
export const createChatAgent = async (createChatAgentBody?: CreateChatAgentBody, options?: RequestInit): Promise<createChatAgentResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getCreateChatAgentUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createChatAgentBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: createChatAgentResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as createChatAgentResponse
}



export type listChatAgentsResponse200 = {
  data: ListChatAgentsEnvelope
  status: 200
}

export type listChatAgentsResponse400 = {
  data: ErrorResponse
  status: 400
}

export type listChatAgentsResponse401 = {
  data: ErrorResponse
  status: 401
}

export type listChatAgentsResponse409 = {
  data: ErrorResponse
  status: 409
}

export type listChatAgentsResponse500 = {
  data: ErrorResponse
  status: 500
}

export type listChatAgentsResponseSuccess = (listChatAgentsResponse200) & {
  headers: Headers;
};
export type listChatAgentsResponseError = (listChatAgentsResponse400 | listChatAgentsResponse401 | listChatAgentsResponse409 | listChatAgentsResponse500) & {
  headers: Headers;
};

export type listChatAgentsResponse = (listChatAgentsResponseSuccess | listChatAgentsResponseError)

export const getListChatAgentsUrl = (params?: ListChatAgentsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/chat-agents?${stringifiedParams}` : `/v1/chat-agents`
}

/**
 * List the tenant's chat agents with pagination and sorting. Prompts are not returned.
 * @summary List chat agents
 */
export const listChatAgents = async (params?: ListChatAgentsParams, options?: RequestInit): Promise<listChatAgentsResponse> => {

  const res = await fetch(getListChatAgentsUrl(params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: listChatAgentsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as listChatAgentsResponse
}



export type getChatAgentResponse200 = {
  data: GetChatAgentEnvelope
  status: 200
}

export type getChatAgentResponse400 = {
  data: ErrorResponse
  status: 400
}

export type getChatAgentResponse401 = {
  data: ErrorResponse
  status: 401
}

export type getChatAgentResponse404 = {
  data: ErrorResponse
  status: 404
}

export type getChatAgentResponse409 = {
  data: ErrorResponse
  status: 409
}

export type getChatAgentResponse500 = {
  data: ErrorResponse
  status: 500
}

export type getChatAgentResponseSuccess = (getChatAgentResponse200) & {
  headers: Headers;
};
export type getChatAgentResponseError = (getChatAgentResponse400 | getChatAgentResponse401 | getChatAgentResponse404 | getChatAgentResponse409 | getChatAgentResponse500) & {
  headers: Headers;
};

export type getChatAgentResponse = (getChatAgentResponseSuccess | getChatAgentResponseError)

export const getGetChatAgentUrl = (chatAgentId: string,) => {




  return `/v1/chat-agents/${chatAgentId}`
}

/**
 * Retrieve a single chat agent by ID, including the IDs of its attached code tools. The prompt is not returned.
 * @summary Get chat agent
 */
export const getChatAgent = async (chatAgentId: string, options?: RequestInit): Promise<getChatAgentResponse> => {

  const res = await fetch(getGetChatAgentUrl(chatAgentId),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getChatAgentResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getChatAgentResponse
}



export type updateChatAgentResponse200 = {
  data: UpdateChatAgentEnvelope
  status: 200
}

export type updateChatAgentResponse400 = {
  data: ErrorResponse
  status: 400
}

export type updateChatAgentResponse401 = {
  data: ErrorResponse
  status: 401
}

export type updateChatAgentResponse404 = {
  data: ErrorResponse
  status: 404
}

export type updateChatAgentResponse409 = {
  data: ErrorResponse
  status: 409
}

export type updateChatAgentResponse500 = {
  data: ErrorResponse
  status: 500
}

export type updateChatAgentResponseSuccess = (updateChatAgentResponse200) & {
  headers: Headers;
};
export type updateChatAgentResponseError = (updateChatAgentResponse400 | updateChatAgentResponse401 | updateChatAgentResponse404 | updateChatAgentResponse409 | updateChatAgentResponse500) & {
  headers: Headers;
};

export type updateChatAgentResponse = (updateChatAgentResponseSuccess | updateChatAgentResponseError)

export const getUpdateChatAgentUrl = (chatAgentId: string,) => {




  return `/v1/chat-agents/${chatAgentId}`
}

/**
 * Patch a chat agent's settings. Today only the attached code tool set can be edited; future fields will be added under the same endpoint. The response returns the chat agent's metadata only and does not include the resulting tool list; the agent's `updated_at` is not bumped when only the tool set changes.
 * @summary Update chat agent
 */
export const updateChatAgent = async (chatAgentId: string,
    updateChatAgentRequest?: UpdateChatAgentRequest, options?: RequestInit): Promise<updateChatAgentResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getUpdateChatAgentUrl(chatAgentId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateChatAgentRequest)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: updateChatAgentResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as updateChatAgentResponse
}



export type deleteChatAgentResponse200 = {
  data: DeleteChatAgentEnvelope
  status: 200
}

export type deleteChatAgentResponse400 = {
  data: ErrorResponse
  status: 400
}

export type deleteChatAgentResponse401 = {
  data: ErrorResponse
  status: 401
}

export type deleteChatAgentResponse404 = {
  data: ErrorResponse
  status: 404
}

export type deleteChatAgentResponse409 = {
  data: ErrorResponse
  status: 409
}

export type deleteChatAgentResponse500 = {
  data: ErrorResponse
  status: 500
}

export type deleteChatAgentResponseSuccess = (deleteChatAgentResponse200) & {
  headers: Headers;
};
export type deleteChatAgentResponseError = (deleteChatAgentResponse400 | deleteChatAgentResponse401 | deleteChatAgentResponse404 | deleteChatAgentResponse409 | deleteChatAgentResponse500) & {
  headers: Headers;
};

export type deleteChatAgentResponse = (deleteChatAgentResponseSuccess | deleteChatAgentResponseError)

export const getDeleteChatAgentUrl = (chatAgentId: string,) => {




  return `/v1/chat-agents/${chatAgentId}`
}

/**
 * Soft-delete a chat agent. The agent no longer appears in any read and stops accepting new chats; existing chats and messages are preserved.
 * @summary Delete chat agent
 */
export const deleteChatAgent = async (chatAgentId: string, options?: RequestInit): Promise<deleteChatAgentResponse> => {

  const res = await fetch(getDeleteChatAgentUrl(chatAgentId),
  {
    ...options,
    method: 'DELETE'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: deleteChatAgentResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as deleteChatAgentResponse
}



export type getChatAgentPromptResponse200 = {
  data: GetChatAgentPromptEnvelope
  status: 200
}

export type getChatAgentPromptResponse400 = {
  data: ErrorResponse
  status: 400
}

export type getChatAgentPromptResponse401 = {
  data: ErrorResponse
  status: 401
}

export type getChatAgentPromptResponse404 = {
  data: ErrorResponse
  status: 404
}

export type getChatAgentPromptResponse409 = {
  data: ErrorResponse
  status: 409
}

export type getChatAgentPromptResponse500 = {
  data: ErrorResponse
  status: 500
}

export type getChatAgentPromptResponseSuccess = (getChatAgentPromptResponse200) & {
  headers: Headers;
};
export type getChatAgentPromptResponseError = (getChatAgentPromptResponse400 | getChatAgentPromptResponse401 | getChatAgentPromptResponse404 | getChatAgentPromptResponse409 | getChatAgentPromptResponse500) & {
  headers: Headers;
};

export type getChatAgentPromptResponse = (getChatAgentPromptResponseSuccess | getChatAgentPromptResponseError)

export const getGetChatAgentPromptUrl = (chatAgentId: string,) => {




  return `/v1/chat-agents/${chatAgentId}/prompt`
}

/**
 * Retrieve the prompt and greeting for a chat agent. Internal use only.
 * @summary Get chat agent prompt
 */
export const getChatAgentPrompt = async (chatAgentId: string, options?: RequestInit): Promise<getChatAgentPromptResponse> => {

  const res = await fetch(getGetChatAgentPromptUrl(chatAgentId),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getChatAgentPromptResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getChatAgentPromptResponse
}



export type updateChatAgentPromptResponse200 = {
  data: UpdateChatAgentPromptEnvelope
  status: 200
}

export type updateChatAgentPromptResponse400 = {
  data: ErrorResponse
  status: 400
}

export type updateChatAgentPromptResponse401 = {
  data: ErrorResponse
  status: 401
}

export type updateChatAgentPromptResponse404 = {
  data: ErrorResponse
  status: 404
}

export type updateChatAgentPromptResponse409 = {
  data: ErrorResponse
  status: 409
}

export type updateChatAgentPromptResponse500 = {
  data: ErrorResponse
  status: 500
}

export type updateChatAgentPromptResponseSuccess = (updateChatAgentPromptResponse200) & {
  headers: Headers;
};
export type updateChatAgentPromptResponseError = (updateChatAgentPromptResponse400 | updateChatAgentPromptResponse401 | updateChatAgentPromptResponse404 | updateChatAgentPromptResponse409 | updateChatAgentPromptResponse500) & {
  headers: Headers;
};

export type updateChatAgentPromptResponse = (updateChatAgentPromptResponseSuccess | updateChatAgentPromptResponseError)

export const getUpdateChatAgentPromptUrl = (chatAgentId: string,) => {




  return `/v1/chat-agents/${chatAgentId}/prompt`
}

/**
 * Update the prompt and/or greeting for a chat agent. Internal use only.
 * @summary Update chat agent prompt
 */
export const updateChatAgentPrompt = async (chatAgentId: string,
    updateChatAgentPromptBody?: UpdateChatAgentPromptBody, options?: RequestInit): Promise<updateChatAgentPromptResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getUpdateChatAgentPromptUrl(chatAgentId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateChatAgentPromptBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: updateChatAgentPromptResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as updateChatAgentPromptResponse
}



export type createChatResponse201 = {
  data: CreateChatEnvelope
  status: 201
}

export type createChatResponse400 = {
  data: ErrorResponse
  status: 400
}

export type createChatResponse401 = {
  data: ErrorResponse
  status: 401
}

export type createChatResponse409 = {
  data: ErrorResponse
  status: 409
}

export type createChatResponse500 = {
  data: ErrorResponse
  status: 500
}

export type createChatResponseSuccess = (createChatResponse201) & {
  headers: Headers;
};
export type createChatResponseError = (createChatResponse400 | createChatResponse401 | createChatResponse409 | createChatResponse500) & {
  headers: Headers;
};

export type createChatResponse = (createChatResponseSuccess | createChatResponseError)

export const getCreateChatUrl = () => {




  return `/public/v1/chats`
}

/**
 * Create a new chat against an existing chat agent. The chat agent's tenant becomes the owner of the chat.
 * @summary Create a chat
 */
export const createChat = async (createChatBody?: CreateChatBody, options?: RequestInit): Promise<createChatResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getCreateChatUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createChatBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: createChatResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as createChatResponse
}



export type getChatResponse200 = {
  data: GetChatEnvelope
  status: 200
}

export type getChatResponse400 = {
  data: ErrorResponse
  status: 400
}

export type getChatResponse401 = {
  data: ErrorResponse
  status: 401
}

export type getChatResponse404 = {
  data: ErrorResponse
  status: 404
}

export type getChatResponse409 = {
  data: ErrorResponse
  status: 409
}

export type getChatResponse500 = {
  data: ErrorResponse
  status: 500
}

export type getChatResponseSuccess = (getChatResponse200) & {
  headers: Headers;
};
export type getChatResponseError = (getChatResponse400 | getChatResponse401 | getChatResponse404 | getChatResponse409 | getChatResponse500) & {
  headers: Headers;
};

export type getChatResponse = (getChatResponseSuccess | getChatResponseError)

export const getGetChatUrl = (chatId: string,) => {




  return `/public/v1/chats/${chatId}`
}

/**
 * Return a chat and its messages in chronological order. Used to re-render a transcript after a reload. Only `user` and `assistant` messages are included; tool calls and tool results are omitted. Each message's `content` is the concatenation of its text blocks separated by newlines.
 *
 * For compatibility this endpoint is also available using the following (deprecated) paths:
 * `GET /public/v1/chat`
 * @summary Get a chat
 */
export const getChat = async (chatId: string, options?: RequestInit): Promise<getChatResponse> => {

  const res = await fetch(getGetChatUrl(chatId),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getChatResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getChatResponse
}



export type getPublicChatAgentResponse200 = {
  data: GetPublicChatAgentEnvelope
  status: 200
}

export type getPublicChatAgentResponse400 = {
  data: ErrorResponse
  status: 400
}

export type getPublicChatAgentResponse401 = {
  data: ErrorResponse
  status: 401
}

export type getPublicChatAgentResponse404 = {
  data: ErrorResponse
  status: 404
}

export type getPublicChatAgentResponse409 = {
  data: ErrorResponse
  status: 409
}

export type getPublicChatAgentResponse500 = {
  data: ErrorResponse
  status: 500
}

export type getPublicChatAgentResponseSuccess = (getPublicChatAgentResponse200) & {
  headers: Headers;
};
export type getPublicChatAgentResponseError = (getPublicChatAgentResponse400 | getPublicChatAgentResponse401 | getPublicChatAgentResponse404 | getPublicChatAgentResponse409 | getPublicChatAgentResponse500) & {
  headers: Headers;
};

export type getPublicChatAgentResponse = (getPublicChatAgentResponseSuccess | getPublicChatAgentResponseError)

export const getGetPublicChatAgentUrl = (chatAgentId: string,) => {




  return `/public/v1/chat-agents/${chatAgentId}`
}

/**
 * Return the public-facing fields of a chat agent for use in the chat UI. Sensitive fields such as the agent's prompt and tenant ID are not exposed.
 * @summary Get a chat agent (public)
 */
export const getPublicChatAgent = async (chatAgentId: string, options?: RequestInit): Promise<getPublicChatAgentResponse> => {

  const res = await fetch(getGetPublicChatAgentUrl(chatAgentId),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getPublicChatAgentResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getPublicChatAgentResponse
}



export type postChatMessageResponse201 = {
  data: PostChatMessageEnvelope
  status: 201
}

export type postChatMessageResponse400 = {
  data: ErrorResponse
  status: 400
}

export type postChatMessageResponse401 = {
  data: ErrorResponse
  status: 401
}

export type postChatMessageResponse404 = {
  data: ErrorResponse
  status: 404
}

export type postChatMessageResponse409 = {
  data: ErrorResponse
  status: 409
}

export type postChatMessageResponse500 = {
  data: ErrorResponse
  status: 500
}

export type postChatMessageResponseSuccess = (postChatMessageResponse201) & {
  headers: Headers;
};
export type postChatMessageResponseError = (postChatMessageResponse400 | postChatMessageResponse401 | postChatMessageResponse404 | postChatMessageResponse409 | postChatMessageResponse500) & {
  headers: Headers;
};

export type postChatMessageResponse = (postChatMessageResponseSuccess | postChatMessageResponseError)

export const getPostChatMessageUrl = (chatId: string,) => {




  return `/public/v1/chats/${chatId}/messages`
}

/**
 * Post a user message to an existing chat and return the assistant reply. Both messages are persisted.
 *
 * For compatibility this endpoint is also available using the following (deprecated) paths:
 * `POST /public/v1/chat/messages`
 * @summary Post a message to a chat
 */
export const postChatMessage = async (chatId: string,
    postChatMessageBody?: PostChatMessageBody, options?: RequestInit): Promise<postChatMessageResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getPostChatMessageUrl(chatId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(postChatMessageBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postChatMessageResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as postChatMessageResponse
}



export type listChatsResponse200 = {
  data: ListChatsEnvelope
  status: 200
}

export type listChatsResponse400 = {
  data: ErrorResponse
  status: 400
}

export type listChatsResponse401 = {
  data: ErrorResponse
  status: 401
}

export type listChatsResponse409 = {
  data: ErrorResponse
  status: 409
}

export type listChatsResponse500 = {
  data: ErrorResponse
  status: 500
}

export type listChatsResponseSuccess = (listChatsResponse200) & {
  headers: Headers;
};
export type listChatsResponseError = (listChatsResponse400 | listChatsResponse401 | listChatsResponse409 | listChatsResponse500) & {
  headers: Headers;
};

export type listChatsResponse = (listChatsResponseSuccess | listChatsResponseError)

export const getListChatsUrl = (params?: ListChatsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/chats?${stringifiedParams}` : `/v1/chats`
}

/**
 * List the tenant's chats with pagination, sorting, and optional filtering by case. Returns chat metadata and message counts; messages are not included.
 * @summary List chats
 */
export const listChats = async (params?: ListChatsParams, options?: RequestInit): Promise<listChatsResponse> => {

  const res = await fetch(getListChatsUrl(params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: listChatsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as listChatsResponse
}



export type listChatMessagesResponse200 = {
  data: ListChatMessagesEnvelope
  status: 200
}

export type listChatMessagesResponse400 = {
  data: ErrorResponse
  status: 400
}

export type listChatMessagesResponse401 = {
  data: ErrorResponse
  status: 401
}

export type listChatMessagesResponse404 = {
  data: ErrorResponse
  status: 404
}

export type listChatMessagesResponse409 = {
  data: ErrorResponse
  status: 409
}

export type listChatMessagesResponse500 = {
  data: ErrorResponse
  status: 500
}

export type listChatMessagesResponseSuccess = (listChatMessagesResponse200) & {
  headers: Headers;
};
export type listChatMessagesResponseError = (listChatMessagesResponse400 | listChatMessagesResponse401 | listChatMessagesResponse404 | listChatMessagesResponse409 | listChatMessagesResponse500) & {
  headers: Headers;
};

export type listChatMessagesResponse = (listChatMessagesResponseSuccess | listChatMessagesResponseError)

export const getListChatMessagesUrl = (chatId: string,
    params?: ListChatMessagesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/chats/${chatId}/messages?${stringifiedParams}` : `/v1/chats/${chatId}/messages`
}

/**
 * List messages for a chat owned by the tenant, in chronological order by default.
 * @summary List chat messages
 */
export const listChatMessages = async (chatId: string,
    params?: ListChatMessagesParams, options?: RequestInit): Promise<listChatMessagesResponse> => {

  const res = await fetch(getListChatMessagesUrl(chatId,params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: listChatMessagesResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as listChatMessagesResponse
}



export type getExtractResponse200 = {
  data: GetExtractEnvelope
  status: 200
}

export type getExtractResponse400 = {
  data: ErrorResponse
  status: 400
}

export type getExtractResponse401 = {
  data: ErrorResponse
  status: 401
}

export type getExtractResponse404 = {
  data: ErrorResponse
  status: 404
}

export type getExtractResponse409 = {
  data: ErrorResponse
  status: 409
}

export type getExtractResponse500 = {
  data: ErrorResponse
  status: 500
}

export type getExtractResponseSuccess = (getExtractResponse200) & {
  headers: Headers;
};
export type getExtractResponseError = (getExtractResponse400 | getExtractResponse401 | getExtractResponse404 | getExtractResponse409 | getExtractResponse500) & {
  headers: Headers;
};

export type getExtractResponse = (getExtractResponseSuccess | getExtractResponseError)

export const getGetExtractUrl = (id: string,) => {




  return `/v1/extracts/${id}`
}

/**
 * Retrieve a single extract by ID, including the extraction result data.
 * @summary Get extract
 */
export const getExtract = async (id: string, options?: RequestInit): Promise<getExtractResponse> => {

  const res = await fetch(getGetExtractUrl(id),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getExtractResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getExtractResponse
}



export type getExtractCitationsResponse200 = {
  data: GetExtractCitationsEnvelope
  status: 200
}

export type getExtractCitationsResponse400 = {
  data: ErrorResponse
  status: 400
}

export type getExtractCitationsResponse401 = {
  data: ErrorResponse
  status: 401
}

export type getExtractCitationsResponse404 = {
  data: ErrorResponse
  status: 404
}

export type getExtractCitationsResponse409 = {
  data: ErrorResponse
  status: 409
}

export type getExtractCitationsResponse500 = {
  data: ErrorResponse
  status: 500
}

export type getExtractCitationsResponseSuccess = (getExtractCitationsResponse200) & {
  headers: Headers;
};
export type getExtractCitationsResponseError = (getExtractCitationsResponse400 | getExtractCitationsResponse401 | getExtractCitationsResponse404 | getExtractCitationsResponse409 | getExtractCitationsResponse500) & {
  headers: Headers;
};

export type getExtractCitationsResponse = (getExtractCitationsResponseSuccess | getExtractCitationsResponseError)

export const getGetExtractCitationsUrl = (id: string,) => {




  return `/v1/extracts/${id}/citations`
}

/**
 * Retrieve the citation tree with resolved chunk data for a given extract. Returns 404 if the extract does not exist or has no citations (the citations sub-resource is not available).
 * @summary Get extract citations
 */
export const getExtractCitations = async (id: string, options?: RequestInit): Promise<getExtractCitationsResponse> => {

  const res = await fetch(getGetExtractCitationsUrl(id),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getExtractCitationsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getExtractCitationsResponse
}



export type listExtractsResponse200 = {
  data: ListExtractsEnvelope
  status: 200
}

export type listExtractsResponse400 = {
  data: ErrorResponse
  status: 400
}

export type listExtractsResponse401 = {
  data: ErrorResponse
  status: 401
}

export type listExtractsResponse409 = {
  data: ErrorResponse
  status: 409
}

export type listExtractsResponse500 = {
  data: ErrorResponse
  status: 500
}

export type listExtractsResponseSuccess = (listExtractsResponse200) & {
  headers: Headers;
};
export type listExtractsResponseError = (listExtractsResponse400 | listExtractsResponse401 | listExtractsResponse409 | listExtractsResponse500) & {
  headers: Headers;
};

export type listExtractsResponse = (listExtractsResponseSuccess | listExtractsResponseError)

export const getListExtractsUrl = (params?: ListExtractsParams,) => {
  const normalizedParams = new URLSearchParams();
  const deepObjectEntries: string[] = [];

  Object.entries(params || {}).forEach(([key, value]) => {
    const deepObjectParameters = ["scope"];

    if (typeof value === 'object' && value !== null && !Array.isArray(value) && deepObjectParameters.includes(key)) {
      Object.entries(value).forEach(([subKey, subValue]) => {
        if (subValue !== undefined) {
          deepObjectEntries.push(encodeURIComponent(key) + '[' + encodeURIComponent(subKey) + ']=' + (subValue === null ? 'null' : encodeURIComponent(String(subValue))));
        }
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = [normalizedParams.toString(), deepObjectEntries.join('&')].filter(Boolean).join('&');

  return stringifiedParams.length > 0 ? `/v1/extracts?${stringifiedParams}` : `/v1/extracts`
}

/**
 * List all extracts with pagination, filtering, and sorting.
 *
 * **Scope Filtering:**
 *
 * Use bracket notation to filter by scope keys:
 * - `scope[claim_id]=abc-123`
 *
 * Multiple scope filters can be combined (AND logic).
 * @summary List extracts
 */
export const listExtracts = async (params?: ListExtractsParams, options?: RequestInit): Promise<listExtractsResponse> => {

  const res = await fetch(getListExtractsUrl(params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: listExtractsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as listExtractsResponse
}



export type getProfileResponse200 = {
  data: GetProfileEnvelope
  status: 200
}

export type getProfileResponse400 = {
  data: ErrorResponse
  status: 400
}

export type getProfileResponse401 = {
  data: ErrorResponse
  status: 401
}

export type getProfileResponse409 = {
  data: ErrorResponse
  status: 409
}

export type getProfileResponse500 = {
  data: ErrorResponse
  status: 500
}

export type getProfileResponseSuccess = (getProfileResponse200) & {
  headers: Headers;
};
export type getProfileResponseError = (getProfileResponse400 | getProfileResponse401 | getProfileResponse409 | getProfileResponse500) & {
  headers: Headers;
};

export type getProfileResponse = (getProfileResponseSuccess | getProfileResponseError)

export const getGetProfileUrl = () => {




  return `/v1/profile`
}

/**
 * Retrieve the current user's profile information. This endpoint requires a user session and cannot be used with API Keys.
 * @summary Get profile
 */
export const getProfile = async ( options?: RequestInit): Promise<getProfileResponse> => {

  const res = await fetch(getGetProfileUrl(),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getProfileResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getProfileResponse
}



export type listTeamMembersResponse200 = {
  data: ListTeamMembersEnvelope
  status: 200
}

export type listTeamMembersResponse400 = {
  data: ErrorResponse
  status: 400
}

export type listTeamMembersResponse401 = {
  data: ErrorResponse
  status: 401
}

export type listTeamMembersResponse409 = {
  data: ErrorResponse
  status: 409
}

export type listTeamMembersResponse500 = {
  data: ErrorResponse
  status: 500
}

export type listTeamMembersResponseSuccess = (listTeamMembersResponse200) & {
  headers: Headers;
};
export type listTeamMembersResponseError = (listTeamMembersResponse400 | listTeamMembersResponse401 | listTeamMembersResponse409 | listTeamMembersResponse500) & {
  headers: Headers;
};

export type listTeamMembersResponse = (listTeamMembersResponseSuccess | listTeamMembersResponseError)

export const getListTeamMembersUrl = () => {




  return `/v1/team/members`
}

/**
 * List all members in the current tenant.
 * @summary List team members
 */
export const listTeamMembers = async ( options?: RequestInit): Promise<listTeamMembersResponse> => {

  const res = await fetch(getListTeamMembersUrl(),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: listTeamMembersResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as listTeamMembersResponse
}



export type inviteTeamMemberResponse201 = {
  data: InviteTeamMemberEnvelope
  status: 201
}

export type inviteTeamMemberResponse400 = {
  data: ErrorResponse
  status: 400
}

export type inviteTeamMemberResponse401 = {
  data: ErrorResponse
  status: 401
}

export type inviteTeamMemberResponse409 = {
  data: ErrorResponse
  status: 409
}

export type inviteTeamMemberResponse500 = {
  data: ErrorResponse
  status: 500
}

export type inviteTeamMemberResponseSuccess = (inviteTeamMemberResponse201) & {
  headers: Headers;
};
export type inviteTeamMemberResponseError = (inviteTeamMemberResponse400 | inviteTeamMemberResponse401 | inviteTeamMemberResponse409 | inviteTeamMemberResponse500) & {
  headers: Headers;
};

export type inviteTeamMemberResponse = (inviteTeamMemberResponseSuccess | inviteTeamMemberResponseError)

export const getInviteTeamMemberUrl = () => {




  return `/v1/team/invitations`
}

/**
 * Invite an email address to join the current tenant. The invitee receives an email and joins at the `member` role once they accept; promote them afterwards with `PATCH /v1/team/members/{id}`.
 *
 * Requires the `teams:write` permission.
 *
 * Returns `409` if the address already has a pending invitation or is already a member.
 * @summary Invite a team member
 */
export const inviteTeamMember = async (inviteTeamMemberBody?: InviteTeamMemberBody, options?: RequestInit): Promise<inviteTeamMemberResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getInviteTeamMemberUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(inviteTeamMemberBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: inviteTeamMemberResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as inviteTeamMemberResponse
}



export type listTeamInvitationsResponse200 = {
  data: ListTeamInvitationsEnvelope
  status: 200
}

export type listTeamInvitationsResponse400 = {
  data: ErrorResponse
  status: 400
}

export type listTeamInvitationsResponse401 = {
  data: ErrorResponse
  status: 401
}

export type listTeamInvitationsResponse409 = {
  data: ErrorResponse
  status: 409
}

export type listTeamInvitationsResponse500 = {
  data: ErrorResponse
  status: 500
}

export type listTeamInvitationsResponseSuccess = (listTeamInvitationsResponse200) & {
  headers: Headers;
};
export type listTeamInvitationsResponseError = (listTeamInvitationsResponse400 | listTeamInvitationsResponse401 | listTeamInvitationsResponse409 | listTeamInvitationsResponse500) & {
  headers: Headers;
};

export type listTeamInvitationsResponse = (listTeamInvitationsResponseSuccess | listTeamInvitationsResponseError)

export const getListTeamInvitationsUrl = () => {




  return `/v1/team/invitations`
}

/**
 * List the invitations for the current tenant that are still awaiting acceptance. Accepted, revoked and expired invitations are not returned.
 *
 * Invitees are not team members yet, so they do not appear in `GET /v1/team/members`. A member-management screen shows both by merging the two lists.
 *
 * Requires the `teams:write` permission.
 * @summary List pending team invitations
 */
export const listTeamInvitations = async ( options?: RequestInit): Promise<listTeamInvitationsResponse> => {

  const res = await fetch(getListTeamInvitationsUrl(),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: listTeamInvitationsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as listTeamInvitationsResponse
}



export type revokeTeamInvitationResponse204 = {
  data: void
  status: 204
}

export type revokeTeamInvitationResponse400 = {
  data: ErrorResponse
  status: 400
}

export type revokeTeamInvitationResponse401 = {
  data: ErrorResponse
  status: 401
}

export type revokeTeamInvitationResponse404 = {
  data: ErrorResponse
  status: 404
}

export type revokeTeamInvitationResponse409 = {
  data: ErrorResponse
  status: 409
}

export type revokeTeamInvitationResponse500 = {
  data: ErrorResponse
  status: 500
}

export type revokeTeamInvitationResponseSuccess = (revokeTeamInvitationResponse204) & {
  headers: Headers;
};
export type revokeTeamInvitationResponseError = (revokeTeamInvitationResponse400 | revokeTeamInvitationResponse401 | revokeTeamInvitationResponse404 | revokeTeamInvitationResponse409 | revokeTeamInvitationResponse500) & {
  headers: Headers;
};

export type revokeTeamInvitationResponse = (revokeTeamInvitationResponseSuccess | revokeTeamInvitationResponseError)

export const getRevokeTeamInvitationUrl = (invitationId: string,) => {




  return `/v1/team/invitations/${invitationId}`
}

/**
 * Cancel a pending invitation. The link that was emailed to the invitee stops working, and the address becomes free to invite again.
 *
 * Idempotent: an invitation that was already accepted, revoked or expired also returns `204`.
 *
 * Requires the `teams:write` permission.
 *
 * Returns `404` for an unknown invitation or one that belongs to another tenant.
 * @summary Revoke a team invitation
 */
export const revokeTeamInvitation = async (invitationId: string, options?: RequestInit): Promise<revokeTeamInvitationResponse> => {

  const res = await fetch(getRevokeTeamInvitationUrl(invitationId),
  {
    ...options,
    method: 'DELETE'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: revokeTeamInvitationResponse['data'] = body ? JSON.parse(body) : undefined
  return { data, status: res.status, headers: res.headers } as revokeTeamInvitationResponse
}



export type resendTeamInvitationResponse200 = {
  data: ResendTeamInvitationEnvelope
  status: 200
}

export type resendTeamInvitationResponse400 = {
  data: ErrorResponse
  status: 400
}

export type resendTeamInvitationResponse401 = {
  data: ErrorResponse
  status: 401
}

export type resendTeamInvitationResponse404 = {
  data: ErrorResponse
  status: 404
}

export type resendTeamInvitationResponse409 = {
  data: ErrorResponse
  status: 409
}

export type resendTeamInvitationResponse500 = {
  data: ErrorResponse
  status: 500
}

export type resendTeamInvitationResponseSuccess = (resendTeamInvitationResponse200) & {
  headers: Headers;
};
export type resendTeamInvitationResponseError = (resendTeamInvitationResponse400 | resendTeamInvitationResponse401 | resendTeamInvitationResponse404 | resendTeamInvitationResponse409 | resendTeamInvitationResponse500) & {
  headers: Headers;
};

export type resendTeamInvitationResponse = (resendTeamInvitationResponseSuccess | resendTeamInvitationResponseError)

export const getResendTeamInvitationUrl = (invitationId: string,) => {




  return `/v1/team/invitations/${invitationId}/resend`
}

/**
 * Email the invitation to its recipient again, for an invite that never arrived. The invitation keeps its `id` and its original expiry — this re-sends the existing link rather than issuing a new one.
 *
 * To give someone a genuinely fresh 5 days, revoke the invitation and send a new one instead.
 *
 * Requires the `teams:write` permission.
 *
 * Returns `409` if the invitation is no longer pending — it was accepted, revoked or expired underneath the caller — and `404` for an unknown invitation or one that belongs to another tenant.
 * @summary Resend a team invitation
 */
export const resendTeamInvitation = async (invitationId: string, options?: RequestInit): Promise<resendTeamInvitationResponse> => {

  const res = await fetch(getResendTeamInvitationUrl(invitationId),
  {
    ...options,
    method: 'POST'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: resendTeamInvitationResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as resendTeamInvitationResponse
}



export type updateMemberRoleResponse200 = {
  data: UpdateMemberRoleEnvelope
  status: 200
}

export type updateMemberRoleResponse400 = {
  data: ErrorResponse
  status: 400
}

export type updateMemberRoleResponse401 = {
  data: ErrorResponse
  status: 401
}

export type updateMemberRoleResponse404 = {
  data: ErrorResponse
  status: 404
}

export type updateMemberRoleResponse409 = {
  data: ErrorResponse
  status: 409
}

export type updateMemberRoleResponse500 = {
  data: ErrorResponse
  status: 500
}

export type updateMemberRoleResponseSuccess = (updateMemberRoleResponse200) & {
  headers: Headers;
};
export type updateMemberRoleResponseError = (updateMemberRoleResponse400 | updateMemberRoleResponse401 | updateMemberRoleResponse404 | updateMemberRoleResponse409 | updateMemberRoleResponse500) & {
  headers: Headers;
};

export type updateMemberRoleResponse = (updateMemberRoleResponseSuccess | updateMemberRoleResponseError)

export const getUpdateMemberRoleUrl = (id: string,) => {




  return `/v1/team/members/${id}`
}

/**
 * Change the role of a team member.
 * @summary Update member role
 */
export const updateMemberRole = async (id: string,
    updateMemberRoleBody?: UpdateMemberRoleBody, options?: RequestInit): Promise<updateMemberRoleResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getUpdateMemberRoleUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateMemberRoleBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: updateMemberRoleResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as updateMemberRoleResponse
}



export type removeMemberResponse204 = {
  data: void
  status: 204
}

export type removeMemberResponse400 = {
  data: ErrorResponse
  status: 400
}

export type removeMemberResponse401 = {
  data: ErrorResponse
  status: 401
}

export type removeMemberResponse404 = {
  data: ErrorResponse
  status: 404
}

export type removeMemberResponse409 = {
  data: ErrorResponse
  status: 409
}

export type removeMemberResponse500 = {
  data: ErrorResponse
  status: 500
}

export type removeMemberResponseSuccess = (removeMemberResponse204) & {
  headers: Headers;
};
export type removeMemberResponseError = (removeMemberResponse400 | removeMemberResponse401 | removeMemberResponse404 | removeMemberResponse409 | removeMemberResponse500) & {
  headers: Headers;
};

export type removeMemberResponse = (removeMemberResponseSuccess | removeMemberResponseError)

export const getRemoveMemberUrl = (id: string,) => {




  return `/v1/team/members/${id}`
}

/**
 * Soft-delete a team member, revoking access on the next token refresh.
 * @summary Remove team member
 */
export const removeMember = async (id: string, options?: RequestInit): Promise<removeMemberResponse> => {

  const res = await fetch(getRemoveMemberUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: removeMemberResponse['data'] = body ? JSON.parse(body) : undefined
  return { data, status: res.status, headers: res.headers } as removeMemberResponse
}



export type createSecretResponse201 = {
  data: CreateSecretEnvelope
  status: 201
}

export type createSecretResponse400 = {
  data: ErrorResponse
  status: 400
}

export type createSecretResponse401 = {
  data: ErrorResponse
  status: 401
}

export type createSecretResponse409 = {
  data: ErrorResponse
  status: 409
}

export type createSecretResponse500 = {
  data: ErrorResponse
  status: 500
}

export type createSecretResponseSuccess = (createSecretResponse201) & {
  headers: Headers;
};
export type createSecretResponseError = (createSecretResponse400 | createSecretResponse401 | createSecretResponse409 | createSecretResponse500) & {
  headers: Headers;
};

export type createSecretResponse = (createSecretResponseSuccess | createSecretResponseError)

export const getCreateSecretUrl = () => {




  return `/v1/secrets`
}

/**
 * Create an organization-level secret. The value is encrypted at rest and **write-only** — no endpoint ever returns it.
 *
 * Requires the `secrets:write` permission. Env keys used by the worker runtime itself (e.g. `OPENAI_API_KEY`, `AVALLON_*`, `AWS_*`) are reserved and rejected.
 * @summary Create a secret
 */
export const createSecret = async (createSecretBody?: CreateSecretBody, options?: RequestInit): Promise<createSecretResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getCreateSecretUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createSecretBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: createSecretResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as createSecretResponse
}



export type listSecretsResponse200 = {
  data: ListSecretsEnvelope
  status: 200
}

export type listSecretsResponse400 = {
  data: ErrorResponse
  status: 400
}

export type listSecretsResponse401 = {
  data: ErrorResponse
  status: 401
}

export type listSecretsResponse409 = {
  data: ErrorResponse
  status: 409
}

export type listSecretsResponse500 = {
  data: ErrorResponse
  status: 500
}

export type listSecretsResponseSuccess = (listSecretsResponse200) & {
  headers: Headers;
};
export type listSecretsResponseError = (listSecretsResponse400 | listSecretsResponse401 | listSecretsResponse409 | listSecretsResponse500) & {
  headers: Headers;
};

export type listSecretsResponse = (listSecretsResponseSuccess | listSecretsResponseError)

export const getListSecretsUrl = (params?: ListSecretsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/secrets?${stringifiedParams}` : `/v1/secrets`
}

/**
 * List the organization's secrets with pagination and sorting. Values are never included. Requires the `secrets:read` permission.
 * @summary List secrets
 */
export const listSecrets = async (params?: ListSecretsParams, options?: RequestInit): Promise<listSecretsResponse> => {

  const res = await fetch(getListSecretsUrl(params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: listSecretsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as listSecretsResponse
}



export type getSecretResponse200 = {
  data: GetSecretEnvelope
  status: 200
}

export type getSecretResponse400 = {
  data: ErrorResponse
  status: 400
}

export type getSecretResponse401 = {
  data: ErrorResponse
  status: 401
}

export type getSecretResponse404 = {
  data: ErrorResponse
  status: 404
}

export type getSecretResponse409 = {
  data: ErrorResponse
  status: 409
}

export type getSecretResponse500 = {
  data: ErrorResponse
  status: 500
}

export type getSecretResponseSuccess = (getSecretResponse200) & {
  headers: Headers;
};
export type getSecretResponseError = (getSecretResponse400 | getSecretResponse401 | getSecretResponse404 | getSecretResponse409 | getSecretResponse500) & {
  headers: Headers;
};

export type getSecretResponse = (getSecretResponseSuccess | getSecretResponseError)

export const getGetSecretUrl = (secretId: string,) => {




  return `/v1/secrets/${secretId}`
}

/**
 * Get a secret's metadata. The value is never included. Requires the `secrets:read` permission.
 * @summary Get secret
 */
export const getSecret = async (secretId: string, options?: RequestInit): Promise<getSecretResponse> => {

  const res = await fetch(getGetSecretUrl(secretId),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getSecretResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getSecretResponse
}



export type updateSecretResponse200 = {
  data: UpdateSecretEnvelope
  status: 200
}

export type updateSecretResponse400 = {
  data: ErrorResponse
  status: 400
}

export type updateSecretResponse401 = {
  data: ErrorResponse
  status: 401
}

export type updateSecretResponse404 = {
  data: ErrorResponse
  status: 404
}

export type updateSecretResponse409 = {
  data: ErrorResponse
  status: 409
}

export type updateSecretResponse500 = {
  data: ErrorResponse
  status: 500
}

export type updateSecretResponseSuccess = (updateSecretResponse200) & {
  headers: Headers;
};
export type updateSecretResponseError = (updateSecretResponse400 | updateSecretResponse401 | updateSecretResponse404 | updateSecretResponse409 | updateSecretResponse500) & {
  headers: Headers;
};

export type updateSecretResponse = (updateSecretResponseSuccess | updateSecretResponseError)

export const getUpdateSecretUrl = (secretId: string,) => {




  return `/v1/secrets/${secretId}`
}

/**
 * Update a secret's display name or description, or rotate its live or test value. Rotation overwrites the stored value — previous values are not retrievable.
 *
 * The `env_key` is immutable: consumers of the secret receive the value under that key, so changing it would silently break them. Create a new secret instead.
 *
 * Requires the `secrets:write` permission.
 * @summary Update secret
 */
export const updateSecret = async (secretId: string,
    updateSecretBody?: UpdateSecretBody, options?: RequestInit): Promise<updateSecretResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getUpdateSecretUrl(secretId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateSecretBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: updateSecretResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as updateSecretResponse
}



export type deleteSecretResponse200 = {
  data: DeleteSecretEnvelope
  status: 200
}

export type deleteSecretResponse400 = {
  data: ErrorResponse
  status: 400
}

export type deleteSecretResponse401 = {
  data: ErrorResponse
  status: 401
}

export type deleteSecretResponse404 = {
  data: ErrorResponse
  status: 404
}

export type deleteSecretResponse409 = {
  data: ErrorResponse
  status: 409
}

export type deleteSecretResponse500 = {
  data: ErrorResponse
  status: 500
}

export type deleteSecretResponseSuccess = (deleteSecretResponse200) & {
  headers: Headers;
};
export type deleteSecretResponseError = (deleteSecretResponse400 | deleteSecretResponse401 | deleteSecretResponse404 | deleteSecretResponse409 | deleteSecretResponse500) & {
  headers: Headers;
};

export type deleteSecretResponse = (deleteSecretResponseSuccess | deleteSecretResponseError)

export const getDeleteSecretUrl = (secretId: string,) => {




  return `/v1/secrets/${secretId}`
}

/**
 * Delete a secret and detach it from all entities. Requires the `secrets:write` permission.
 * @summary Delete secret
 */
export const deleteSecret = async (secretId: string, options?: RequestInit): Promise<deleteSecretResponse> => {

  const res = await fetch(getDeleteSecretUrl(secretId),
  {
    ...options,
    method: 'DELETE'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: deleteSecretResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as deleteSecretResponse
}



export type createScheduleResponse201 = {
  data: CreateScheduleEnvelope
  status: 201
}

export type createScheduleResponse400 = {
  data: ErrorResponse
  status: 400
}

export type createScheduleResponse401 = {
  data: ErrorResponse
  status: 401
}

export type createScheduleResponse409 = {
  data: ErrorResponse
  status: 409
}

export type createScheduleResponse500 = {
  data: ErrorResponse
  status: 500
}

export type createScheduleResponseSuccess = (createScheduleResponse201) & {
  headers: Headers;
};
export type createScheduleResponseError = (createScheduleResponse400 | createScheduleResponse401 | createScheduleResponse409 | createScheduleResponse500) & {
  headers: Headers;
};

export type createScheduleResponse = (createScheduleResponseSuccess | createScheduleResponseError)

export const getCreateScheduleUrl = () => {




  return `/v1/schedules`
}

/**
 * Create a schedule that performs an action, either repeatedly or once.
 *
 * `action` describes **what** happens — today only `trigger_worker`, which starts a worker run with the given scope. `rule` describes **when**: `recurring` carries one or more `patterns`, and fires whenever any of them comes round. A pattern fires every hour at `minute`, narrowed by `hours` and `weekdays` — so `hours: [9]` is daily at 09:00, `hours: [12], weekdays: [1]` is Mondays at noon, and `hours: [9, 13, 17], weekdays: [1, 2, 3, 4, 5]` is three times a day on weekdays. Give a second pattern to mix cadences: hourly on weekdays plus 09:00, 11:00 and 18:00 at weekends is two patterns on one schedule. Patterns overlap harmlessly — two that land on the same minute fire once. Every set is read in the schedule's own time zone — an IANA identifier such as `America/Chicago`, resolved across DST transitions. `once` fires a single time at a UTC instant.
 *
 * `environments` says **which worker version** each occurrence runs: `live` resolves the worker at its live version, `test` at its test version. Give both to soak a candidate version on the same cadence and scope as production — every occurrence then fires twice, producing one run per environment. Omit it to fire in `live` only.
 *
 * The response's `next_run_at` is the first occurrence strictly after the moment of creation; a rule that resolves to no such occurrence is rejected. Create with `enabled: false` to stage a recurring schedule without letting it fire. A one-off is always enabled: delete it to cancel it, and its `next_run_at` becomes null once it has fired.
 *
 * Requires the `schedules:write` permission.
 * @summary Create a schedule
 */
export const createSchedule = async (createScheduleBody?: CreateScheduleBody, options?: RequestInit): Promise<createScheduleResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getCreateScheduleUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createScheduleBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: createScheduleResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as createScheduleResponse
}



export type listSchedulesResponse200 = {
  data: ListSchedulesEnvelope
  status: 200
}

export type listSchedulesResponse400 = {
  data: ErrorResponse
  status: 400
}

export type listSchedulesResponse401 = {
  data: ErrorResponse
  status: 401
}

export type listSchedulesResponse409 = {
  data: ErrorResponse
  status: 409
}

export type listSchedulesResponse500 = {
  data: ErrorResponse
  status: 500
}

export type listSchedulesResponseSuccess = (listSchedulesResponse200) & {
  headers: Headers;
};
export type listSchedulesResponseError = (listSchedulesResponse400 | listSchedulesResponse401 | listSchedulesResponse409 | listSchedulesResponse500) & {
  headers: Headers;
};

export type listSchedulesResponse = (listSchedulesResponseSuccess | listSchedulesResponseError)

export const getListSchedulesUrl = (params?: ListSchedulesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/schedules?${stringifiedParams}` : `/v1/schedules`
}

/**
 * List the organization's schedules. Requires the `schedules:read` permission.
 * @summary List schedules
 */
export const listSchedules = async (params?: ListSchedulesParams, options?: RequestInit): Promise<listSchedulesResponse> => {

  const res = await fetch(getListSchedulesUrl(params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: listSchedulesResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as listSchedulesResponse
}



export type getScheduleResponse200 = {
  data: GetScheduleEnvelope
  status: 200
}

export type getScheduleResponse400 = {
  data: ErrorResponse
  status: 400
}

export type getScheduleResponse401 = {
  data: ErrorResponse
  status: 401
}

export type getScheduleResponse404 = {
  data: ErrorResponse
  status: 404
}

export type getScheduleResponse409 = {
  data: ErrorResponse
  status: 409
}

export type getScheduleResponse500 = {
  data: ErrorResponse
  status: 500
}

export type getScheduleResponseSuccess = (getScheduleResponse200) & {
  headers: Headers;
};
export type getScheduleResponseError = (getScheduleResponse400 | getScheduleResponse401 | getScheduleResponse404 | getScheduleResponse409 | getScheduleResponse500) & {
  headers: Headers;
};

export type getScheduleResponse = (getScheduleResponseSuccess | getScheduleResponseError)

export const getGetScheduleUrl = (scheduleId: string,) => {




  return `/v1/schedules/${scheduleId}`
}

/**
 * Retrieve a single schedule. Requires the `schedules:read` permission.
 * @summary Get a schedule
 */
export const getSchedule = async (scheduleId: string, options?: RequestInit): Promise<getScheduleResponse> => {

  const res = await fetch(getGetScheduleUrl(scheduleId),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getScheduleResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getScheduleResponse
}



export type updateScheduleResponse200 = {
  data: UpdateScheduleEnvelope
  status: 200
}

export type updateScheduleResponse400 = {
  data: ErrorResponse
  status: 400
}

export type updateScheduleResponse401 = {
  data: ErrorResponse
  status: 401
}

export type updateScheduleResponse404 = {
  data: ErrorResponse
  status: 404
}

export type updateScheduleResponse409 = {
  data: ErrorResponse
  status: 409
}

export type updateScheduleResponse500 = {
  data: ErrorResponse
  status: 500
}

export type updateScheduleResponseSuccess = (updateScheduleResponse200) & {
  headers: Headers;
};
export type updateScheduleResponseError = (updateScheduleResponse400 | updateScheduleResponse401 | updateScheduleResponse404 | updateScheduleResponse409 | updateScheduleResponse500) & {
  headers: Headers;
};

export type updateScheduleResponse = (updateScheduleResponseSuccess | updateScheduleResponseError)

export const getUpdateScheduleUrl = (scheduleId: string,) => {




  return `/v1/schedules/${scheduleId}`
}

/**
 * Update a schedule's rule, environments, name, or enabled state.
 *
 * Changing the rule moves `next_run_at` to the first occurrence after the update; a rule that resolves to no such occurrence is rejected. One-off schedules are always enabled — delete one to cancel it before it fires.
 *
 * `environments` replaces the whole list rather than adding to it. It takes effect from the next occurrence: one already due keeps the environments it was created with.
 * @summary Update a schedule
 */
export const updateSchedule = async (scheduleId: string,
    updateScheduleBody?: UpdateScheduleBody, options?: RequestInit): Promise<updateScheduleResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getUpdateScheduleUrl(scheduleId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateScheduleBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: updateScheduleResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as updateScheduleResponse
}



export type deleteScheduleResponse200 = {
  data: DeleteScheduleEnvelope
  status: 200
}

export type deleteScheduleResponse400 = {
  data: ErrorResponse
  status: 400
}

export type deleteScheduleResponse401 = {
  data: ErrorResponse
  status: 401
}

export type deleteScheduleResponse404 = {
  data: ErrorResponse
  status: 404
}

export type deleteScheduleResponse409 = {
  data: ErrorResponse
  status: 409
}

export type deleteScheduleResponse500 = {
  data: ErrorResponse
  status: 500
}

export type deleteScheduleResponseSuccess = (deleteScheduleResponse200) & {
  headers: Headers;
};
export type deleteScheduleResponseError = (deleteScheduleResponse400 | deleteScheduleResponse401 | deleteScheduleResponse404 | deleteScheduleResponse409 | deleteScheduleResponse500) & {
  headers: Headers;
};

export type deleteScheduleResponse = (deleteScheduleResponseSuccess | deleteScheduleResponseError)

export const getDeleteScheduleUrl = (scheduleId: string,) => {




  return `/v1/schedules/${scheduleId}`
}

/**
 * Delete a schedule so it stops firing.
 * @summary Delete a schedule
 */
export const deleteSchedule = async (scheduleId: string, options?: RequestInit): Promise<deleteScheduleResponse> => {

  const res = await fetch(getDeleteScheduleUrl(scheduleId),
  {
    ...options,
    method: 'DELETE'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: deleteScheduleResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as deleteScheduleResponse
}



export type listDispatchesResponse200 = {
  data: ListDispatchesEnvelope
  status: 200
}

export type listDispatchesResponse400 = {
  data: ErrorResponse
  status: 400
}

export type listDispatchesResponse401 = {
  data: ErrorResponse
  status: 401
}

export type listDispatchesResponse409 = {
  data: ErrorResponse
  status: 409
}

export type listDispatchesResponse500 = {
  data: ErrorResponse
  status: 500
}

export type listDispatchesResponseSuccess = (listDispatchesResponse200) & {
  headers: Headers;
};
export type listDispatchesResponseError = (listDispatchesResponse400 | listDispatchesResponse401 | listDispatchesResponse409 | listDispatchesResponse500) & {
  headers: Headers;
};

export type listDispatchesResponse = (listDispatchesResponseSuccess | listDispatchesResponseError)

export const getListDispatchesUrl = (params?: ListDispatchesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/dispatches?${stringifiedParams}` : `/v1/dispatches`
}

/**
 * List the organization's dispatches, newest occurrence first.
 *
 * A dispatch is one occurrence of a trigger in one environment, carried out on its own: a schedule produces one per environment it runs in every time it fires, an inbound email produces one for the environment its inbox received it in, and a resolved information request produces one that restarts the worker that asked. Listing them shows what a trigger has actually done, including occurrences that never produced anything.
 *
 * - `pending` — not carried out yet: waiting to be picked up, in flight, or waiting on a retry after an earlier pickup did not complete.
 * - `dispatched` — carried out.
 * - `abandoned` — gave up, because the occurrence passed its `expires_at` deadline before it could be carried out.
 *
 * `attempts` counts how many times the occurrence has been picked up, not how many times it failed: a dispatch carried out on the first pickup ends at `attempts: 1`, and a higher count means earlier pickups did not complete.
 *
 * `target` is what the occurrence produced — a worker run, or an extractor job for an email whose inbox extracts. It is null until the dispatch is carried out, and stays null on one that was abandoned.
 *
 * Narrow to one trigger with `trigger_type` and `trigger_id` — the schedule's ID for a schedule, the email's ID for an email, the request's ID for an information request. `trigger_id` requires `trigger_type`.
 * @summary List dispatches
 */
export const listDispatches = async (params?: ListDispatchesParams, options?: RequestInit): Promise<listDispatchesResponse> => {

  const res = await fetch(getListDispatchesUrl(params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: listDispatchesResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as listDispatchesResponse
}



export type listNotificationsResponse200 = {
  data: ListNotificationsEnvelope
  status: 200
}

export type listNotificationsResponse400 = {
  data: ErrorResponse
  status: 400
}

export type listNotificationsResponse401 = {
  data: ErrorResponse
  status: 401
}

export type listNotificationsResponse409 = {
  data: ErrorResponse
  status: 409
}

export type listNotificationsResponse500 = {
  data: ErrorResponse
  status: 500
}

export type listNotificationsResponseSuccess = (listNotificationsResponse200) & {
  headers: Headers;
};
export type listNotificationsResponseError = (listNotificationsResponse400 | listNotificationsResponse401 | listNotificationsResponse409 | listNotificationsResponse500) & {
  headers: Headers;
};

export type listNotificationsResponse = (listNotificationsResponseSuccess | listNotificationsResponseError)

export const getListNotificationsUrl = (params?: ListNotificationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/notifications?${stringifiedParams}` : `/v1/notifications`
}

/**
 * List the organization's notifications, newest first.
 *
 * A notification is a durable record that something happened and that somebody should know about it. Notifications are not yet addressed to individual people, so everyone in the organization sees the same feed.
 *
 * `title` and `body` are the display text — render them as-is rather than deriving your own wording from `type`, so every surface says the same thing. `data` carries the identifiers the notification points at, so a client can link to the thing it is about; which keys are present depends on `type`.
 *
 * `worker_issue_reported` means a worker hit a problem during a run and reported it; its `body` is the worker's own message and its `data` is the reporting `worker_id` and `run_id`. `information_request_created` means a worker paused to ask a person a question; its `data` is the `request_id` to answer through `POST /v1/information-requests/{informationRequestId}/resolve`.
 * @summary List notifications
 */
export const listNotifications = async (params?: ListNotificationsParams, options?: RequestInit): Promise<listNotificationsResponse> => {

  const res = await fetch(getListNotificationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: listNotificationsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as listNotificationsResponse
}



export type createInformationRequestResponse201 = {
  data: CreateInformationRequestEnvelope
  status: 201
}

export type createInformationRequestResponse400 = {
  data: ErrorResponse
  status: 400
}

export type createInformationRequestResponse401 = {
  data: ErrorResponse
  status: 401
}

export type createInformationRequestResponse409 = {
  data: ErrorResponse
  status: 409
}

export type createInformationRequestResponse500 = {
  data: ErrorResponse
  status: 500
}

export type createInformationRequestResponseSuccess = (createInformationRequestResponse201) & {
  headers: Headers;
};
export type createInformationRequestResponseError = (createInformationRequestResponse400 | createInformationRequestResponse401 | createInformationRequestResponse409 | createInformationRequestResponse500) & {
  headers: Headers;
};

export type createInformationRequestResponse = (createInformationRequestResponseSuccess | createInformationRequestResponseError)

export const getCreateInformationRequestUrl = () => {




  return `/v1/information-requests`
}

/**
 * Ask a person for a specific fact you cannot establish yourself.
 *
 * Use this when one missing piece of information is blocking you and only a human can supply it — which claim a document belongs to, which of two policies applies, what an ambiguous reference means. Ask one answerable question per request, and write it so it stands on its own: whoever resolves it sees your title and your question and nothing else.
 *
 * Immediately link the request to its case with `addCaseLinks` and `entity_type: "information_request"`. That is how it reaches the person working that case; unlinked, it sits in a queue nobody is looking at. Leave it unlinked only when you genuinely cannot tell which case it belongs to.
 *
 * **This does not block or suspend you.** Nobody resolves it while this run is happening. Carry on with what you can still do, or stop, and say in your final report that you asked.
 *
 * Do not use it for progress updates, or for anything you can work out yourself.
 * @summary Ask for information
 */
export const createInformationRequest = async (createInformationRequestBody?: CreateInformationRequestBody, options?: RequestInit): Promise<createInformationRequestResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getCreateInformationRequestUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createInformationRequestBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: createInformationRequestResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as createInformationRequestResponse
}



export type listInformationRequestsResponse200 = {
  data: ListInformationRequestsEnvelope
  status: 200
}

export type listInformationRequestsResponse400 = {
  data: ErrorResponse
  status: 400
}

export type listInformationRequestsResponse401 = {
  data: ErrorResponse
  status: 401
}

export type listInformationRequestsResponse409 = {
  data: ErrorResponse
  status: 409
}

export type listInformationRequestsResponse500 = {
  data: ErrorResponse
  status: 500
}

export type listInformationRequestsResponseSuccess = (listInformationRequestsResponse200) & {
  headers: Headers;
};
export type listInformationRequestsResponseError = (listInformationRequestsResponse400 | listInformationRequestsResponse401 | listInformationRequestsResponse409 | listInformationRequestsResponse500) & {
  headers: Headers;
};

export type listInformationRequestsResponse = (listInformationRequestsResponseSuccess | listInformationRequestsResponseError)

export const getListInformationRequestsUrl = (params?: ListInformationRequestsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/information-requests?${stringifiedParams}` : `/v1/information-requests`
}

/**
 * List the organization's information requests, newest first.
 *
 * An information request is a specific question a worker could not settle on its own and needs a person to resolve. It stays open until somebody resolves it; there is no separate status field.
 * @summary List information requests
 */
export const listInformationRequests = async (params?: ListInformationRequestsParams, options?: RequestInit): Promise<listInformationRequestsResponse> => {

  const res = await fetch(getListInformationRequestsUrl(params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: listInformationRequestsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as listInformationRequestsResponse
}



export type getInformationRequestResponse200 = {
  data: GetInformationRequestEnvelope
  status: 200
}

export type getInformationRequestResponse400 = {
  data: ErrorResponse
  status: 400
}

export type getInformationRequestResponse401 = {
  data: ErrorResponse
  status: 401
}

export type getInformationRequestResponse404 = {
  data: ErrorResponse
  status: 404
}

export type getInformationRequestResponse409 = {
  data: ErrorResponse
  status: 409
}

export type getInformationRequestResponse500 = {
  data: ErrorResponse
  status: 500
}

export type getInformationRequestResponseSuccess = (getInformationRequestResponse200) & {
  headers: Headers;
};
export type getInformationRequestResponseError = (getInformationRequestResponse400 | getInformationRequestResponse401 | getInformationRequestResponse404 | getInformationRequestResponse409 | getInformationRequestResponse500) & {
  headers: Headers;
};

export type getInformationRequestResponse = (getInformationRequestResponseSuccess | getInformationRequestResponseError)

export const getGetInformationRequestUrl = (informationRequestId: string,) => {




  return `/v1/information-requests/${informationRequestId}`
}

/**
 * Retrieve a single information request by its ID.
 * @summary Get information request
 */
export const getInformationRequest = async (informationRequestId: string, options?: RequestInit): Promise<getInformationRequestResponse> => {

  const res = await fetch(getGetInformationRequestUrl(informationRequestId),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getInformationRequestResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getInformationRequestResponse
}



export type resolveInformationRequestResponse200 = {
  data: ResolveInformationRequestEnvelope
  status: 200
}

export type resolveInformationRequestResponse400 = {
  data: ErrorResponse
  status: 400
}

export type resolveInformationRequestResponse401 = {
  data: ErrorResponse
  status: 401
}

export type resolveInformationRequestResponse404 = {
  data: ErrorResponse
  status: 404
}

export type resolveInformationRequestResponse409 = {
  data: ErrorResponse
  status: 409
}

export type resolveInformationRequestResponse500 = {
  data: ErrorResponse
  status: 500
}

export type resolveInformationRequestResponseSuccess = (resolveInformationRequestResponse200) & {
  headers: Headers;
};
export type resolveInformationRequestResponseError = (resolveInformationRequestResponse400 | resolveInformationRequestResponse401 | resolveInformationRequestResponse404 | resolveInformationRequestResponse409 | resolveInformationRequestResponse500) & {
  headers: Headers;
};

export type resolveInformationRequestResponse = (resolveInformationRequestResponseSuccess | resolveInformationRequestResponseError)

export const getResolveInformationRequestUrl = (informationRequestId: string,) => {




  return `/v1/information-requests/${informationRequestId}/resolve`
}

/**
 * Resolve an open information request by providing an answer/resolution.
 * @summary Resolve information request
 */
export const resolveInformationRequest = async (informationRequestId: string,
    resolveInformationRequestBody?: ResolveInformationRequestBody, options?: RequestInit): Promise<resolveInformationRequestResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getResolveInformationRequestUrl(informationRequestId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(resolveInformationRequestBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: resolveInformationRequestResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as resolveInformationRequestResponse
}



export type createToolResponse200 = {
  data: CreateToolEnvelope
  status: 200
}

export type createToolResponse400 = {
  data: ErrorResponse
  status: 400
}

export type createToolResponse401 = {
  data: ErrorResponse
  status: 401
}

export type createToolResponse409 = {
  data: ErrorResponse
  status: 409
}

export type createToolResponse500 = {
  data: ErrorResponse
  status: 500
}

export type createToolResponseSuccess = (createToolResponse200) & {
  headers: Headers;
};
export type createToolResponseError = (createToolResponse400 | createToolResponse401 | createToolResponse409 | createToolResponse500) & {
  headers: Headers;
};

export type createToolResponse = (createToolResponseSuccess | createToolResponseError)

export const getCreateToolUrl = () => {




  return `/v1/tools`
}

/**
 * Create a new code tool that can be attached to agents. Provide the tool's name, code, and description.
 * @summary Create tool
 */
export const createTool = async (createToolBody?: CreateToolBody, options?: RequestInit): Promise<createToolResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getCreateToolUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createToolBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: createToolResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as createToolResponse
}



export type listToolsResponse200 = {
  data: ListToolsEnvelope
  status: 200
}

export type listToolsResponse400 = {
  data: ErrorResponse
  status: 400
}

export type listToolsResponse401 = {
  data: ErrorResponse
  status: 401
}

export type listToolsResponse409 = {
  data: ErrorResponse
  status: 409
}

export type listToolsResponse500 = {
  data: ErrorResponse
  status: 500
}

export type listToolsResponseSuccess = (listToolsResponse200) & {
  headers: Headers;
};
export type listToolsResponseError = (listToolsResponse400 | listToolsResponse401 | listToolsResponse409 | listToolsResponse500) & {
  headers: Headers;
};

export type listToolsResponse = (listToolsResponseSuccess | listToolsResponseError)

export const getListToolsUrl = (params?: ListToolsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/tools?${stringifiedParams}` : `/v1/tools`
}

/**
 * List all code tools with sorting.
 *
 * For compatibility this endpoint is also available using the following (deprecated) paths:
 * `GET /worker/v1/tools`
 * @summary List tools
 */
export const listTools = async (params?: ListToolsParams, options?: RequestInit): Promise<listToolsResponse> => {

  const res = await fetch(getListToolsUrl(params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: listToolsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as listToolsResponse
}



export type deleteToolResponse200 = {
  data: DeleteToolEnvelope
  status: 200
}

export type deleteToolResponse400 = {
  data: ErrorResponse
  status: 400
}

export type deleteToolResponse401 = {
  data: ErrorResponse
  status: 401
}

export type deleteToolResponse404 = {
  data: ErrorResponse
  status: 404
}

export type deleteToolResponse409 = {
  data: ErrorResponse
  status: 409
}

export type deleteToolResponse500 = {
  data: ErrorResponse
  status: 500
}

export type deleteToolResponseSuccess = (deleteToolResponse200) & {
  headers: Headers;
};
export type deleteToolResponseError = (deleteToolResponse400 | deleteToolResponse401 | deleteToolResponse404 | deleteToolResponse409 | deleteToolResponse500) & {
  headers: Headers;
};

export type deleteToolResponse = (deleteToolResponseSuccess | deleteToolResponseError)

export const getDeleteToolUrl = (id: string,) => {




  return `/v1/tools/${id}`
}

/**
 * Delete a tool. Fails with a conflict when the tool is still attached to a voice agent, worker, or chat agent; detach it first.
 * @summary Delete tool
 */
export const deleteTool = async (id: string, options?: RequestInit): Promise<deleteToolResponse> => {

  const res = await fetch(getDeleteToolUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: deleteToolResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as deleteToolResponse
}



export type getToolResponse200 = {
  data: GetToolEnvelope
  status: 200
}

export type getToolResponse400 = {
  data: ErrorResponse
  status: 400
}

export type getToolResponse401 = {
  data: ErrorResponse
  status: 401
}

export type getToolResponse404 = {
  data: ErrorResponse
  status: 404
}

export type getToolResponse409 = {
  data: ErrorResponse
  status: 409
}

export type getToolResponse500 = {
  data: ErrorResponse
  status: 500
}

export type getToolResponseSuccess = (getToolResponse200) & {
  headers: Headers;
};
export type getToolResponseError = (getToolResponse400 | getToolResponse401 | getToolResponse404 | getToolResponse409 | getToolResponse500) & {
  headers: Headers;
};

export type getToolResponse = (getToolResponseSuccess | getToolResponseError)

export const getGetToolUrl = (id: string,) => {




  return `/v1/tools/${id}`
}

/**
 * Retrieve a single tool by ID at its newest config version, including its code, schema, description and attached secrets, plus the versions each environment runs.
 *
 * For compatibility this endpoint is also available using the following (deprecated) paths:
 * `GET /worker/v1/tools/{id}`
 * @summary Get tool
 */
export const getTool = async (id: string, options?: RequestInit): Promise<getToolResponse> => {

  const res = await fetch(getGetToolUrl(id),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getToolResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getToolResponse
}



export type updateToolResponse200 = {
  data: UpdateToolEnvelope
  status: 200
}

export type updateToolResponse400 = {
  data: ErrorResponse
  status: 400
}

export type updateToolResponse401 = {
  data: ErrorResponse
  status: 401
}

export type updateToolResponse404 = {
  data: ErrorResponse
  status: 404
}

export type updateToolResponse409 = {
  data: ErrorResponse
  status: 409
}

export type updateToolResponse500 = {
  data: ErrorResponse
  status: 500
}

export type updateToolResponseSuccess = (updateToolResponse200) & {
  headers: Headers;
};
export type updateToolResponseError = (updateToolResponse400 | updateToolResponse401 | updateToolResponse404 | updateToolResponse409 | updateToolResponse500) & {
  headers: Headers;
};

export type updateToolResponse = (updateToolResponseSuccess | updateToolResponseError)

export const getUpdateToolUrl = (id: string,) => {




  return `/v1/tools/${id}`
}

/**
 * Update a code tool's name, description, code, or attached secrets. All fields are optional — only provided fields are updated.
 *
 * Changing the code, description or attached secrets creates a new config version; runs keep executing the versions promoted to live and test until that version is promoted. Renaming does not create a version.
 * @summary Update tool
 */
export const updateTool = async (id: string,
    updateToolBody?: UpdateToolBody, options?: RequestInit): Promise<updateToolResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getUpdateToolUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateToolBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: updateToolResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as updateToolResponse
}



export type executeCodeResponse200 = {
  data: ExecuteCodeEnvelope
  status: 200
}

export type executeCodeResponse400 = {
  data: ErrorResponse
  status: 400
}

export type executeCodeResponse401 = {
  data: ErrorResponse
  status: 401
}

export type executeCodeResponse404 = {
  data: ErrorResponse
  status: 404
}

export type executeCodeResponse409 = {
  data: ErrorResponse
  status: 409
}

export type executeCodeResponse500 = {
  data: ErrorResponse
  status: 500
}

export type executeCodeResponseSuccess = (executeCodeResponse200) & {
  headers: Headers;
};
export type executeCodeResponseError = (executeCodeResponse400 | executeCodeResponse401 | executeCodeResponse404 | executeCodeResponse409 | executeCodeResponse500) & {
  headers: Headers;
};

export type executeCodeResponse = (executeCodeResponseSuccess | executeCodeResponseError)

export const getExecuteCodeUrl = (id: string,) => {




  return `/v1/tools/${id}/execute`
}

/**
 * Execute a code tool with the given parameters. Returns the result, any errors, and execution traces.
 *
 * For compatibility this endpoint is also available using the following (deprecated) paths:
 * `POST /worker/v1/tools/{id}/execute`
 * @summary Execute tool
 */
export const executeCode = async (id: string,
    executeCodeBody?: ExecuteCodeBody, options?: RequestInit): Promise<executeCodeResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getExecuteCodeUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(executeCodeBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: executeCodeResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as executeCodeResponse
}



export type listToolVersionsResponse200 = {
  data: ListToolVersionsEnvelope
  status: 200
}

export type listToolVersionsResponse400 = {
  data: ErrorResponse
  status: 400
}

export type listToolVersionsResponse401 = {
  data: ErrorResponse
  status: 401
}

export type listToolVersionsResponse404 = {
  data: ErrorResponse
  status: 404
}

export type listToolVersionsResponse409 = {
  data: ErrorResponse
  status: 409
}

export type listToolVersionsResponse500 = {
  data: ErrorResponse
  status: 500
}

export type listToolVersionsResponseSuccess = (listToolVersionsResponse200) & {
  headers: Headers;
};
export type listToolVersionsResponseError = (listToolVersionsResponse400 | listToolVersionsResponse401 | listToolVersionsResponse404 | listToolVersionsResponse409 | listToolVersionsResponse500) & {
  headers: Headers;
};

export type listToolVersionsResponse = (listToolVersionsResponseSuccess | listToolVersionsResponseError)

export const getListToolVersionsUrl = (id: string,
    params?: ListToolVersionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/tools/${id}/versions?${stringifiedParams}` : `/v1/tools/${id}/versions`
}

/**
 * List all config versions for a tool, ordered by version (newest first by default).
 * @summary List tool versions
 */
export const listToolVersions = async (id: string,
    params?: ListToolVersionsParams, options?: RequestInit): Promise<listToolVersionsResponse> => {

  const res = await fetch(getListToolVersionsUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: listToolVersionsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as listToolVersionsResponse
}



export type getToolVersionResponse200 = {
  data: GetToolVersionEnvelope
  status: 200
}

export type getToolVersionResponse400 = {
  data: ErrorResponse
  status: 400
}

export type getToolVersionResponse401 = {
  data: ErrorResponse
  status: 401
}

export type getToolVersionResponse404 = {
  data: ErrorResponse
  status: 404
}

export type getToolVersionResponse409 = {
  data: ErrorResponse
  status: 409
}

export type getToolVersionResponse500 = {
  data: ErrorResponse
  status: 500
}

export type getToolVersionResponseSuccess = (getToolVersionResponse200) & {
  headers: Headers;
};
export type getToolVersionResponseError = (getToolVersionResponse400 | getToolVersionResponse401 | getToolVersionResponse404 | getToolVersionResponse409 | getToolVersionResponse500) & {
  headers: Headers;
};

export type getToolVersionResponse = (getToolVersionResponseSuccess | getToolVersionResponseError)

export const getGetToolVersionUrl = (id: string,
    version: number,) => {




  return `/v1/tools/${id}/versions/${version}`
}

/**
 * Retrieve a single tool config version: the tool's identity, the code, schema, description and attached secrets at that version, and version metadata.
 * @summary Get tool version
 */
export const getToolVersion = async (id: string,
    version: number, options?: RequestInit): Promise<getToolVersionResponse> => {

  const res = await fetch(getGetToolVersionUrl(id,version),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getToolVersionResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getToolVersionResponse
}



export type promoteToolVersionResponse200 = {
  data: PromoteToolVersionEnvelope
  status: 200
}

export type promoteToolVersionResponse400 = {
  data: ErrorResponse
  status: 400
}

export type promoteToolVersionResponse401 = {
  data: ErrorResponse
  status: 401
}

export type promoteToolVersionResponse404 = {
  data: ErrorResponse
  status: 404
}

export type promoteToolVersionResponse409 = {
  data: ErrorResponse
  status: 409
}

export type promoteToolVersionResponse500 = {
  data: ErrorResponse
  status: 500
}

export type promoteToolVersionResponseSuccess = (promoteToolVersionResponse200) & {
  headers: Headers;
};
export type promoteToolVersionResponseError = (promoteToolVersionResponse400 | promoteToolVersionResponse401 | promoteToolVersionResponse404 | promoteToolVersionResponse409 | promoteToolVersionResponse500) & {
  headers: Headers;
};

export type promoteToolVersionResponse = (promoteToolVersionResponseSuccess | promoteToolVersionResponseError)

export const getPromoteToolVersionUrl = (id: string,
    version: number,) => {




  return `/v1/tools/${id}/versions/${version}/promote`
}

/**
 * Select a tool config version for the live or test environment. Runs in that environment execute this version's code with this version's schema and attached secrets from then on.
 * @summary Promote tool version
 */
export const promoteToolVersion = async (id: string,
    version: number,
    promoteToolVersionBody?: PromoteToolVersionBody, options?: RequestInit): Promise<promoteToolVersionResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getPromoteToolVersionUrl(id,version),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(promoteToolVersionBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: promoteToolVersionResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as promoteToolVersionResponse
}



export type getToolVersionChangeSummaryResponse200 = {
  data: GetToolVersionChangeSummaryEnvelope
  status: 200
}

export type getToolVersionChangeSummaryResponse400 = {
  data: ErrorResponse
  status: 400
}

export type getToolVersionChangeSummaryResponse401 = {
  data: ErrorResponse
  status: 401
}

export type getToolVersionChangeSummaryResponse404 = {
  data: ErrorResponse
  status: 404
}

export type getToolVersionChangeSummaryResponse409 = {
  data: ErrorResponse
  status: 409
}

export type getToolVersionChangeSummaryResponse500 = {
  data: ErrorResponse
  status: 500
}

export type getToolVersionChangeSummaryResponseSuccess = (getToolVersionChangeSummaryResponse200) & {
  headers: Headers;
};
export type getToolVersionChangeSummaryResponseError = (getToolVersionChangeSummaryResponse400 | getToolVersionChangeSummaryResponse401 | getToolVersionChangeSummaryResponse404 | getToolVersionChangeSummaryResponse409 | getToolVersionChangeSummaryResponse500) & {
  headers: Headers;
};

export type getToolVersionChangeSummaryResponse = (getToolVersionChangeSummaryResponseSuccess | getToolVersionChangeSummaryResponseError)

export const getGetToolVersionChangeSummaryUrl = (id: string,
    version: number,) => {




  return `/v1/tools/${id}/versions/${version}/change-summary`
}

/**
 * Returns an AI-generated summary of what changed between this version and the previous one. Initial version returns an empty string since there is no predecessor.
 * @summary Get tool version change summary
 */
export const getToolVersionChangeSummary = async (id: string,
    version: number, options?: RequestInit): Promise<getToolVersionChangeSummaryResponse> => {

  const res = await fetch(getGetToolVersionChangeSummaryUrl(id,version),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getToolVersionChangeSummaryResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getToolVersionChangeSummaryResponse
}



export type workerListToolsResponse200 = {
  data: WorkerListToolsEnvelope
  status: 200
}

export type workerListToolsResponse400 = {
  data: ErrorResponse
  status: 400
}

export type workerListToolsResponse401 = {
  data: ErrorResponse
  status: 401
}

export type workerListToolsResponse409 = {
  data: ErrorResponse
  status: 409
}

export type workerListToolsResponse500 = {
  data: ErrorResponse
  status: 500
}

export type workerListToolsResponseSuccess = (workerListToolsResponse200) & {
  headers: Headers;
};
export type workerListToolsResponseError = (workerListToolsResponse400 | workerListToolsResponse401 | workerListToolsResponse409 | workerListToolsResponse500) & {
  headers: Headers;
};

export type workerListToolsResponse = (workerListToolsResponseSuccess | workerListToolsResponseError)

export const getWorkerListToolsUrl = (params?: WorkerListToolsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/worker/v1/tools?${stringifiedParams}` : `/worker/v1/tools`
}

/**
 * List all code tools with sorting.
 * @deprecated
 * @summary List tools
 */
export const workerListTools = async (params?: WorkerListToolsParams, options?: RequestInit): Promise<workerListToolsResponse> => {

  const res = await fetch(getWorkerListToolsUrl(params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: workerListToolsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as workerListToolsResponse
}



export type workerGetToolResponse200 = {
  data: WorkerGetToolEnvelope
  status: 200
}

export type workerGetToolResponse400 = {
  data: ErrorResponse
  status: 400
}

export type workerGetToolResponse401 = {
  data: ErrorResponse
  status: 401
}

export type workerGetToolResponse404 = {
  data: ErrorResponse
  status: 404
}

export type workerGetToolResponse409 = {
  data: ErrorResponse
  status: 409
}

export type workerGetToolResponse500 = {
  data: ErrorResponse
  status: 500
}

export type workerGetToolResponseSuccess = (workerGetToolResponse200) & {
  headers: Headers;
};
export type workerGetToolResponseError = (workerGetToolResponse400 | workerGetToolResponse401 | workerGetToolResponse404 | workerGetToolResponse409 | workerGetToolResponse500) & {
  headers: Headers;
};

export type workerGetToolResponse = (workerGetToolResponseSuccess | workerGetToolResponseError)

export const getWorkerGetToolUrl = (id: string,) => {




  return `/worker/v1/tools/${id}`
}

/**
 * Retrieve a single tool by ID at its newest config version, including its code, schema, description and attached secrets, plus the versions each environment runs.
 * @deprecated
 * @summary Get tool
 */
export const workerGetTool = async (id: string, options?: RequestInit): Promise<workerGetToolResponse> => {

  const res = await fetch(getWorkerGetToolUrl(id),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: workerGetToolResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as workerGetToolResponse
}



export type workerExecuteToolResponse200 = {
  data: WorkerExecuteToolEnvelope
  status: 200
}

export type workerExecuteToolResponse400 = {
  data: ErrorResponse
  status: 400
}

export type workerExecuteToolResponse401 = {
  data: ErrorResponse
  status: 401
}

export type workerExecuteToolResponse404 = {
  data: ErrorResponse
  status: 404
}

export type workerExecuteToolResponse409 = {
  data: ErrorResponse
  status: 409
}

export type workerExecuteToolResponse500 = {
  data: ErrorResponse
  status: 500
}

export type workerExecuteToolResponseSuccess = (workerExecuteToolResponse200) & {
  headers: Headers;
};
export type workerExecuteToolResponseError = (workerExecuteToolResponse400 | workerExecuteToolResponse401 | workerExecuteToolResponse404 | workerExecuteToolResponse409 | workerExecuteToolResponse500) & {
  headers: Headers;
};

export type workerExecuteToolResponse = (workerExecuteToolResponseSuccess | workerExecuteToolResponseError)

export const getWorkerExecuteToolUrl = (id: string,) => {




  return `/worker/v1/tools/${id}/execute`
}

/**
 * Execute a code tool with the given parameters. Returns the result, any errors, and execution traces.
 * @deprecated
 * @summary Execute tool
 */
export const workerExecuteTool = async (id: string,
    workerExecuteToolBody?: WorkerExecuteToolBody, options?: RequestInit): Promise<workerExecuteToolResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getWorkerExecuteToolUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(workerExecuteToolBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: workerExecuteToolResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as workerExecuteToolResponse
}



export type notifyAdminResponse201 = {
  data: NotifyAdminEnvelope
  status: 201
}

export type notifyAdminResponse400 = {
  data: ErrorResponse
  status: 400
}

export type notifyAdminResponse401 = {
  data: ErrorResponse
  status: 401
}

export type notifyAdminResponse409 = {
  data: ErrorResponse
  status: 409
}

export type notifyAdminResponse500 = {
  data: ErrorResponse
  status: 500
}

export type notifyAdminResponseSuccess = (notifyAdminResponse201) & {
  headers: Headers;
};
export type notifyAdminResponseError = (notifyAdminResponse400 | notifyAdminResponse401 | notifyAdminResponse409 | notifyAdminResponse500) & {
  headers: Headers;
};

export type notifyAdminResponse = (notifyAdminResponseSuccess | notifyAdminResponseError)

export const getNotifyAdminUrl = () => {




  return `/worker/v1/notifications`
}

/**
 * Report a problem to the people who run this organization.
 *
 * Use this for something a human has to resolve — a login that no longer works, a document you cannot read, a system that will not let you in, instructions that contradict what you found. The report goes to the organization's notifications; nobody sees it while the run is happening, so it does not unblock you now. Carry on with what you can still do, or stop, and say in your final report that you raised it.
 *
 * Do not use it for progress updates or for anything you can work around yourself.
 * @summary Notify an admin
 */
export const notifyAdmin = async (notifyAdminBody?: NotifyAdminBody, options?: RequestInit): Promise<notifyAdminResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getNotifyAdminUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(notifyAdminBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: notifyAdminResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as notifyAdminResponse
}



export type uploadFileResponse202 = {
  data: UploadFileEnvelope
  status: 202
}

export type uploadFileResponse400 = {
  data: ErrorResponse
  status: 400
}

export type uploadFileResponse401 = {
  data: ErrorResponse
  status: 401
}

export type uploadFileResponse409 = {
  data: ErrorResponse
  status: 409
}

export type uploadFileResponse500 = {
  data: ErrorResponse
  status: 500
}

export type uploadFileResponseSuccess = (uploadFileResponse202) & {
  headers: Headers;
};
export type uploadFileResponseError = (uploadFileResponse400 | uploadFileResponse401 | uploadFileResponse409 | uploadFileResponse500) & {
  headers: Headers;
};

export type uploadFileResponse = (uploadFileResponseSuccess | uploadFileResponseError)

export const getUploadFileUrl = () => {




  return `/v1/upload-file`
}

/**
 * Upload a file for processing by passing a URL to a file. Use this for uploading larger files.
 *
 * This endpoint returns an upload id that can be used to find the created artifacts using the list artifacts endpoint.
 * @summary Upload a file for processing
 */
export const uploadFile = async (uploadFileBody?: UploadFileBody, options?: RequestInit): Promise<uploadFileResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getUploadFileUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(uploadFileBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: uploadFileResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as uploadFileResponse
}



export type createAgentWebhookResponse200 = {
  data: CreateAgentWebhookEnvelope
  status: 200
}

export type createAgentWebhookResponse400 = {
  data: ErrorResponse
  status: 400
}

export type createAgentWebhookResponse401 = {
  data: ErrorResponse
  status: 401
}

export type createAgentWebhookResponse404 = {
  data: ErrorResponse
  status: 404
}

export type createAgentWebhookResponse409 = {
  data: ErrorResponse
  status: 409
}

export type createAgentWebhookResponse500 = {
  data: ErrorResponse
  status: 500
}

export type createAgentWebhookResponseSuccess = (createAgentWebhookResponse200) & {
  headers: Headers;
};
export type createAgentWebhookResponseError = (createAgentWebhookResponse400 | createAgentWebhookResponse401 | createAgentWebhookResponse404 | createAgentWebhookResponse409 | createAgentWebhookResponse500) & {
  headers: Headers;
};

export type createAgentWebhookResponse = (createAgentWebhookResponseSuccess | createAgentWebhookResponseError)

export const getCreateAgentWebhookUrl = (voiceAgentId: string,) => {




  return `/v1/voice-agents/${voiceAgentId}/webhooks`
}

/**
 * Create a webhook that fires when events occur for the specified voice agent.
 *
 * For compatibility this endpoint is also available using the following (deprecated) paths:
 * `POST /v1/agents/{id}/webhooks`
 * @summary Create voice agent webhook
 */
export const createAgentWebhook = async (voiceAgentId: string,
    createAgentWebhookBody?: CreateAgentWebhookBody, options?: RequestInit): Promise<createAgentWebhookResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getCreateAgentWebhookUrl(voiceAgentId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createAgentWebhookBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: createAgentWebhookResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as createAgentWebhookResponse
}



export type listAgentWebhooksResponse200 = {
  data: ListAgentWebhooksEnvelope
  status: 200
}

export type listAgentWebhooksResponse400 = {
  data: ErrorResponse
  status: 400
}

export type listAgentWebhooksResponse401 = {
  data: ErrorResponse
  status: 401
}

export type listAgentWebhooksResponse404 = {
  data: ErrorResponse
  status: 404
}

export type listAgentWebhooksResponse409 = {
  data: ErrorResponse
  status: 409
}

export type listAgentWebhooksResponse500 = {
  data: ErrorResponse
  status: 500
}

export type listAgentWebhooksResponseSuccess = (listAgentWebhooksResponse200) & {
  headers: Headers;
};
export type listAgentWebhooksResponseError = (listAgentWebhooksResponse400 | listAgentWebhooksResponse401 | listAgentWebhooksResponse404 | listAgentWebhooksResponse409 | listAgentWebhooksResponse500) & {
  headers: Headers;
};

export type listAgentWebhooksResponse = (listAgentWebhooksResponseSuccess | listAgentWebhooksResponseError)

export const getListAgentWebhooksUrl = (voiceAgentId: string,
    params?: ListAgentWebhooksParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/voice-agents/${voiceAgentId}/webhooks?${stringifiedParams}` : `/v1/voice-agents/${voiceAgentId}/webhooks`
}

/**
 * List all webhooks configured for a specific voice agent.
 *
 * For compatibility this endpoint is also available using the following (deprecated) paths:
 * `GET /v1/agents/{id}/webhooks`
 * @summary List voice agent webhooks
 */
export const listAgentWebhooks = async (voiceAgentId: string,
    params?: ListAgentWebhooksParams, options?: RequestInit): Promise<listAgentWebhooksResponse> => {

  const res = await fetch(getListAgentWebhooksUrl(voiceAgentId,params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: listAgentWebhooksResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as listAgentWebhooksResponse
}



export type createInboxWebhookResponse200 = {
  data: CreateInboxWebhookEnvelope
  status: 200
}

export type createInboxWebhookResponse400 = {
  data: ErrorResponse
  status: 400
}

export type createInboxWebhookResponse401 = {
  data: ErrorResponse
  status: 401
}

export type createInboxWebhookResponse404 = {
  data: ErrorResponse
  status: 404
}

export type createInboxWebhookResponse409 = {
  data: ErrorResponse
  status: 409
}

export type createInboxWebhookResponse500 = {
  data: ErrorResponse
  status: 500
}

export type createInboxWebhookResponseSuccess = (createInboxWebhookResponse200) & {
  headers: Headers;
};
export type createInboxWebhookResponseError = (createInboxWebhookResponse400 | createInboxWebhookResponse401 | createInboxWebhookResponse404 | createInboxWebhookResponse409 | createInboxWebhookResponse500) & {
  headers: Headers;
};

export type createInboxWebhookResponse = (createInboxWebhookResponseSuccess | createInboxWebhookResponseError)

export const getCreateInboxWebhookUrl = (inboxId: string,) => {




  return `/v1/inboxes/${inboxId}/webhooks`
}

/**
 * Create a webhook that fires when events occur for the specified inbox.
 *
 * For compatibility this endpoint is also available using the following (deprecated) paths:
 * `POST /v1/email-agents/{id}/webhooks`
 * @summary Create inbox webhook
 */
export const createInboxWebhook = async (inboxId: string,
    createInboxWebhookBody?: CreateInboxWebhookBody, options?: RequestInit): Promise<createInboxWebhookResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getCreateInboxWebhookUrl(inboxId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createInboxWebhookBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: createInboxWebhookResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as createInboxWebhookResponse
}



export type listInboxWebhooksResponse200 = {
  data: ListInboxWebhooksEnvelope
  status: 200
}

export type listInboxWebhooksResponse400 = {
  data: ErrorResponse
  status: 400
}

export type listInboxWebhooksResponse401 = {
  data: ErrorResponse
  status: 401
}

export type listInboxWebhooksResponse404 = {
  data: ErrorResponse
  status: 404
}

export type listInboxWebhooksResponse409 = {
  data: ErrorResponse
  status: 409
}

export type listInboxWebhooksResponse500 = {
  data: ErrorResponse
  status: 500
}

export type listInboxWebhooksResponseSuccess = (listInboxWebhooksResponse200) & {
  headers: Headers;
};
export type listInboxWebhooksResponseError = (listInboxWebhooksResponse400 | listInboxWebhooksResponse401 | listInboxWebhooksResponse404 | listInboxWebhooksResponse409 | listInboxWebhooksResponse500) & {
  headers: Headers;
};

export type listInboxWebhooksResponse = (listInboxWebhooksResponseSuccess | listInboxWebhooksResponseError)

export const getListInboxWebhooksUrl = (inboxId: string,
    params?: ListInboxWebhooksParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/inboxes/${inboxId}/webhooks?${stringifiedParams}` : `/v1/inboxes/${inboxId}/webhooks`
}

/**
 * List all webhooks configured for a specific inbox.
 *
 * For compatibility this endpoint is also available using the following (deprecated) paths:
 * `GET /v1/email-agents/{id}/webhooks`
 * @summary List inbox webhooks
 */
export const listInboxWebhooks = async (inboxId: string,
    params?: ListInboxWebhooksParams, options?: RequestInit): Promise<listInboxWebhooksResponse> => {

  const res = await fetch(getListInboxWebhooksUrl(inboxId,params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: listInboxWebhooksResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as listInboxWebhooksResponse
}



export type createExtractorWebhookResponse200 = {
  data: CreateExtractorWebhookEnvelope
  status: 200
}

export type createExtractorWebhookResponse400 = {
  data: ErrorResponse
  status: 400
}

export type createExtractorWebhookResponse401 = {
  data: ErrorResponse
  status: 401
}

export type createExtractorWebhookResponse404 = {
  data: ErrorResponse
  status: 404
}

export type createExtractorWebhookResponse409 = {
  data: ErrorResponse
  status: 409
}

export type createExtractorWebhookResponse500 = {
  data: ErrorResponse
  status: 500
}

export type createExtractorWebhookResponseSuccess = (createExtractorWebhookResponse200) & {
  headers: Headers;
};
export type createExtractorWebhookResponseError = (createExtractorWebhookResponse400 | createExtractorWebhookResponse401 | createExtractorWebhookResponse404 | createExtractorWebhookResponse409 | createExtractorWebhookResponse500) & {
  headers: Headers;
};

export type createExtractorWebhookResponse = (createExtractorWebhookResponseSuccess | createExtractorWebhookResponseError)

export const getCreateExtractorWebhookUrl = (id: string,) => {




  return `/v1/extractors/${id}/webhooks`
}

/**
 * Create a webhook that fires when extraction events occur for the specified extractor.
 * @summary Create extractor webhook
 */
export const createExtractorWebhook = async (id: string,
    createExtractorWebhookBody?: CreateExtractorWebhookBody, options?: RequestInit): Promise<createExtractorWebhookResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getCreateExtractorWebhookUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createExtractorWebhookBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: createExtractorWebhookResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as createExtractorWebhookResponse
}



export type listWebhooksResponse200 = {
  data: ListWebhooksEnvelope
  status: 200
}

export type listWebhooksResponse400 = {
  data: ErrorResponse
  status: 400
}

export type listWebhooksResponse401 = {
  data: ErrorResponse
  status: 401
}

export type listWebhooksResponse404 = {
  data: ErrorResponse
  status: 404
}

export type listWebhooksResponse409 = {
  data: ErrorResponse
  status: 409
}

export type listWebhooksResponse500 = {
  data: ErrorResponse
  status: 500
}

export type listWebhooksResponseSuccess = (listWebhooksResponse200) & {
  headers: Headers;
};
export type listWebhooksResponseError = (listWebhooksResponse400 | listWebhooksResponse401 | listWebhooksResponse404 | listWebhooksResponse409 | listWebhooksResponse500) & {
  headers: Headers;
};

export type listWebhooksResponse = (listWebhooksResponseSuccess | listWebhooksResponseError)

export const getListWebhooksUrl = (id: string,
    params?: ListWebhooksParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/extractors/${id}/webhooks?${stringifiedParams}` : `/v1/extractors/${id}/webhooks`
}

/**
 * List all webhooks configured for a specific extractor.
 * @summary List extractor webhooks
 */
export const listWebhooks = async (id: string,
    params?: ListWebhooksParams, options?: RequestInit): Promise<listWebhooksResponse> => {

  const res = await fetch(getListWebhooksUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: listWebhooksResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as listWebhooksResponse
}



export type createNotificationWebhookResponse201 = {
  data: CreateNotificationWebhookEnvelope
  status: 201
}

export type createNotificationWebhookResponse400 = {
  data: ErrorResponse
  status: 400
}

export type createNotificationWebhookResponse401 = {
  data: ErrorResponse
  status: 401
}

export type createNotificationWebhookResponse409 = {
  data: ErrorResponse
  status: 409
}

export type createNotificationWebhookResponse500 = {
  data: ErrorResponse
  status: 500
}

export type createNotificationWebhookResponseSuccess = (createNotificationWebhookResponse201) & {
  headers: Headers;
};
export type createNotificationWebhookResponseError = (createNotificationWebhookResponse400 | createNotificationWebhookResponse401 | createNotificationWebhookResponse409 | createNotificationWebhookResponse500) & {
  headers: Headers;
};

export type createNotificationWebhookResponse = (createNotificationWebhookResponseSuccess | createNotificationWebhookResponseError)

export const getCreateNotificationWebhookUrl = () => {




  return `/v1/notifications/webhooks`
}

/**
 * Create a webhook that fires whenever a notification is raised for the organization.
 *
 * Notifications belong to the organization rather than to a resource, so this webhook is not attached to anything: its `scope` is `{ "notifications": true }` and it receives every notification the organization raises. Each delivery carries the notification's `title` and `body` — the same display text `GET /v1/notifications` returns — alongside the structured `data` it points at.
 *
 * Notifications are not environment-specific, so every delivery is `live`. A webhook that names only `test` receives nothing.
 * @summary Create notification webhook
 */
export const createNotificationWebhook = async (createNotificationWebhookBody?: CreateNotificationWebhookBody, options?: RequestInit): Promise<createNotificationWebhookResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getCreateNotificationWebhookUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createNotificationWebhookBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: createNotificationWebhookResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as createNotificationWebhookResponse
}



export type listNotificationWebhooksResponse200 = {
  data: ListNotificationWebhooksEnvelope
  status: 200
}

export type listNotificationWebhooksResponse400 = {
  data: ErrorResponse
  status: 400
}

export type listNotificationWebhooksResponse401 = {
  data: ErrorResponse
  status: 401
}

export type listNotificationWebhooksResponse409 = {
  data: ErrorResponse
  status: 409
}

export type listNotificationWebhooksResponse500 = {
  data: ErrorResponse
  status: 500
}

export type listNotificationWebhooksResponseSuccess = (listNotificationWebhooksResponse200) & {
  headers: Headers;
};
export type listNotificationWebhooksResponseError = (listNotificationWebhooksResponse400 | listNotificationWebhooksResponse401 | listNotificationWebhooksResponse409 | listNotificationWebhooksResponse500) & {
  headers: Headers;
};

export type listNotificationWebhooksResponse = (listNotificationWebhooksResponseSuccess | listNotificationWebhooksResponseError)

export const getListNotificationWebhooksUrl = (params?: ListNotificationWebhooksParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/notifications/webhooks?${stringifiedParams}` : `/v1/notifications/webhooks`
}

/**
 * List the webhooks that receive the organization's notifications.
 * @summary List notification webhooks
 */
export const listNotificationWebhooks = async (params?: ListNotificationWebhooksParams, options?: RequestInit): Promise<listNotificationWebhooksResponse> => {

  const res = await fetch(getListNotificationWebhooksUrl(params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: listNotificationWebhooksResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as listNotificationWebhooksResponse
}



export type deleteWebhookResponse200 = {
  data: DeleteWebhookEnvelope
  status: 200
}

export type deleteWebhookResponse400 = {
  data: ErrorResponse
  status: 400
}

export type deleteWebhookResponse401 = {
  data: ErrorResponse
  status: 401
}

export type deleteWebhookResponse404 = {
  data: ErrorResponse
  status: 404
}

export type deleteWebhookResponse409 = {
  data: ErrorResponse
  status: 409
}

export type deleteWebhookResponse500 = {
  data: ErrorResponse
  status: 500
}

export type deleteWebhookResponseSuccess = (deleteWebhookResponse200) & {
  headers: Headers;
};
export type deleteWebhookResponseError = (deleteWebhookResponse400 | deleteWebhookResponse401 | deleteWebhookResponse404 | deleteWebhookResponse409 | deleteWebhookResponse500) & {
  headers: Headers;
};

export type deleteWebhookResponse = (deleteWebhookResponseSuccess | deleteWebhookResponseError)

export const getDeleteWebhookUrl = (id: string,) => {




  return `/v1/webhooks/${id}`
}

/**
 * Permanently delete a webhook. This action is irreversible.
 * @summary Delete webhook
 */
export const deleteWebhook = async (id: string, options?: RequestInit): Promise<deleteWebhookResponse> => {

  const res = await fetch(getDeleteWebhookUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: deleteWebhookResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as deleteWebhookResponse
}



export type getWebhookResponse200 = {
  data: GetWebhookEnvelope
  status: 200
}

export type getWebhookResponse400 = {
  data: ErrorResponse
  status: 400
}

export type getWebhookResponse401 = {
  data: ErrorResponse
  status: 401
}

export type getWebhookResponse404 = {
  data: ErrorResponse
  status: 404
}

export type getWebhookResponse409 = {
  data: ErrorResponse
  status: 409
}

export type getWebhookResponse500 = {
  data: ErrorResponse
  status: 500
}

export type getWebhookResponseSuccess = (getWebhookResponse200) & {
  headers: Headers;
};
export type getWebhookResponseError = (getWebhookResponse400 | getWebhookResponse401 | getWebhookResponse404 | getWebhookResponse409 | getWebhookResponse500) & {
  headers: Headers;
};

export type getWebhookResponse = (getWebhookResponseSuccess | getWebhookResponseError)

export const getGetWebhookUrl = (id: string,) => {




  return `/v1/webhooks/${id}`
}

/**
 * Retrieve a single webhook by ID. The authentication header value is never exposed — only `has_auth` indicates whether authentication is configured.
 * @summary Get webhook
 */
export const getWebhook = async (id: string, options?: RequestInit): Promise<getWebhookResponse> => {

  const res = await fetch(getGetWebhookUrl(id),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getWebhookResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getWebhookResponse
}



export type updateWebhookResponse200 = {
  data: UpdateWebhookEnvelope
  status: 200
}

export type updateWebhookResponse400 = {
  data: ErrorResponse
  status: 400
}

export type updateWebhookResponse401 = {
  data: ErrorResponse
  status: 401
}

export type updateWebhookResponse404 = {
  data: ErrorResponse
  status: 404
}

export type updateWebhookResponse409 = {
  data: ErrorResponse
  status: 409
}

export type updateWebhookResponse500 = {
  data: ErrorResponse
  status: 500
}

export type updateWebhookResponseSuccess = (updateWebhookResponse200) & {
  headers: Headers;
};
export type updateWebhookResponseError = (updateWebhookResponse400 | updateWebhookResponse401 | updateWebhookResponse404 | updateWebhookResponse409 | updateWebhookResponse500) & {
  headers: Headers;
};

export type updateWebhookResponse = (updateWebhookResponseSuccess | updateWebhookResponseError)

export const getUpdateWebhookUrl = (id: string,) => {




  return `/v1/webhooks/${id}`
}

/**
 * Update a webhook's name, destination, environments, enabled state, or authentication. Omitted fields are left unchanged, and at least one must be provided.
 * @summary Update webhook
 */
export const updateWebhook = async (id: string,
    updateWebhookBody?: UpdateWebhookBody, options?: RequestInit): Promise<updateWebhookResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getUpdateWebhookUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateWebhookBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: updateWebhookResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as updateWebhookResponse
}



export type listWebhookDeliveriesResponse200 = {
  data: ListWebhookDeliveriesEnvelope
  status: 200
}

export type listWebhookDeliveriesResponse400 = {
  data: ErrorResponse
  status: 400
}

export type listWebhookDeliveriesResponse401 = {
  data: ErrorResponse
  status: 401
}

export type listWebhookDeliveriesResponse404 = {
  data: ErrorResponse
  status: 404
}

export type listWebhookDeliveriesResponse409 = {
  data: ErrorResponse
  status: 409
}

export type listWebhookDeliveriesResponse500 = {
  data: ErrorResponse
  status: 500
}

export type listWebhookDeliveriesResponseSuccess = (listWebhookDeliveriesResponse200) & {
  headers: Headers;
};
export type listWebhookDeliveriesResponseError = (listWebhookDeliveriesResponse400 | listWebhookDeliveriesResponse401 | listWebhookDeliveriesResponse404 | listWebhookDeliveriesResponse409 | listWebhookDeliveriesResponse500) & {
  headers: Headers;
};

export type listWebhookDeliveriesResponse = (listWebhookDeliveriesResponseSuccess | listWebhookDeliveriesResponseError)

export const getListWebhookDeliveriesUrl = (id: string,
    params?: ListWebhookDeliveriesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/webhooks/${id}/deliveries?${stringifiedParams}` : `/v1/webhooks/${id}/deliveries`
}

/**
 * List delivery attempts for a specific webhook, with pagination and sorting. Useful for debugging webhook issues.
 * @summary List webhook deliveries
 */
export const listWebhookDeliveries = async (id: string,
    params?: ListWebhookDeliveriesParams, options?: RequestInit): Promise<listWebhookDeliveriesResponse> => {

  const res = await fetch(getListWebhookDeliveriesUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: listWebhookDeliveriesResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as listWebhookDeliveriesResponse
}



export type testWebhookResponse200 = {
  data: TestWebhookEnvelope
  status: 200
}

export type testWebhookResponse400 = {
  data: ErrorResponse
  status: 400
}

export type testWebhookResponse401 = {
  data: ErrorResponse
  status: 401
}

export type testWebhookResponse404 = {
  data: ErrorResponse
  status: 404
}

export type testWebhookResponse409 = {
  data: ErrorResponse
  status: 409
}

export type testWebhookResponse500 = {
  data: ErrorResponse
  status: 500
}

export type testWebhookResponseSuccess = (testWebhookResponse200) & {
  headers: Headers;
};
export type testWebhookResponseError = (testWebhookResponse400 | testWebhookResponse401 | testWebhookResponse404 | testWebhookResponse409 | testWebhookResponse500) & {
  headers: Headers;
};

export type testWebhookResponse = (testWebhookResponseSuccess | testWebhookResponseError)

export const getTestWebhookUrl = (id: string,) => {




  return `/v1/webhooks/${id}/test`
}

/**
 * Send a test event to a webhook endpoint. Returns the HTTP status code, response time, and any errors. The request is rejected with a 400 if the webhook does not target the given environment, since a successful ping would say nothing about events it will never receive.
 * @summary Test webhook
 */
export const testWebhook = async (id: string,
    testWebhookBody?: TestWebhookBody, options?: RequestInit): Promise<testWebhookResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
const res = await fetch(getTestWebhookUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(testWebhookBody)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: testWebhookResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as testWebhookResponse
}


